import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { getRequest, postRequest } from "../../globalhelper/helper";
import emailData from "./emailData.json";
import emailData1 from "./emailData1.json";
import emailData2 from "./emailData2.json";
import emailData3 from "./emailData3.json";
import emailData4 from "./emailData4.json";
import emailData5 from "./emailData5.json";
import emailData6 from "./emailData6.json";
import emailData7 from "./emailData7.json";
import emailData8 from "./emailData8.json";
import emailData9 from "./emailData9.json";
import emailData10 from "./emailData10.json";
import emailData11 from "./emailData11.json";
import emailData12 from "./emailData12.json";
import emailData13 from "./emailData13.json";
import emailData14 from "./emailData14.json";
import emailData15 from "./emailData15.json";
import emailData16 from "./emailData16.json";
import emailData17 from "./emailData17.json";
import filesDetails from "./files-details.json";
import {
    Box,
    Typography,
    Stack,
    Chip,
    IconButton,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Drawer,
    TextField,
    Select,
    MenuItem,
    Menu,
    FormControl,
    InputLabel,
    LinearProgress,
    Tooltip,
    Avatar,
    Divider,
    Grid,
    CircularProgress,
    Card,
    CardHeader as MuiCardHeader,
    CardContent,
    AppBar,
    Toolbar,
    DialogActions
} from "@mui/material";
import {
    Close as CloseIcon,
    Download as DownloadIcon,
    ExpandMore as ExpandMoreIcon,
    ExpandLess as ExpandLessIcon,
    Mail as MailIcon,
    Chat as ChatIcon,
    NorthEast as NorthEastIcon,
    Dashboard as DashboardIcon,
    AccountBalance as AccountBalanceIcon,
    SwapHoriz as SwapHorizIcon,
    Link as LinkIcon,
    FactCheck as FactCheckIcon,
    Analytics as AnalyticsIcon,
    Insights as MonitoringIcon,
    Shield as ShieldIcon,
    Tune as TuneIcon,
    Warning as WarningIcon,
    VerifiedUser as VerifiedUserIcon,
    FilterList as FilterListIcon,
    Add as AddIcon,
    Error as ErrorIcon,
    AssignmentTurnedIn as AssignmentTurnedInIcon,
    Groups as GroupsIcon,
    HelpOutline as HelpOutlineIcon,
    CalendarMonth as CalendarMonthIcon,
    CheckCircle as CheckCircleIcon,
    RadioButtonUnchecked as RadioButtonUncheckedIcon,
    ReceiptLong as ReceiptLongIcon,
    Description as DescriptionIcon,
    Receipt as ReceiptIcon,
    Apartment as ApartmentIcon,
    ShoppingCart as ShoppingCartIcon,
    Sell as SellIcon,
    Warehouse as WarehouseIcon,
    Moving as MovingIcon,
    RequestQuote as RequestQuoteIcon,
    Assessment as AssessmentIcon,
    Verified as VerifiedIcon,
    Payments as PaymentsIcon,
    Handshake as HandshakeIcon,
    EventRepeat as EventRepeatIcon,
    AccountTree as AccountTreeIcon,
    Draw as DrawIcon,
    EditNote as EditNoteIcon,
    UploadFile as UploadFileIcon,
    LayersClear as LayersClearIcon,
    PlaylistAddCheck as PlaylistAddCheckIcon,
    RateReview as RateReviewIcon,
    Send as SendIcon,
    TrendingUp as TrendingUpIcon,
    Update as UpdateIcon,
    HistoryEdu as HistoryEduIcon,
    AccountBalanceWallet as AccountBalanceWalletIcon,
    FolderOpen as FolderOpenIcon,
    ImportExport as ImportExportIcon,
    Calculate as CalculateIcon,
    ReportProblem as ReportProblemIcon,
    MoreVert as MoreVertIcon,
    UnfoldMore as UnfoldMoreIcon,
    UnfoldLess as UnfoldLessIcon,
    CurrencyRupee as CurrencyRupeeIcon,
    Notifications as NotificationsIcon,
    Settings as SettingsIcon,
    AccountCircle as AccountCircleIcon,
    ArrowForward as ArrowForwardIcon,
    Search as SearchIcon
} from "@mui/icons-material";
import { showAlert } from "../../redux/Common/commonActions";
import store from "../../store";
import globalhelper from "../../helper/globalhelper";
/* â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
   HEAD INJECTION â€” Tailwind CDN + Fonts + Material Symbols + Theme config
   Runs once on mount so this file needs no companion index.html
â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
function useHeadAssets() {
    useEffect(() => {
        const inject = (tag, attrs) => {
            const key = attrs.src || attrs.href || attrs.id;
            if (key && document.querySelector(`[src="${key}"],[href="${key}"],[id="${key}"]`)) return;
            const el = document.createElement(tag);
            Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
            document.head.appendChild(el);
        };

        // Google Fonts
        inject("link", { rel: "preconnect", href: "https://fonts.googleapis.com" });
        inject("link", { rel: "preconnect", href: "https://fonts.gstatic.com", crossorigin: "" });
        inject("link", {
            href: "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=IBM+Plex+Sans:wght@500&display=swap",
            rel: "stylesheet",
        });

        // Custom scrollbar CSS
        if (!document.getElementById("cockpit-scrollbar-style")) {
            const style = document.createElement("style");
            style.id = "cockpit-scrollbar-style";
            style.textContent = `
        .custom-scrollbar::-webkit-scrollbar { width: 8px; height: 8px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: #f1f4f7; border-radius: 10px; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #c3c6d6; border-radius: 10px; border: 2px solid #f1f4f7; }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #737685; }
      `;
            document.head.appendChild(style);
        }
    }, []);
}

/* â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
   SHARED PRIMITIVE COMPONENTS
â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */

const IconMap = {
    dashboard: DashboardIcon,
    account_balance: AccountBalanceIcon,
    swap_horiz: SwapHorizIcon,
    link: LinkIcon,
    fact_check: FactCheckIcon,
    analytics: AnalyticsIcon,
    monitoring: MonitoringIcon,
    shield: ShieldIcon,
    tune: TuneIcon,
    warning: WarningIcon,
    verified_user: VerifiedUserIcon,
    filter_list: FilterListIcon,
    add: AddIcon,
    error: ErrorIcon,
    assignment_turned_in: AssignmentTurnedInIcon,
    groups: GroupsIcon,
    help_outline: HelpOutlineIcon,
    calendar_month: CalendarMonthIcon,
    close: CloseIcon,
    download: DownloadIcon,
    expand_more: ExpandMoreIcon,
    expand_less: ExpandLessIcon,
    north_east: NorthEastIcon,
    mail: MailIcon,
    chat: ChatIcon,
    check_circle: CheckCircleIcon,
    radio_button_unchecked: RadioButtonUncheckedIcon,
    receipt_long: ReceiptLongIcon,
    description: DescriptionIcon,
    receipt: ReceiptIcon,
    apartment: ApartmentIcon,
    shopping_cart: ShoppingCartIcon,
    sell: SellIcon,
    warehouse: WarehouseIcon,
    moving: MovingIcon,
    request_quote: RequestQuoteIcon,
    assessment: AssessmentIcon,
    verified: VerifiedIcon,
    payments: PaymentsIcon,
    handshake: HandshakeIcon,
    event_repeat: EventRepeatIcon,
    account_tree: AccountTreeIcon,
    draw: DrawIcon,
    edit_note: EditNoteIcon,
    upload_file: UploadFileIcon,
    layers_clear: LayersClearIcon,
    playlist_add_check: PlaylistAddCheckIcon,
    rate_review: RateReviewIcon,
    send: SendIcon,
    trending_up: TrendingUpIcon,
    update: UpdateIcon,
    history_edu: HistoryEduIcon,
    account_balance_wallet: AccountBalanceWalletIcon,
    folder_open: FolderOpenIcon,
    import_export: ImportExportIcon,
    calculate: CalculateIcon,
    report_problem: ReportProblemIcon,
    more_vert: MoreVertIcon,
    unfold_more: UnfoldMoreIcon,
    unfold_less: UnfoldLessIcon,
    currency_rupee: CurrencyRupeeIcon,
    notifications: NotificationsIcon,
    settings: SettingsIcon,
    account_circle: AccountCircleIcon,
    arrow_forward: ArrowForwardIcon,
    search: SearchIcon
};

function Icon({ name, sx = {}, ...props }) {
    const Component = IconMap[name];
    if (!Component) return null;
    return <Component sx={{ fontSize: "inherit", ...sx }} {...props} />;
}

function StatusBadge({ level }) {
    const colors = {
        critical: { bg: "#ffdad6", text: "#ba1a1a", label: "Critical" },
        attention: { bg: "#fff4e5", text: "#663d00", label: "Attention" },
        ok: { bg: "#e8f5e9", text: "#2e7d32", label: "Ok" },
    };
    const config = colors[level.toLowerCase()] ?? colors.critical;

    return (
        <Chip
            label={config.label}
            size="small"
            sx={{
                height: 18,
                fontSize: "9px",
                fontWeight: 700,
                backgroundColor: config.bg,
                color: config.text,
                borderRadius: "4px",
                "& .MuiChip-label": { px: 1 }
            }}
        />
    );
}

function IssueCounts({ noIssues, moderate, blocker, onNoIssueClick, onModerateClick, onBlockerClick }) {
    return (
        <Stack direction="row" spacing={0.5} mt={1} justifyContent="space-between">
            {[
                { label: "No issues", value: noIssues, color: "#2e7d32", hoverBg: "rgba(46, 125, 50, 0.08)", hoverBorder: "rgba(46, 125, 50, 0.3)", onClick: onNoIssueClick },
                { label: "Moderate issue", value: moderate, color: "#ed6c02", hoverBg: "rgba(237, 108, 2, 0.08)", hoverBorder: "rgba(237, 108, 2, 0.3)", onClick: onModerateClick },
                { label: "Close blocker", value: blocker, color: "#d32f2f", onClick: onBlockerClick, hoverBg: "rgba(211, 47, 47, 0.08)", hoverBorder: "rgba(211, 47, 47, 0.3)" }
            ].map((item, idx) => (
                <Box
                    key={idx}
                    onClick={(e) => {
                        if (item.onClick) {
                            e.stopPropagation();
                            item.onClick();
                        }
                    }}
                    sx={{
                        flex: 1,
                        minWidth: 64,
                        border: "1px solid rgba(195, 198, 214, 0.3)",
                        borderRadius: "4px",
                        py: 0.5,
                        px: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        cursor: "pointer",
                        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                        backgroundColor: "#ffffff",
                        "&:hover": {
                            backgroundColor: item.hoverBg,
                            borderColor: item.hoverBorder,
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                            transform: "translateY(-1px)"
                        },
                        "&:active": { transform: "scale(0.95)" }
                    }}
                >
                    <Typography sx={{ fontSize: "8px", color: "#737685", letterSpacing: "-0.02em", whiteSpace: "break-spaces", fontWeight: 700 }}>
                        {item.label}
                    </Typography>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: item.color, fontFamily: "'IBM Plex Sans', monospace", lineHeight: 1, mt: 0.25 }}>
                        {item.value}
                    </Typography>
                </Box>
            ))}
        </Stack>
    );
}

function ModuleRow({ icon, label, status, noIssues, moderate, blocker, onNoIssueClick, onModerateClick, onBlockerClick }) {
    return (
        <Paper elevation={0} sx={{ p: 1, backgroundColor: "#f1f4f7", borderRadius: "8px" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 0.5, gap: 0.5 }}>
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    {icon && <Icon name={icon} sx={{ fontSize: "16px", mr: 0.5 }} />}
                    <Typography sx={{ fontWeight: 700, fontSize: "9.5px", lineHeight: 1.2, maxWidth: 180 }}>
                        {label}
                    </Typography>
                    <Icon name="expand_more" sx={{ fontSize: "16px", color: "#737685", cursor: "pointer" }} />
                </Stack>
                <StatusBadge level={status} />
            </Box>
            <IssueCounts noIssues={noIssues} moderate={moderate} blocker={blocker} onNoIssueClick={onNoIssueClick} onModerateClick={onModerateClick} onBlockerClick={onBlockerClick} />
        </Paper>
    );
}

function ModuleRowInline({ icon, label, status, noIssues, moderate, blocker, onNoIssueClick, onModerateClick, onBlockerClick }) {
    return (
        <Paper elevation={0} sx={{ p: 1, backgroundColor: "#f1f4f7", borderRadius: "8px" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 0.5, gap: 0.5 }}>
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    {icon && <Icon name={icon} sx={{ fontSize: "16px", mr: 0.5 }} />}
                    <Typography sx={{ fontWeight: 700, fontSize: "9.5px", lineHeight: 1.2, maxWidth: 180 }}>
                        {label}
                    </Typography>
                    <Icon name="expand_more" sx={{ fontSize: "16px", color: "#737685", cursor: "pointer" }} />
                </Stack>
                <StatusBadge level={status} />
            </Box>
            <IssueCounts noIssues={noIssues} moderate={moderate} blocker={blocker} onNoIssueClick={onNoIssueClick} onModerateClick={onModerateClick} onBlockerClick={onBlockerClick} />
        </Paper>
    );
}

function injectTailwindConfig() {
    if (!window.tailwind) return;
    window.tailwind.config = {
        darkMode: "class",
        theme: {
            extend: {
                colors: {
                    "inverse-on-surface": "#eef1f4",
                    "tertiary-container": "#006847",
                    "on-surface": "#181c1e",
                    "secondary-container": "#d5e0f7",
                    "on-primary-fixed-variant": "#0040a2",
                    "surface-bright": "#f7fafd",
                    "error-container": "#ffdad6",
                    "surface-container-lowest": "#ffffff",
                    "surface-container-high": "#e5e8eb",
                    "on-tertiary-fixed": "#002114",
                    "on-secondary-fixed-variant": "#3c475a",
                    surface: "#f7fafd",
                    "primary-fixed": "#dae2ff",
                    "on-surface-variant": "#434654",
                    "on-primary-fixed": "#001848",
                    "secondary-fixed": "#d8e3fa",
                    "on-secondary-container": "#586377",
                    error: "#ba1a1a",
                    "primary-container": "#0052cc",
                    "inverse-surface": "#2d3133",
                    "on-primary": "#ffffff",
                    "secondary-fixed-dim": "#bcc7dd",
                    background: "#f7fafd",
                    "tertiary-fixed-dim": "#68dba9",
                    "surface-container-highest": "#e0e3e6",
                    "surface-dim": "#d7dadd",
                    "tertiary-fixed": "#85f8c4",
                    "on-error": "#ffffff",
                    "on-background": "#181c1e",
                    "surface-container-low": "#f1f4f7",
                    "on-tertiary": "#ffffff",
                    "on-secondary-fixed": "#111c2c",
                    tertiary: "#004e34",
                    "on-tertiary-container": "#75e8b5",
                    "surface-container": "#ebeef1",
                    secondary: "#545f72",
                    "outline-variant": "#c3c6d6",
                    "on-tertiary-fixed-variant": "#005137",
                    "primary-fixed-dim": "#b2c5ff",
                    "on-secondary": "#ffffff",
                    "on-error-container": "#93000a",
                    primary: "#003d9b",
                    outline: "#737685",
                    "on-primary-container": "#c4d2ff",
                    "surface-variant": "#e0e3e6",
                    "inverse-primary": "#b2c5ff",
                    "surface-tint": "#0c56d0",
                },
                borderRadius: {
                    DEFAULT: "0.25rem",
                    lg: "0.5rem",
                    xl: "0.75rem",
                    full: "9999px",
                },
                spacing: {
                    margin: "24px",
                    lg: "24px",
                    gutter: "16px",
                    xl: "32px",
                    md: "16px",
                    sm: "8px",
                    "container-max": "1440px",
                    base: "4px",
                    xs: "4px",
                },
                fontFamily: {
                    "headline-md": ["Inter"],
                    "body-md": ["Inter"],
                    "display-lg": ["Inter"],
                    "data-mono": ["IBM Plex Sans"],
                    "title-sm": ["Inter"],
                    "label-caps": ["Inter"],
                    "body-sm": ["Inter"],
                },
                fontSize: {
                    "headline-md": ["24px", { lineHeight: "32px", fontWeight: "600" }],
                    "body-md": ["14px", { lineHeight: "20px", fontWeight: "400" }],
                    "display-lg": ["32px", { lineHeight: "40px", letterSpacing: "-0.02em", fontWeight: "700" }],
                    "data-mono": ["13px", { lineHeight: "18px", letterSpacing: "0.01em", fontWeight: "500" }],
                    "title-sm": ["18px", { lineHeight: "24px", fontWeight: "600" }],
                    "label-caps": ["11px", { lineHeight: "16px", letterSpacing: "0.05em", fontWeight: "700" }],
                    "body-sm": ["13px", { lineHeight: "18px", fontWeight: "400" }],
                },
            },
        },
    };
}

/** Drilldown Modal Component (Level 1) */
function DrilldownModal({ isOpen, onClose, title, data, onDownload }) {
    if (!isOpen) return null;

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: "12px",
                    overflow: "hidden",
                    backgroundColor: "#ffffff"
                }
            }}
        >
            <Box sx={{ backgroundColor: "#003d9b", p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography sx={{ color: "#ffffff", fontSize: "18px", fontWeight: 700 }}>
                    {title} â€“ drilldown
                </Typography>
                <IconButton onClick={onClose} sx={{ color: "#ffffff", p: 0, "&:hover": { opacity: 0.7 } }}>
                    <Icon name="close" sx={{ fontSize: "24px" }} />
                </IconButton>
            </Box>
            <DialogContent sx={{ p: 2 }}>
                <TableContainer component={Box}>
                    <Table size="small">
                        <TableHead>
                            <TableRow sx={{ borderBottom: "1px solid #c3c6d6" }}>
                                <TableCell sx={{ py: 1, fontSize: "11px", fontWeight: 700, color: "#737685", border: "none" }}>Metric</TableCell>
                                <TableCell align="right" sx={{ py: 1, fontSize: "11px", fontWeight: 700, color: "#737685", border: "none" }}>Value</TableCell>
                                <TableCell align="center" sx={{ py: 1, fontSize: "11px", fontWeight: 700, color: "#737685", border: "none" }}>Drill</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.rows.map((row, i) => (
                                <TableRow
                                    key={i}
                                    onClick={() => row.hasDrill && row.onDrill && row.onDrill()}
                                    sx={{
                                        borderBottom: "1px solid rgba(195, 198, 214, 0.5)",
                                        cursor: row.hasDrill && row.onDrill ? "pointer" : "default",
                                        "&:hover": row.hasDrill && row.onDrill ? { backgroundColor: "#f1f4f7" } : {}
                                    }}
                                >
                                    <TableCell sx={{ py: 1.25, fontSize: "13px", color: "#181c1e", lineHeight: 1.2, border: "none" }}>{row.metric}</TableCell>
                                    <TableCell align="right" sx={{ py: 1.25, fontSize: "13px", fontWeight: 700, color: row.isError ? "#ba1a1a" : "#181c1e", fontFamily: "'IBM Plex Sans', monospace", border: "none" }}>{row.value}</TableCell>
                                    <TableCell align="center" sx={{ py: 1.25, border: "none" }}>
                                        {row.hasDrill ? (
                                            <Icon
                                                name="north_east"
                                                sx={{
                                                    fontSize: "16px",
                                                    color: "#003d9b",
                                                    transition: "transform 0.2s",
                                                    "&:hover": { transform: "scale(1.1)" }
                                                }}
                                            />
                                        ) : null}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <TableRow sx={{ backgroundColor: "rgba(0, 61, 155, 0.05)" }}>
                            <TableCell sx={{ py: 1.5, px: 1, fontWeight: 700, color: "#003d9b", border: "none" }}>{data.footer.label}</TableCell>
                            <TableCell align="right" sx={{ py: 1.5, fontWeight: 700, color: "#003d9b", fontFamily: "'IBM Plex Sans', monospace", border: "none" }}>{data.footer.value}</TableCell>
                            <TableCell align="center" sx={{ py: 1.5, fontSize: "10px", fontWeight: 700, color: "#003d9b", border: "none" }}>{data.footer.subText}</TableCell>
                        </TableRow>
                    </Table>
                </TableContainer>
                <Stack direction="row" spacing={1.5} mt={3}>
                    <Button
                        fullWidth
                        variant="contained"
                        disabled={!data.onViewDetailedReport}
                        onClick={() => data.onViewDetailedReport && data.onViewDetailedReport()}
                        sx={{
                            backgroundColor: "#003d9b",
                            color: "#ffffff",
                            borderRadius: "8px",
                            fontSize: "11px",
                            fontWeight: 700,
                            letterSpacing: "0.05em",
                            py: 1.25,
                            "&:disabled": {
                                backgroundColor: "rgba(0, 61, 155, 0.3)",
                                color: "rgba(255, 255, 255, 0.7)"
                            },
                            "&.Mui-disabled": {
                                backgroundColor: "rgba(0, 61, 155, 0.3)",
                                color: "rgba(255, 255, 255, 0.7)"
                            },
                            "&:hover": { backgroundColor: "#003d9b", opacity: 0.9 }
                        }}
                    >
                        View reported file
                    </Button>
                    <Button
                        variant="outlined"
                        onClick={onDownload}
                        sx={{
                            minWidth: "auto",
                            px: 2,
                            borderColor: "#c3c6d6",
                            color: "#181c1e",
                            borderRadius: "8px",
                            "&:hover": { borderColor: "#c3c6d6", backgroundColor: "#e5e8eb" }
                        }}
                    >
                        <Icon name="download" sx={{ fontSize: "20px" }} />
                    </Button>
                </Stack>
            </DialogContent>
        </Dialog>
    );
}

const CONTEXT_ID_MAP = {
    "billing pending count": "2604-IF-AB-BPC",
    "billing pending value": "2604-IF-AB-BPV",
    "billing exception count": "2604-IF-AB-BEC",
    "sla breach count": "2604-IF-AB-SBC",
    "ap booking pending count": "2604-IF-AB-ABPC",
    "ap booking pending value": "2604-IF-AB-ABPV",
    "ar vs ap value mismatch count": "2604-IF-AB-AAVMC",
    "document reference missing count": "2604-IF-AB-DRMC",
    "settlement pending count": "2604-IF-SOA-SPC",
    "settlement pending value": "2604-IF-SOA-SPV",
    "settlement overdue count": "2604-IF-SOA-SOC",
    "ar vs ap settlement mismatch count": "2604-IF-SOA-AASMC",
    "cash application pending count": "2604-IF-CA-CAPC",
    "cash application pending value": "2604-IF-CA-CAPV",
    "unapplied cash count": "2604-IF-CA-UCC",
    "bank receipt not matched count": "2604-IF-CA-BRNMC",
    "confirmation not received count": "2604-IF-ACR-CNRC",
    "balance difference count": "2604-IF-ACR-BDC",
    "balance difference value": "2604-IF-ACR-BDV",
    "confirmation sla breach count": "2604-IF-ACR-CSBC",
    "ar reconciliation pending count": "2604-IF-ARCR-ARPC",
    "ar vs counterparty balance difference count": "2604-IF-ARCR-ACBDC",
    "ar vs counterparty balance difference value": "2604-IF-ARCR-ACBDV",
    "ageing above 60 days count": "2604-IF-ARC-AA60DC",
    "advance / receivable confirmation pending count": "2604-IF-ARC-ARCPC",
    "advance / receivable balance pending value": "2604-IF-ARC-ARBPV",
    "confirmation difference count": "2604-IF-ARC-CDC",
    "unposted journal count": "2604-CF-GL-UJC",
    "open journal count": "2604-CF-GL-OJC",
    "suspense balance value": "2604-CF-GL-SBV",
    "trial balance difference value": "2604-CF-GL-TBDV",
    "backdated posting count": "2604-CF-GL-BPC",
    "reversal pending count": "2604-CF-GL-RPC",
    "open invoice count": "2604-TF-OTC-OIC",
    "blocked invoice count": "2604-CF-AP-BIC",
    "due / overdue payable value": "2604-CF-AP-DOPV",
    "GR/IR pending value": "2604-CF-AP-GPV",
    "vendor advance unadjusted value": "2604-TF-PTP-VAUV",
    "duplicate invoice risk count": "2604-CF-AP-DIRC",
    "overdue invoice count": "2604-CF-AR-OIC",
    "overdue ar value": "2604-CF-AR-OARV",
    "collection pending value": "2604-CF-AR-CPV",
    "billing block count": "2604-TF-OTC-BBC",
    "unapplied receipt count": "2604-CF-AR-URC",
    "customer dispute count": "2604-CF-AR-CDC",
    "pending capitalization count": "2604-CF-FA-PCC",
    "pending capitalization": "2604-CF-FA-PCC",
    "depreciation not ready count": "2604-CF-FA-DNRC",
    "depreciation not ready": "2604-CF-FA-DNRC",
    "retirement pending count": "2604-CF-FA-RPC",
    "retirement pending": "2604-CF-FA-RPC",
    "asset addition not tagged count": "2604-CF-FA-AANTC",
    "asset addition not tagged": "2604-CF-FA-AANTC",
    "cwip ageing above threshold value": "2604-CF-FA-CAATV",
    "cwip ageing above threshold": "2604-CF-FA-CAATV",
    "bank reconciliation pending count": "2604-CF-BC-BRPC",
    "unmatched bank transaction count": "2604-CF-BC-UBTC",
    "unmatched bank transaction value": "2604-CF-BC-UBTV",
    "book vs bank balance difference value": "2604-CF-BC-BBBDV",
    "open payment / receipt clearing count": "2604-CF-BC-OPRCC",
    "master data error count": "2604-GAC-MCR-MDEC",
    "coa pending change count": "2604-GAC-MCR-CPCC",
    "coa readiness gap count": "2604-GAC-MCR-CRGC",
    "ap subledger close pending count": "2604-GAC-SC-ASCPC",
    "ar subledger close pending count": "2604-GAC-SC-RSCPC",
    "subledger vs gl difference value": "2604-GAC-SC-SGDV",
    "allocation run pending count": "2604-GAC-AL-ARPC",
    "allocation error count": "2604-GAC-AL-AEC",
    "allocation pending value": "2604-GAC-AL-APV",
    "revenue feed exception count": "2604-GAC-RR-RFEC",
    "revenue accrual pending value": "2604-GAC-RR-RAPV",
    "deferred revenue difference value": "2604-GAC-RR-DRDV",
    "accrual jv pending count": "2604-GAC-AJ-AJPC",
    "accrual jv pending value": "2604-GAC-AJ-AJPV",
    "accrual reversal pending count": "2604-GAC-AJ-ARPC",
    "provision jv pending count": "2604-GAC-PJ-PJPC",
    "provision pending value": "2604-GAC-PJ-PPV",
    "provision approval pending count": "2604-GAC-PJ-PAPC",
    "tax provision jv pending count": "2604-TC-TP-TPJPC",
    "tax provision pending value": "2604-TC-TP-TPPV",
    "tax review exception count": "2604-TC-TP-TREC",
    "manual allocation pending count": "2604-GAC-MA-MAPC",
    "manual allocation approval pending count": "2604-GAC-MA-MAAPC",
    "manual allocation exception count": "2604-GAC-MA-MAEC",
    "reclass pending count": "2604-GAC-RRà¶¢-RPC",
    "recharge pending count": "2604-GAC-RRà¶¢-RGPC",
    "reclass / recharge approval pending count": "2604-GAC-RRà¶¢-RRAPC",
    "other jv pending count": "2604-GAC-OMJ-OJPC",
    "high risk jv count": "2604-GAC-OMJ-HRJC",
    "jv approval pending count": "2604-GAC-OMJ-JAPC",
    "p&l preparation pending count": "2604-GAC-PLP-PPPPC",
    "p&l variance count": "2604-GAC-PLP-PLVC",
    "adjustment pending count": "2604-GAC-PLP-APC",
    "p&l review pending count": "2604-GAC-PLR-PRPC",
    "review comment open count": "2604-FP-PLBR-RCOC",
    "unresolved variance count": "2604-GAC-PLR-UVC",
    "close task pending count": "2604-GAC-MECM-CTPC",
    "close task sla breach count": "2604-GAC-MECM-CTSBC",
    "critical open item count": "2604-GAC-MECM-COIC",
    "3-way match exception count": "2604-TF-PTP-3WMEC",
    "GR/IR open value": "2604-TF-PTP-GIOV",
    "po pending count": "2604-TF-PTP-PPPC",
    "invoice blocked count": "2604-TF-PTP-IBC",
    "unbilled revenue count": "2604-TF-OTC-URC",
    "delivery not billed count": "2604-TF-OTC-DNBC",
    "revenue recognition exception count": "2604-TF-OTC-RREC",
    "inventory value exception count": "2604-TF-IA-SVDV",
    "mm-fi difference value": "2604-TF-IA-MFDV",
    "negative stock count": "2604-TF-IA-NSC",
    "gr/ir ageing above threshold count": "2604-TF-IA-GAATC",
    "stock valuation difference value": "2604-TF-IA-SVDV",
    "non-moving / obsolete review": "2604-TF-IA-NMOR",
    "slow moving": "2604-TF-IA-SM",
    "pending capitalization": "2604-CF-FA-PCC",
    "depreciation not ready": "2604-CF-FA-DNRC",
    "retirement pending": "2604-CF-FA-RPC",
    "asset addition not tagged": "2604-CF-FA-AANTC",
    "cwip ageing above threshold": "2604-CF-FA-CAATV",
    "gr/ir ageing above threshold": "2604-TF-IA-GAATC",
    "opening balance (stock vs. tb)": "2604-TF-IA-OPST",
    "closing balance (stock vs. tb)": "2604-TF-IA-CBST",
    "payroll validation pending count": "2604-TF-PR-PVPC",
    "payroll posting exception count": "2604-TF-PR-PPEC",
    "payroll cost variance value": "2604-TF-PR-PCVV",
    "employee master mismatch count": "2604-TF-PR-EMMC",
    "payroll accrual pending count": "2604-TF-PR-PAPC",
    "report pending count": "2604-RC-PCR-RPC",
    "report delay count": "2604-RC-PCR-RDC",
    "report sign-off pending count": "2604-RC-PCR-RSPC",
    "financial analysis pending count": "2604-RC-PCFA-FAPC",
    "variance explanation pending count": "2604-RC-PCFA-VEPC",
    "material variance value": "2604-RC-PCFA-MVV",
    "balance sheet schedule pending count": "2604-RC-BSNS-BSSPC",
    "balance reconciliation difference value": "2604-RC-BSNS-BRDV",
    "supporting evidence pending count": "2604-RC-BSNS-SEPC",
    "control checklist pending count": "2604-RC-ICC-CCPC",
    "control exception count": "2604-RC-ICC-CEC",
    "control sign-off pending count": "2604-RC-ICC-CSPC",
    "package preparation pending count": "2604-RC-CPPU-PPPC",
    "package upload pending count": "2604-RC-CPPU-PUPC",
    "upload error count": "2604-RC-CPPU-UEC",
    "correction entry pending count": "2604-RC-CPC-CEPC",
    "resubmission pending count": "2604-RC-CPC-RSPC",
    "correction value": "2604-RC-CPC-CV",
    "gaap adjustment pending count": "2604-RC-GAETE-GAPC",
    "elimination entry pending count": "2604-RC-GAETE-EEPC",
    "top-side entry pending count": "2604-RC-GAETE-TSEPC",
    "final sign-off pending count": "2604-FP-FBFS-FSPC",
    "certification exception count": "2604-RC-MSC-CEC",
    "revenue budget input pending count": "2604-FP-RBP-RBIPC",
    "revenue budget draft pending count": "2604-FP-RBP-RBDPC",
    "revenue assumption gap count": "2604-FP-RBP-RAGC",
    "revenue budget review pending count": "2604-FP-RBR-RBRPC",
    "revenue budget approval pending count": "2604-FP-RBR-RBAPC",
    "revenue budget variance %": "2604-FP-RBR-RBVP",
    "cost input pending count": "2604-FP-PLBP-CIPC",
    "revenue input pending count": "2604-FP-PLBP-RIPC",
    "budget version pending count": "2604-FP-PLBP-BVPC",
    "p&l budget review pending count": "2604-FP-PLBR-PBRPC",
    "p&l budget variance %": "2604-FP-PLBR-PBVP",
    "submission pending count": "2604-FP-PLBS-SPC",
    "rejected submission count": "2604-FP-PLBS-RSC",
    "final approval pending count": "2604-FP-PLBS-FAPC",
    "revenue reforecast pending count": "2604-FP-RRF-RRPC",
    "revenue forecast variance value": "2604-FP-RRF-RFVV",
    "forecast accuracy gap %": "2604-FP-RRF-FAGP",
    "p&l reforecast pending count": "2604-FP-PLRF-PRPC",
    "p&l forecast variance value": "2604-FP-PLRF-PFVV",
    "margin variance %": "2604-FP-PLRF-MVP",
    "sign-off exception count": "2604-FP-FBFS-SEC",
    "cost allocation variance count": "2604-PC-CA-CAVC",
    "unallocated cost value": "2604-PC-CA-UCV",
    "review pending count": "2604-PC-CA-RPC",
    "cost center mapping error count": "2604-PC-CA-CCMEC",
    "cost absorption difference value": "2604-PC-CA-CADV",
    "profit center alert count": "2604-PC-PCA-PCAC",
    "loss center count": "2604-PC-PCA-LCC",
    "margin deviation %": "2604-PC-PCA-MDP",
    "profit center mapping missing count": "2604-PC-PCA-PCMMC",
    "intercompany profit elimination difference value": "2604-PC-PCA-IPEDV",
    "mis pack pending count": "2604-PC-FPAB-MPPC",
    "action open count": "2604-PC-FPAB-AOC",
    "plan vs actual gap %": "2604-PC-FPAB-PVAGP",
    "benchmark variance count": "2604-PC-FPAB-BVC",
    "management review pending count": "2604-PC-FPAB-MRPC",
    "anomaly detected count": "2604-IR-AD-ADC",
    "critical anomaly count": "2604-IR-AD-CAC",
    "high-value anomaly amount": "2604-IR-AD-HVAA",
    "duplicate transaction risk count": "2604-IR-AD-DTRC",
    "unusual posting pattern count": "2604-IR-AD-UPPC",
    "recovery opportunity count": "2604-IR-FR-ROC",
    "recovery opportunity value": "2604-IR-FR-ROV",
    "recovery action pending count": "2604-IR-FR-RAPC",
    "realization gap value": "2604-IR-FR-RGV",
    "recovery sla breach count": "2604-IR-FR-RSBC",
    "manual touch count": "2604-IR-AT-MTC",
    "unauthorized change count": "2604-IR-AT-UCC",
    "missing approval trail count": "2604-IR-AT-MATC",
    "backdated change count": "2604-IR-AT-BCC",
    "critical audit exception count": "2604-IR-AT-CAEC",
    "gst return pending count": "2604-TC-GSTC-GRPC",
    "gst filing delay count": "2604-TC-GSTC-GFDC",
    "gst input credit mismatch value": "2604-TC-GSTC-GICMV",
    "gst liability reconciliation difference value": "2604-TC-GSTC-GLRDV",
    "e-invoice generation failure count": "2604-TC-GSTC-EIGFC",
    "gst payment pending value": "2604-TC-GSTC-GPPV",
    "tds deduction error count": "2604-TC-TDSC-TDEC",
    "tds return pending count": "2604-TC-TDSC-TRPC",
    "tds payment delay count": "2604-TC-TDSC-TPDC",
    "tds certificate pending count": "2604-TC-TDSC-TCPC",
    "tds vendor pan error count": "2604-TC-TDSC-TVPEC",
    "tds reconciliation difference value": "2604-TC-TDSC-TRDV",
    "deferred tax calculation pending count": "2604-TC-TP-DTCPC",
    "tax accrual reversal pending count": "2604-TC-TP-TARPC",
    "effective tax rate variance %": "2604-TC-TP-ETRVP",
    "statutory return pending count": "2604-TC-SR-SRPC",
    "statutory filing sla breach count": "2604-TC-SR-SFSBC",
    "regulatory notice open count": "2604-TC-SR-RNOC",
    "compliance calendar missed count": "2604-TC-SR-CCMC",
    "return approval pending count": "2604-TC-SR-RAPC",
    "late filing penalty value": "2604-TC-SR-LFPV",
    "audit query open count": "2604-TC-AS-AQOC",
    "audit evidence pending count": "2604-TC-AS-AEPC",
    "audit observation open count": "2604-TC-AS-AOOC",
    "management response pending count": "2604-TC-AS-MRPC",
    "repeat audit finding count": "2604-TC-AS-RAFC",
    "audit closure pending count": "2604-TC-AS-ACPC",
    "transfer pricing adjustment value": "2604-TC-TPR-TPAV",
    "intercompany pricing variance count": "2604-TC-TPR-IPVC",
    "transfer pricing documentation pending count": "2604-TC-TPR-TPDPC",
    "armâ€™s length margin deviation %": "2604-TC-TPR-ALMDP",
    "transfer pricing review pending count": "2604-TC-TPR-TPRPC",
    "cross-border transaction exception count": "2604-TC-TPR-CBTEC",
    "capitalisation issue": "2604-TF-IA-CI",
    "service confirmation pending": "2604-TF-CSRO-SCB",
    "crm billing vs fi revenue mismatch": "2604-TF-CSRO-CFRM",
    "deferred revenue mismatch": "2604-TF-CSRO-DRB",
    "retrofit wip not settled": "2604-TF-CSRO-RWB",
    "spare consumption not linked": "2604-TF-CSRO-SCBL",
    "spare consumption not linked ": "2604-TF-CSRO-SCBL"
};

const getContextId = (title) => {
    if (!title) return "CON-GEN-001";
    return CONTEXT_ID_MAP[title.toLowerCase()] || "CON-GEN-001";
};

/** Chat Section Component (can be drawer or partition) */
function ChatSection({ isOpen, onClose, isEmbedded = false, subTitle = "", parentTitle = "", additionalMessages = [] }) {
    const [expandedIndex, setExpandedIndex] = useState(null);
    const messagesEndRef = React.useRef(null);


    const checkTitle = (t) => t?.toLowerCase() || "";
    const pTitle = checkTitle(parentTitle);
    const sTitle = checkTitle(subTitle);

    if (pTitle.includes("closing balance") || sTitle.includes("closing balance")) {
        baseEmailData = emailData2;
    } else if (pTitle.includes("opening balance") || sTitle.includes("opening balance")) {
        baseEmailData = emailData3;
    } else if (pTitle.includes("gr/ir ageing") || sTitle.includes("gr/ir ageing")) {
        baseEmailData = emailData4;
    } else if (pTitle.includes("inventory value exception count") || sTitle.includes("inventory value exception count")) {
        baseEmailData = emailData5;
    } else if (pTitle.includes("non-moving") || sTitle.includes("non-moving") || pTitle.includes("obsolete") || sTitle.includes("obsolete")) {
        baseEmailData = emailData6;
    } else if (pTitle.includes("asset addition not tagged") || sTitle.includes("asset addition not tagged")) {
        baseEmailData = emailData7;
    } else if (pTitle.includes("cwip ageing above threshold") || sTitle.includes("cwip ageing above threshold")) {
        baseEmailData = emailData8;
    } else if (pTitle.includes("depreciation not ready") || sTitle.includes("depreciation not ready")) {
        baseEmailData = emailData9;
    } else if (pTitle.includes("retirement pending") || sTitle.includes("retirement pending")) {
        baseEmailData = emailData10;
    } else if (pTitle.includes("pending capitalization") || sTitle.includes("pending capitalization")) {
        baseEmailData = emailData11;
    } else if (pTitle.includes("capitalisation issue") || sTitle.includes("capitalisation issue")) {
        baseEmailData = emailData12;
    } else if (pTitle.includes("crm billing vs fi revenue mismatch") || sTitle.includes("crm billing vs fi revenue mismatch")) {
        baseEmailData = emailData13;
    } else if (pTitle.includes("deferred revenue mismatch") || sTitle.includes("deferred revenue mismatch")) {
        baseEmailData = emailData14;
    } else if (pTitle.includes("retrofit wip not settled") || sTitle.includes("retrofit wip not settled")) {
        baseEmailData = emailData15;
    } else if (pTitle.includes("service confirmation pending") || sTitle.includes("service confirmation pending")) {
        baseEmailData = emailData16;
    } else if (pTitle.includes("spare consumption not linked") || sTitle.includes("spare consumption not linked")) {
        baseEmailData = emailData17;
    }

    const finalEmailData = React.useMemo(() => {
        return [...baseEmailData, ...additionalMessages];
    }, [baseEmailData, additionalMessages]);

    React.useEffect(() => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [finalEmailData.length, isOpen, isEmbedded]);

    const CONTEXT_ID_MAP = {
        "billing pending count": "2604-IF-AB-BPC",
        "billing pending value": "2604-IF-AB-BPV",
        "billing exception count": "2604-IF-AB-BEC",
        "sla breach count": "2604-IF-AB-SBC",
        "ap booking pending count": "2604-IF-AB-ABPC",
        "ap booking pending value": "2604-IF-AB-ABPV",
        "ar vs ap value mismatch count": "2604-IF-AB-AAVMC",
        "document reference missing count": "2604-IF-AB-DRMC",
        "settlement pending count": "2604-IF-SOA-SPC",
        "settlement pending value": "2604-IF-SOA-SPV",
        "settlement overdue count": "2604-IF-SOA-SOC",
        "ar vs ap settlement mismatch count": "2604-IF-SOA-AASMC",
        "cash application pending count": "2604-IF-CA-CAPC",
        "cash application pending value": "2604-IF-CA-CAPV",
        "unapplied cash count": "2604-IF-CA-UCC",
        "bank receipt not matched count": "2604-IF-CA-BRNMC",
        "confirmation not received count": "2604-IF-ACR-CNRC",
        "balance difference count": "2604-IF-ACR-BDC",
        "balance difference value": "2604-IF-ACR-BDV",
        "confirmation sla breach count": "2604-IF-ACR-CSBC",
        "ar reconciliation pending count": "2604-IF-ARCR-ARPC",
        "ar vs counterparty balance difference count": "2604-IF-ARCR-ACBDC",
        "ar vs counterparty balance difference value": "2604-IF-ARCR-ACBDV",
        "ageing above 60 days count": "2604-IF-ARC-AA60DC",
        "advance / receivable confirmation pending count": "2604-IF-ARC-ARCPC",
        "advance / receivable balance pending value": "2604-IF-ARC-ARBPV",
        "confirmation difference count": "2604-IF-ARC-CDC",
        "unposted journal count": "2604-CF-GL-UJC",
        "open journal count": "2604-CF-GL-OJC",
        "suspense balance value": "2604-CF-GL-SBV",
        "trial balance difference value": "2604-CF-GL-TBDV",
        "backdated posting count": "2604-CF-GL-BPC",
        "reversal pending count": "2604-CF-GL-RPC",
        "open invoice count": "2604-TF-OTC-OIC",
        "blocked invoice count": "2604-CF-AP-BIC",
        "due / overdue payable value": "2604-CF-AP-DOPV",
        "gr/ir pending value": "2604-CF-AP-GPV",
        "vendor advance unadjusted value": "2604-TF-PTP-VAUV",
        "duplicate invoice risk count": "2604-CF-AP-DIRC",
        "overdue invoice count": "2604-CF-AR-OIC",
        "overdue ar value": "2604-CF-AR-OARV",
        "collection pending value": "2604-CF-AR-CPV",
        "billing block count": "2604-TF-OTC-BBC",
        "unapplied receipt count": "2604-CF-AR-URC",
        "customer dispute count": "2604-CF-AR-CDC",
        "pending capitalization count": "2604-CF-FA-PCC",
        "depreciation not ready count": "2604-CF-FA-DNRC",
        "retirement pending count": "2604-CF-FA-RPC",
        "asset addition not tagged count": "2604-CF-FA-AANTC",
        "cwip ageing above threshold value": "2604-CF-FA-CAATV",
        "bank reconciliation pending count": "2604-CF-BC-BRPC",
        "unmatched bank transaction count": "2604-CF-BC-UBTC",
        "unmatched bank transaction value": "2604-CF-BC-UBTV",
        "book vs bank balance difference value": "2604-CF-BC-BBBDV",
        "open payment / receipt clearing count": "2604-CF-BC-OPRCC",
        "master data error count": "2604-GAC-MCR-MDEC",
        "coa pending change count": "2604-GAC-MCR-CPCC",
        "coa readiness gap count": "2604-GAC-MCR-CRGC",
        "ap subledger close pending count": "2604-GAC-SC-ASCPC",
        "ar subledger close pending count": "2604-GAC-SC-RSCPC",
        "subledger vs gl difference value": "2604-GAC-SC-SGDV",
        "allocation run pending count": "2604-GAC-AL-ARPC",
        "allocation error count": "2604-GAC-AL-AEC",
        "allocation pending value": "2604-GAC-AL-APV",
        "revenue feed exception count": "2604-GAC-RR-RFEC",
        "revenue accrual pending value": "2604-GAC-RR-RAPV",
        "deferred revenue difference value": "2604-GAC-RR-DRDV",
        "accrual jv pending count": "2604-GAC-AJ-AJPC",
        "accrual jv pending value": "2604-GAC-AJ-AJPV",
        "accrual reversal pending count": "2604-GAC-AJ-ARPC",
        "provision jv pending count": "2604-GAC-PJ-PJPC",
        "provision pending value": "2604-GAC-PJ-PPV",
        "provision approval pending count": "2604-GAC-PJ-PAPC",
        "tax provision jv pending count": "2604-TC-TP-TPJPC",
        "tax provision pending value": "2604-TC-TP-TPPV",
        "tax review exception count": "2604-TC-TP-TREC",
        "manual allocation pending count": "2604-GAC-MA-MAPC",
        "manual allocation approval pending count": "2604-GAC-MA-MAAPC",
        "manual allocation exception count": "2604-GAC-MA-MAEC",
        "reclass pending count": "2604-GAC-RRà¶¢-RPC",
        "recharge pending count": "2604-GAC-RRà¶¢-RGPC",
        "reclass / recharge approval pending count": "2604-GAC-RRà¶¢-RRAPC",
        "other jv pending count": "2604-GAC-OMJ-OJPC",
        "high risk jv count": "2604-GAC-OMJ-HRJC",
        "jv approval pending count": "2604-GAC-OMJ-JAPC",
        "p&l preparation pending count": "2604-GAC-PLP-PPPPC",
        "p&l variance count": "2604-GAC-PLP-PLVC",
        "adjustment pending count": "2604-GAC-PLP-APC",
        "p&l review pending count": "2604-GAC-PLR-PRPC",
        "review comment open count": "2604-FP-PLBR-RCOC",
        "unresolved variance count": "2604-GAC-PLR-UVC",
        "close task pending count": "2604-GAC-MECM-CTPC",
        "close task sla breach count": "2604-GAC-MECM-CTSBC",
        "critical open item count": "2604-GAC-MECM-COIC",
        "3-way match exception count": "2604-TF-PTP-3WMEC",
        "gr/ir open value": "2604-TF-PTP-GIOV",
        "po pending count": "2604-TF-PTP-PPPC",
        "invoice blocked count": "2604-TF-PTP-IBC",
        "unbilled revenue count": "2604-TF-OTC-URC",
        "delivery not billed count": "2604-TF-OTC-DNBC",
        "revenue recognition exception count": "2604-TF-OTC-RREC",
        "inventory value exception count": "2604-TF-IA-IVEC",
        "mm-fi difference value": "2604-TF-IA-MFDV",
        "negative stock count": "2604-TF-IA-NSC",
        "gr/ir ageing above threshold count": "2604-TF-IA-GAATC",
        "stock valuation difference value": "2604-TF-IA-SVDV",
        "non-moving / obsolete review": "2604-TF-IA-NMOR",
        "slow moving": "2604-TF-IA-SM",
        "payroll validation pending count": "2604-TF-PR-PVPC",
        "payroll posting exception count": "2604-TF-PR-PPEC",
        "payroll cost variance value": "2604-TF-PR-PCVV",
        "employee master mismatch count": "2604-TF-PR-EMMC",
        "payroll accrual pending count": "2604-TF-PR-PAPC",
        "report pending count": "2604-RC-PCR-RPC",
        "report delay count": "2604-RC-PCR-RDC",
        "report sign-off pending count": "2604-RC-PCR-RSPC",
        "financial analysis pending count": "2604-RC-PCFA-FAPC",
        "variance explanation pending count": "2604-RC-PCFA-VEPC",
        "material variance value": "2604-RC-PCFA-MVV",
        "balance sheet schedule pending count": "2604-RC-BSNS-BSSPC",
        "balance reconciliation difference value": "2604-RC-BSNS-BRDV",
        "supporting evidence pending count": "2604-RC-BSNS-SEPC",
        "control checklist pending count": "2604-RC-ICC-CCPC",
        "control exception count": "2604-RC-ICC-CEC",
        "control sign-off pending count": "2604-RC-ICC-CSPC",
        "package preparation pending count": "2604-RC-CPPU-PPPC",
        "package upload pending count": "2604-RC-CPPU-PUPC",
        "upload error count": "2604-RC-CPPU-UEC",
        "correction entry pending count": "2604-RC-CPC-CEPC",
        "resubmission pending count": "2604-RC-CPC-RSPC",
        "correction value": "2604-RC-CPC-CV",
        "gaap adjustment pending count": "2604-RC-GAETE-GAPC",
        "elimination entry pending count": "2604-RC-GAETE-EEPC",
        "top-side entry pending count": "2604-RC-GAETE-TSEPC",
        "final sign-off pending count": "2604-FP-FBFS-FSPC",
        "certification exception count": "2604-RC-MSC-CEC",
        "revenue budget input pending count": "2604-FP-RBP-RBIPC",
        "revenue budget draft pending count": "2604-FP-RBP-RBDPC",
        "revenue assumption gap count": "2604-FP-RBP-RAGC",
        "revenue budget review pending count": "2604-FP-RBR-RBRPC",
        "revenue budget approval pending count": "2604-FP-RBR-RBAPC",
        "revenue budget variance %": "2604-FP-RBR-RBVP",
        "cost input pending count": "2604-FP-PLBP-CIPC",
        "revenue input pending count": "2604-FP-PLBP-RIPC",
        "budget version pending count": "2604-FP-PLBP-BVPC",
        "p&l budget review pending count": "2604-FP-PLBR-PBRPC",
        "p&l budget variance %": "2604-FP-PLBR-PBVP",
        "submission pending count": "2604-FP-PLBS-SPC",
        "rejected submission count": "2604-FP-PLBS-RSC",
        "final approval pending count": "2604-FP-PLBS-FAPC",
        "revenue reforecast pending count": "2604-FP-RRF-RRPC",
        "revenue forecast variance value": "2604-FP-RRF-RFVV",
        "forecast accuracy gap %": "2604-FP-RRF-FAGP",
        "p&l reforecast pending count": "2604-FP-PLRF-PRPC",
        "p&l forecast variance value": "2604-FP-PLRF-PFVV",
        "margin variance %": "2604-FP-PLRF-MVP",
        "sign-off exception count": "2604-FP-FBFS-SEC",
        "cost allocation variance count": "2604-PC-CA-CAVC",
        "unallocated cost value": "2604-PC-CA-UCV",
        "review pending count": "2604-PC-CA-RPC",
        "cost center mapping error count": "2604-PC-CA-CCMEC",
        "cost absorption difference value": "2604-PC-CA-CADV",
        "profit center alert count": "2604-PC-PCA-PCAC",
        "loss center count": "2604-PC-PCA-LCC",
        "margin deviation %": "2604-PC-PCA-MDP",
        "profit center mapping missing count": "2604-PC-PCA-PCMMC",
        "intercompany profit elimination difference value": "2604-PC-PCA-IPEDV",
        "mis pack pending count": "2604-PC-FPAB-MPPC",
        "action open count": "2604-PC-FPAB-AOC",
        "plan vs actual gap %": "2604-PC-FPAB-PVAGP",
        "benchmark variance count": "2604-PC-FPAB-BVC",
        "management review pending count": "2604-PC-FPAB-MRPC",
        "anomaly detected count": "2604-IR-AD-ADC",
        "critical anomaly count": "2604-IR-AD-CAC",
        "high-value anomaly amount": "2604-IR-AD-HVAA",
        "duplicate transaction risk count": "2604-IR-AD-DTRC",
        "unusual posting pattern count": "2604-IR-AD-UPPC",
        "recovery opportunity count": "2604-IR-FR-ROC",
        "recovery opportunity value": "2604-IR-FR-ROV",
        "recovery action pending count": "2604-IR-FR-RAPC",
        "realization gap value": "2604-IR-FR-RGV",
        "recovery sla breach count": "2604-IR-FR-RSBC",
        "manual touch count": "2604-IR-AT-MTC",
        "unauthorized change count": "2604-IR-AT-UCC",
        "missing approval trail count": "2604-IR-AT-MATC",
        "backdated change count": "2604-IR-AT-BCC",
        "critical audit exception count": "2604-IR-AT-CAEC",
        "gst return pending count": "2604-TC-GSTC-GRPC",
        "gst filing delay count": "2604-TC-GSTC-GFDC",
        "gst input credit mismatch value": "2604-TC-GSTC-GICMV",
        "gst liability reconciliation difference value": "2604-TC-GSTC-GLRDV",
        "e-invoice generation failure count": "2604-TC-GSTC-EIGFC",
        "gst payment pending value": "2604-TC-GSTC-GPPV",
        "tds deduction error count": "2604-TC-TDSC-TDEC",
        "tds return pending count": "2604-TC-TDSC-TRPC",
        "tds payment delay count": "2604-TC-TDSC-TPDC",
        "tds certificate pending count": "2604-TC-TDSC-TCPC",
        "tds vendor pan error count": "2604-TC-TDSC-TVPEC",
        "tds reconciliation difference value": "2604-TC-TDSC-TRDV",
        "deferred tax calculation pending count": "2604-TC-TP-DTCPC",
        "tax accrual reversal pending count": "2604-TC-TP-TARPC",
        "effective tax rate variance %": "2604-TC-TP-ETRVP",
        "statutory return pending count": "2604-TC-SR-SRPC",
        "statutory filing sla breach count": "2604-TC-SR-SFSBC",
        "regulatory notice open count": "2604-TC-SR-RNOC",
        "compliance calendar missed count": "2604-TC-SR-CCMC",
        "return approval pending count": "2604-TC-SR-RAPC",
        "late filing penalty value": "2604-TC-SR-LFPV",
        "audit query open count": "2604-TC-AS-AQOC",
        "audit evidence pending count": "2604-TC-AS-AEPC",
        "audit observation open count": "2604-TC-AS-AOOC",
        "management response pending count": "2604-TC-AS-MRPC",
        "repeat audit finding count": "2604-TC-AS-RAFC",
        "audit closure pending count": "2604-TC-AS-ACPC",
        "transfer pricing adjustment value": "2604-TC-TPR-TPAV",
        "intercompany pricing variance count": "2604-TC-TPR-IPVC",
        "transfer pricing documentation pending count": "2604-TC-TPR-TPDPC",
        "armâ€™s length margin deviation %": "2604-TC-TPR-ALMDP",
        "transfer pricing review pending count": "2604-TC-TPR-TPRPC",
        "cross-border transaction exception count": "2604-TC-TPR-CBTEC"
    };

    const getContextId = (title) => {
        if (!title) return "CON-GEN-001";
        return CONTEXT_ID_MAP[title.toLowerCase()] || "CON-GEN-001";
    };

    const contextId = getContextId(subTitle);

    let baseEmailData = parentTitle === "Fixed Assets" ? emailData1 : emailData;

    React.useEffect(() => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [finalEmailData.length, isOpen, isEmbedded]);

    if (!isOpen && !isEmbedded) return null;

    const content = (
        <Box sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: isEmbedded ? 500 : 450,
            backgroundColor: "#ffffff",
            borderLeft: isEmbedded ? "1px solid rgba(195, 198, 214, 0.2)" : "none"
        }}>
            {/* Header */}
            <Box sx={{
                p: 1.5,
                borderBottom: "1px solid rgba(195, 198, 214, 0.1)",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: isEmbedded ? "#ffffff" : "#003d9b",
                color: isEmbedded ? "#181c1e" : "#ffffff"
            }}>
                <Stack direction="row" spacing={1.5} alignItems="center">
                    <Box sx={{
                        width: 32,
                        height: 32,
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: isEmbedded ? "rgba(0, 61, 155, 0.1)" : "rgba(255, 255, 255, 0.2)",
                        color: isEmbedded ? "#003d9b" : "#ffffff"
                    }}>
                        <Icon name="alternate_email" sx={{ fontSize: "18px" }} />
                    </Box>
                    <Box>
                        <Typography sx={{ fontSize: "12px", fontWeight: 700, lineHeight: 1.1 }}>Email Conversations</Typography>
                        <Typography sx={{ fontSize: "10px", fontWeight: 500, color: isEmbedded ? "#737685" : "rgba(255, 255, 255, 0.8)" }}>{contextId}</Typography>
                    </Box>
                </Stack>
                {!isEmbedded && (
                    <IconButton onClick={onClose} size="small" sx={{ color: "inherit", "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.1)" } }}>
                        <Icon name="close" sx={{ fontSize: "20px" }} />
                    </IconButton>
                )}
            </Box>

            {/* Messages Scroll Area */}
            <Box className="custom-scrollbar" sx={{ flex: 1, overflowY: "auto", p: 1.5, backgroundColor: "rgba(241, 244, 247, 0.2)" }}>
                <Stack spacing={2}>
                    {finalEmailData.map((item, index) => {
                        const isUser = item.from === 'AI';
                        const isExpanded = expandedIndex === index;
                        const userColor = globalhelper.stringToColor(item.from);

                        return (
                            <Box key={index} sx={{ display: "flex", flexDirection: "column", alignItems: isUser ? "flex-end" : "flex-start", width: "100%" }}>
                                {/* Metadata Header Line */}
                                <Stack
                                    direction={isUser ? "row-reverse" : "row"}
                                    spacing={1}
                                    alignItems="center"
                                    sx={{ mb: 0.75, px: 0.5, fontSize: "10px", color: "#737685", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.02em" }}
                                >
                                    <Avatar sx={{ bgcolor: userColor, width: 16, height: 16, fontSize: "9px" }}>
                                        {item.from.charAt(0).toUpperCase()}
                                    </Avatar>
                                    <Stack direction="row" spacing={0.5} alignItems="center">
                                        <Typography variant="inherit" sx={{ color: userColor }}>{item.from}</Typography>
                                        <Typography variant="inherit" sx={{ textTransform: "lowercase", fontWeight: 500, color: "#737685" }}>to: {item.to}</Typography>
                                    </Stack>
                                    <Box component="span" sx={{ opacity: 0.2 }}>â€¢</Box>
                                    <Typography variant="inherit" sx={{ fontWeight: 500, opacity: 0.6, textTransform: "none" }}>{item.time}</Typography>
                                </Stack>

                                {/* Message Bubble */}
                                <Paper
                                    elevation={1}
                                    sx={{
                                        width: "70%",
                                        borderRadius: "12px",
                                        overflow: "hidden",
                                        borderTopLeftRadius: isUser ? "12px" : 0,
                                        borderTopRightRadius: isUser ? 0 : "12px",
                                        backgroundColor: isUser ? "#003d9b" : "#ffffff",
                                        border: isUser ? "none" : `1px solid ${userColor}`
                                    }}
                                >
                                    {/* Subject / Toggle Area */}
                                    <Box
                                        onClick={() => setExpandedIndex(isExpanded ? null : index)}
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            gap: 2,
                                            px: 2,
                                            py: 1.25,
                                            cursor: "pointer",
                                            transition: "background-color 0.2s",
                                            color: isUser ? "#ffffff" : "#181c1e",
                                            "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.05)" }
                                        }}
                                    >
                                        <Stack direction="row" spacing={1.5} alignItems="center" sx={{ minWidth: 0, overflow: "hidden", flex: 1 }}>
                                            <Chip
                                                label={item.status}
                                                size="small"
                                                sx={{
                                                    height: 18,
                                                    fontSize: "9px",
                                                    fontWeight: 700,
                                                    textTransform: "uppercase",
                                                    backgroundColor: isUser ? "rgba(255, 255, 255, 0.2)" : "#ebeef1",
                                                    color: isUser ? "#ffffff" : "#737685",
                                                    borderRadius: "4px",
                                                    shrink: 0
                                                }}
                                            />
                                        </Stack>
                                        <Stack direction="row" spacing={1} alignItems="center" sx={{ shrink: 0 }}>
                                            <Icon name={isExpanded ? "expand_less" : "expand_more"} sx={{ fontSize: "18px" }} />
                                        </Stack>
                                    </Box>

                                    {/* Collapsible Body */}
                                    {isExpanded && (
                                        <Box sx={{
                                            px: 2,
                                            py: 1.5,
                                            borderTop: "1px solid",
                                            borderColor: isUser ? "rgba(255, 255, 255, 0.1)" : "rgba(195, 198, 214, 0.2)",
                                            backgroundColor: isUser ? "rgba(255, 255, 255, 0.05)" : "#ffffff",
                                            color: isUser ? "rgba(255, 255, 255, 0.9)" : "rgba(24, 28, 30, 0.8)"
                                        }}>
                                            <Typography sx={{ fontSize: "10px", fontWeight: 700, mb: 1, textTransform: "uppercase", letterSpacing: "0.05em" }}>
                                                {item.subject}
                                            </Typography>
                                            <Box sx={{ fontSize: "9px", lineHeight: 1.6, whiteSpace: "pre-wrap" }}>
                                                {item.body}
                                            </Box>
                                        </Box>
                                    )}
                                </Paper>
                            </Box>
                        );
                    })}
                    <div ref={messagesEndRef} />
                </Stack>
            </Box >
        </Box >
    );

    if (isEmbedded) return content;

    return (
        <Drawer anchor="right" open={isOpen} onClose={onClose} PaperProps={{ sx: { border: "none" } }}>
            {content}
        </Drawer>
    );
}


function ActionDropdown({ label, options }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [selected, setSelected] = useState(label);
    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = (opt) => {
        setAnchorEl(null);
        if (typeof opt === 'string') {
            setSelected(opt);
        }
    };

    return (
        <React.Fragment>
            <Button
                variant="outlined"
                onClick={handleClick}
                endIcon={<Icon name="arrow_drop_down" />}
                sx={{
                    justifyContent: 'space-between',
                    fontSize: '11px',
                    color: '#334155',
                    borderColor: '#cbd5e1',
                    textTransform: 'none',
                    px: 1,
                    py: 0.5,
                    textAlign: 'left'
                }}
            >
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {selected}
                </span>
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => handleClose()}
                PaperProps={{
                    sx: {
                        mt: 0.5,
                        boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
                        border: '1px solid #e2e8f0',
                        borderRadius: '8px'
                    }
                }}
            >
                {options.map((opt, i) => (
                    <MenuItem key={i} onClick={() => handleClose(opt)} sx={{ fontSize: '11px', py: 0.5, minHeight: 'auto', color: '#334155', '&:hover': { backgroundColor: '#f1f5f9' } }}>
                        {opt}
                    </MenuItem>
                ))}
            </Menu>
        </React.Fragment>
    );
}

function DetailDrilldownModal({
    isOpen,
    onClose,
    title,
    data,
    isChatOpen,
    onChatToggle,
    onDownload,
    total,
    parentTitle,
    storeManagerApproved,
    setStoreManagerApproved,
    financeManagerApproved,
    setFinanceManagerApproved,
    approvalMessages,
    setApprovalMessages
}) {
    const [isEmailOpen, setIsEmailOpen] = useState(false);
    const [isEmailExpandedDialogOpen, setIsEmailExpandedDialogOpen] = useState(false);
    const [isFooterOpen, setIsFooterOpen] = useState(true);
    const [editedJournalAmt, setEditedJournalAmt] = useState(null);
    const [isEditingComm, setIsEditingComm] = useState(false);
    const [commTo, setCommTo] = useState("Asset Owner, FA Accountant");
    const [commSub, setCommSub] = useState("Asset 400018 Update Required");
    const [commBody, setCommBody] = useState("Missing tag identified. Impact: â‚¹65,000. Action required to proceed with Q3 Close.\nProduct SL:XL2344399DSAJKNDA");

    const [isEditingDepComm, setIsEditingDepComm] = useState(false);
    const [depCommTo, setDepCommTo] = useState("FA Accountant");
    const [depCommSub, setDepCommSub] = useState("Depreciation Not Ready â€“ Asset 400001");
    const [depCommBody, setDepCommBody] = useState("Asset 400001 â€“ CNC Machine Line 2 is not depreciation-ready. Please update depreciation key and depreciation start date, run depreciation simulation, and complete depreciation posting before close.");
    const [isEditingRetComm, setIsEditingRetComm] = useState(false);
    const [retCommTo, setRetCommTo] = useState("project.controller@equinox.com, accountant@eq.mxx.com");
    const [retCommSub, setRetCommSub] = useState("Asset 500006 â€“ Plant Expansion CWIP is pending capitalization.");
    const [retCommBody, setRetCommBody] = useState("Reason: CWIP open value exists and capitalization date is missing.\nImpact: â‚¹42,00,000.\n\nAction needed:\n\n* Confirm if asset is ready for use\n* Update capitalization date\n* Post CWIP settlement if approved\n* Share confirmation before close\n\nProposed entry:\nDr Fixed Asset / Building / Plant Asset â€” â‚¹42,00,000\nCr CWIP â€” â‚¹42,00,000");

    const [isEditingRetirementPendingComm, setIsEditingRetirementPendingComm] = useState(false);
    const [retPendingCommTo, setRetPendingCommTo] = useState("FA Accountant, Asset Owner, Controller");
    const [retPendingCommSub, setRetPendingCommSub] = useState("Asset 400030 - Retirement Pending Review Required");
    const [retPendingCommBody, setRetPendingCommBody] = useState("Asset 400030 - Old DG Generator is pending retirement... Please confirm action.");
    const [retPendingNotifyList, setRetPendingNotifyList] = useState(["FA Accountant", "Asset Owner", "Controller"]);
    const [retPendingNotifyInput, setRetPendingNotifyInput] = useState("");

    const [cwipCommTo, setCwipCommTo] = useState("Controller, Project Owner, FA Accountant");
    const [cwipCommSub, setCwipCommSub] = useState("Asset 500011 â€“ CWIP Ageing Above Threshold Review Required");
    const [cwipCommBody, setCwipCommBody] = useState("Asset 500011 â€“ Warehouse Construction CWIP is aged above threshold.\n\nBlocker Type: CWIP Ageing Above Threshold\nReason: CWIP is open for more than 180 days with material open value\nFinancial Impact: â‚¹18,00,000\nAgeing Days: 333\n\nRequired Action:\n\nConfirm current project status\nReview whether capitalization is possible\nAssess impairment / provision requirement if capitalization is not feasible\nComplete supporting documentation before close");
    const [isEditingCwipComm, setIsEditingCwipComm] = useState(false);
    const [cwipNotifyList, setCwipNotifyList] = useState(["Controller", "Project Owner", "FA Accountant"]);
    const [cwipNotifyInput, setCwipNotifyInput] = useState("");
    const [cwipAccountingEntry, setCwipAccountingEntry] = useState("cap");

    const [tagRows, setTagRows] = useState([{ id: Date.now(), productId: "PRD-1001", employeeRef: "John Doe - EMP123", assetsLocation: "Mumbai", costCenter: "CC-IT", tagUpdate: "Update Asset Tag", ownership: "Update Responsible Person", validation: "Verification Action" }]);
    const [isTagAssignmentDialogOpen, setIsTagAssignmentDialogOpen] = useState(false);

    const [isEditingServiceComm, setIsEditingServiceComm] = useState(false);
    const [serviceCommTo, setServiceCommTo] = useState("CRM Service Owner");
    const [serviceCommSub, setServiceCommSub] = useState("Service Confirmation Pending â€“ SO-50001");
    const [serviceCommBody, setServiceCommBody] = useState("Service Order SO-50001 for ABC Retail Services Pvt Ltd is completed, but confirmation is still pending in SAP CRM. This is blocking revenue close readiness for Apr-2026. Please complete the CRM service confirmation before period close.");
    const [selectedServiceAction, setSelectedServiceAction] = useState("Complete Service Confirmation");

    const [spareCommTo, setSpareCommTo] = useState("Inventory / Service Owner");
    const [spareCommSub, setSpareCommSub] = useState("Spare Consumption Not Linked - MAT-80002");
    const [spareCommBody, setSpareCommBody] = useState("Material document MAT-80002 for Electronic Control Board has chargeable consumption of â‚¹0.18 L, but is not linked to a CRM service order and is not billed. This may create margin leakage for Apr-2026. Please link the material consumption to the correct CRM service order and trigger billing review before period close.");
    const [selectedSpareAction, setSelectedSpareAction] = useState("Link to CRM Service Order");

    const [retrofitCommTo, setRetrofitCommTo] = useState("Project Finance Owner");
    const [retrofitCommSub, setRetrofitCommSub] = useState("Retrofit WIP Not Settled - RET-WIP-30001");
    const [retrofitCommBody, setRetrofitCommBody] = useState("Retrofit project RET-WIP-30001 for Metro Cooling Mall Pvt Ltd is technically completed, but WIP of â‚¹1.85 L is not settled. This is impacting project close and margin reporting for Apr-2026. Please validate cost allocation and complete WIP settlement before period close.");
    const [selectedRetrofitAction, setSelectedRetrofitAction] = useState("Settle WIP");

    const [revCommTo, setRevCommTo] = useState("Finance Revenue Owner");
    const [revCommSub, setRevCommSub] = useState("CRM-FI Revenue Mismatch â€“ CRM-BILL-90002");
    const [revCommBody, setRevCommBody] = useState("CRM billing document CRM-BILL-90002 for Metro Cooling Mall Pvt Ltd is billed for â‚¹2.50 L, but FI revenue posting is not completed...");
    const [selectedRevAction, setSelectedRevAction] = useState("Trigger FI Posting");

    const [deferredCommTo, setDeferredCommTo] = useState("Revenue Accounting Owner");
    const [deferredCommSub, setDeferredCommSub] = useState("Deferred Revenue Mismatch - AMC-10001");
    const [deferredCommBody, setDeferredCommBody] = useState("AMC contract AMC-10001 for ABC Retail Services Pvt Ltd has deferred revenue posted, but monthly revenue recognition of â‚¹0.10 L is pending for Apr-2026. Please validate the contract period and run AMC revenue recognition before period close.");
    const [selectedDeferredAction, setSelectedDeferredAction] = useState("Run Revenue Recognition");


    React.useEffect(() => {
        setEditedJournalAmt(null);
    }, [title, data]);

    const handleSendEmail = () => {
        store.dispatch(showAlert("Email sent successfully to the manager", "success"));
        setIsEmailOpen(false);
    };

    if (!isOpen || !data) return null;

    const getJournalEntryDetails = (t) => {
        if (!t) return null;
        const lowerT = t.toLowerCase();
        if (lowerT.includes("opening balance")) {
            return {
                drAccount: "Inventory Reconciliation Adjustment A/c",
                drAmount: "â‚¹65,000",
                crAccount: "Inventory GL",
                crAmount: "â‚¹65,000"
            };
        }
        if (lowerT.includes("closing balance")) {
            return {
                drAccount: "Inventory Valuation Difference A/c",
                drAmount: "â‚¹15,000",
                crAccount: "Inventory GL",
                crAmount: "â‚¹15,000"
            };
        }
        if (lowerT.includes("non-moving") || lowerT.includes("obsolete")) {
            return {
                drAccount: "Inventory Obsolescence / Non-Moving Inventory Expense",
                drAmount: "â‚¹16,36,500",
                crAccount: "Provision for Obsolete / Non-Moving Inventory",
                crAmount: "â‚¹16,36,500"
            };
        }
        if (lowerT.includes("slow moving") || lowerT.includes("slow")) {
            return {
                drAccount: "Inventory Obsolescence / Slow Moving Inventory Expense",
                drAmount: "â‚¹34,74,800",
                crAccount: "Provision for Slow Moving Inventory",
                crAmount: "â‚¹34,74,800"
            };
        }
        if (lowerT.includes("capitalisation issue") || lowerT.includes("capitalization issue")) {
            return {
                drAccount: "Plant & Machinery A/c",
                drAmount: "2,570,000",
                crAccount: "Repair & Maintenance Expense A/c",
                crAmount: "2,570,000",
                closeImpact: "Asset understated and expense overstated by â‚¹2,570,000."
            };
        }
        if (lowerT.includes("capitalisation issue") || lowerT.includes("capitalization issue")) {
            return {
                drAccount: "Plant & Machinery A/c",
                drAmount: "2,570,000",
                crAccount: "Repair & Maintenance Expense A/c",
                crAmount: "2,570,000",
                closeImpact: "Asset understated and expense overstated by â‚¹2,570,000."
            };
        }
        return null;
    };

    const journalEntry = getJournalEntryDetails(title);
    const hasJournalEntry = !!journalEntry;
    const currentJournalAmt = editedJournalAmt !== null ? editedJournalAmt : (journalEntry ? journalEntry.drAmount : "");

    const rawTotal = data?.total;
    // Extract numeric part safely, stripping commas
    const rawStr = String(rawTotal || "0");
    const numMatch = rawStr.replace(/,/g, '').match(/-?[\d.]+/);
    let parsedVal = numMatch ? parseFloat(numMatch[0]) : 0;

    // Determine the true absolute value in Rupees
    let trueValueRupees = parsedVal;
    if (rawStr.toLowerCase().includes("lakh")) {
        trueValueRupees = parsedVal * 100000;
    } else if (Math.abs(parsedVal) < 1000 && parsedVal !== 0 && typeof rawTotal === "number") {
        // If it's a small number passed directly, it might be in Lakhs (e.g. 22.15)
        trueValueRupees = parsedVal * 100000;
    }

    let formattedRupees = "â‚¹0";
    let displayTotalStr = "0";
    const absValue = Math.abs(trueValueRupees);

    if (absValue !== 0) {
        if (absValue >= 100000) {
            // For 1 Lakh or more, show in Lakhs with 'L'
            formattedRupees = `${trueValueRupees < 0 ? '-' : ''}â‚¹${(absValue / 100000).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}L`;
            const lakhsStr = (absValue / 100000).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            const fullValueStr = Math.round(absValue).toLocaleString('en-IN');
            displayTotalStr = `${trueValueRupees < 0 ? '-' : ''}â‚¹${lakhsStr} L(â‚¹${fullValueStr})`;
        } else {
            // For thousands/hundreds/tens/ones, show the exact value without 'L'
            formattedRupees = `${trueValueRupees < 0 ? '-' : ''}â‚¹${Math.round(absValue).toLocaleString('en-IN')}`;
            displayTotalStr = formattedRupees;
        }
    } else {
        displayTotalStr = formattedRupees;
    }

    if (String(total).includes("â‚¹")) {
        displayTotalStr = total;
    } else if (isNaN(total) && absValue === 0) {
        displayTotalStr = "0";
    }

    const headers = data.rows && data.rows.length > 0 ? Object.keys(data.rows[0]).filter(k => k !== "Keyword") : [];

    const renderColorfulCell = (key, val, row, rowIndex, title) => {
        if (val === undefined || val === null) return "";
        const valStr = String(val).trim();
        const keyLower = key.toLowerCase();

        // Check if value is a numeric value
        const numVal = parseFloat(valStr.replace(/[^\d.-]/g, ''));
        const isNumericValue = !isNaN(numVal) && isFinite(numVal) &&
            (keyLower.includes("value") || keyLower.includes("impact") || keyLower.includes("amount") || keyLower.includes("lakhs") || keyLower.includes("price") || keyLower.includes("balance")) || keyLower.includes("qty diff") || keyLower.includes("difference") || keyLower.includes("value diff") || (title.toLowerCase() === "slow moving" && (keyLower.includes("90-120 days - values") || keyLower.includes("61-90 days - values"))) || (title.toLowerCase() === "non-moving / obsolete review" && keyLower.includes("above 120 days - values"));

        // 1. If key is code / account / material ID
        if (keyLower.includes("code") || keyLower.includes("material") || keyLower.includes("gl") || keyLower.includes("account") || keyLower.includes("id") || keyLower.includes("no")) {
            let bg = "rgba(30, 58, 138, 0.08)";
            let text = "#1e3a8a";
            let border = "rgba(30, 58, 138, 0.15)";

            if (valStr.startsWith("BO-")) {
                bg = "rgba(59, 130, 246, 0.15)"; // Blue
                text = "#1d4ed8";
                border = "rgba(59, 130, 246, 0.3)";
            } else if (valStr.startsWith("FG-")) {
                bg = "rgba(16, 185, 129, 0.15)"; // Emerald
                text = "#047857";
                border = "rgba(16, 185, 129, 0.3)";
            } else if (valStr.startsWith("RM-")) {
                bg = "rgba(6, 182, 212, 0.15)"; // Cyan
                text = "#0369a1";
                border = "rgba(6, 182, 212, 0.3)";
            } else if (valStr.startsWith("PM-")) {
                bg = "rgba(168, 85, 247, 0.15)"; // Purple
                text = "#7e22ce";
                border = "rgba(168, 85, 247, 0.3)";
            } else if (valStr.startsWith("SF-")) {
                bg = "rgba(31, 138, 209, 0.15)"; // Pink / Rose
                text = "#0e72d5ff";
                border = "rgba(31, 138, 209, 0.3)";
            } else if (valStr.startsWith("OB-")) {
                bg = "rgba(17, 35, 191, 0.15)"; // Orange / Red
                text = "#4e1cb9ff";
                border = "rgba(17, 35, 191, 0.3)";
            } else if (valStr.startsWith("GL-")) {
                bg = "rgba(99, 102, 241, 0.15)"; // Indigo
                text = "#4338ca";
                border = "rgba(99, 102, 241, 0.3)";
            }

            return (
                <Chip
                    label={valStr}
                    size="small"
                    sx={{
                        fontFamily: "'IBM Plex Sans', monospace",
                        fontWeight: 700,
                        fontSize: "11px",
                        backgroundColor: bg,
                        color: text,
                        borderRadius: "6px",
                        border: `1px solid ${border} `,
                        boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
                    }}
                />
            );
        }

        // 2. If key is classification or status
        if (keyLower.includes("classification") || keyLower.includes("status") || keyLower.includes("type")) {
            const valLower = valStr.toLowerCase();
            let bg = "rgba(100, 116, 139, 0.08)";
            let text = "#475569";
            let border = "rgba(100, 116, 139, 0.15)";

            if (valLower.includes("slow")) {
                bg = "rgba(245, 158, 11, 0.15)"; // amber
                text = "#b45309";
                border = "rgba(245, 158, 11, 0.3)";
            } else if (valLower.includes("non") || valLower.includes("obsolete") || valLower.includes("critical")) {
                bg = "rgba(239, 68, 68, 0.15)"; // red
                text = "#b91c1c";
                border = "rgba(239, 68, 68, 0.3)";
            } else if (valLower.includes("active") || valLower.includes("ok") || valLower.includes("normal") || valLower.includes("no issues") || valLower.includes("success")) {
                bg = "rgba(16, 185, 129, 0.15)"; // emerald
                text = "#047857";
                border = "rgba(16, 185, 129, 0.3)";
            }

            return (
                <Chip
                    label={valStr}
                    size="small"
                    sx={{
                        fontWeight: 800,
                        fontSize: "10px",
                        backgroundColor: bg,
                        color: text,
                        borderRadius: "6px",
                        border: `1px solid ${border} `,
                        textTransform: "uppercase",
                        letterSpacing: "0.05em",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
                    }}
                />
            );
        }

        // 3. UOM styling
        if (keyLower === "uom") {
            let bg = "#f1f5f9";
            let text = "#475569";
            if (valStr === "NOS") {
                bg = "#f3e8ff";
                text = "#6b21a8";
            } else if (valStr === "KG") {
                bg = "#fef3c7";
                text = "#92400e";
            } else if (valStr === "MTR") {
                bg = "#ecfeff";
                text = "#0891b2";
            } else if (valStr === "VAL") {
                bg = "#dcfce7";
                text = "#166534";
            }
            return (
                <Chip
                    label={valStr}
                    size="small"
                    sx={{
                        fontWeight: 700,
                        fontSize: "10px",
                        backgroundColor: bg,
                        color: text,
                        borderRadius: "4px",
                        px: 0.5
                    }}
                />
            );
        }

        // 4. Description styling with vibrant indicator dot
        if (keyLower.includes("description")) {
            const lowerVal = valStr.toLowerCase();
            let dotColor = "#3b82f6"; // Default blue
            if (lowerVal.includes("motor") || lowerVal.includes("remote") || lowerVal.includes("sensor") || lowerVal.includes("pcb")) {
                dotColor = "#8b5cf6"; // Violet (electronic/mechanical)
            } else if (lowerVal.includes("copper") || lowerVal.includes("steel") || lowerVal.includes("alu") || lowerVal.includes("glass") || lowerVal.includes("paint") || lowerVal.includes("foam")) {
                dotColor = "#0d9488"; // Teal (raw metals/compounds)
            } else if (lowerVal.includes("box") || lowerVal.includes("carton") || lowerVal.includes("label") || lowerVal.includes("eps")) {
                dotColor = "#ec4899"; // Pink (packaging)
            } else if (lowerVal.includes("obsolete") || lowerVal.includes("legacy")) {
                dotColor = "#ef4444"; // Red (obsolete/blocked)
            } else if (lowerVal.includes("account")) {
                dotColor = "#6366f1"; // Indigo (GL Account)
            }

            return (
                <Stack direction="row" spacing={1} alignItems="center" sx={{ justifyContent: "center" }}>
                    <Box sx={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: dotColor, boxShadow: `0 0 8px ${dotColor} ` }} />
                    <Typography sx={{
                        fontSize: "12px",
                        fontWeight: 700,
                        color: "#1e293b",
                        letterSpacing: "-0.01em"
                    }}>
                        {valStr}
                    </Typography>
                </Stack>
            );
        }

        // 5. Numeric value styling (Currency, impact, amount, closing stock)
        if (isNumericValue) {
            let bg = "rgba(71, 85, 105, 0.05)";
            let text = "#334155";
            let border = "rgba(71, 85, 105, 0.1)";

            if (keyLower.includes("value diff") || keyLower.includes("qty diff") || keyLower.includes("difference count") || keyLower.includes("difference") || keyLower.includes('61-90 days - values') || keyLower.includes("90-120 days - values") || keyLower.includes("above 120 days - values")) {
                bg = "rgba(239, 68, 68, 0.1)"; // High red
                text = "#be123c";
                border = "rgba(239, 68, 68, 0.2)";
            }
            else if (keyLower.includes("value_statement")) {
                bg = "rgba(66, 133, 244, 0.1)"; // Google Blue bg
                text = "#1a73e8"; // Google Blue text
                border = "rgba(66, 133, 244, 0.2)"; // Google Blue border
            } else if (keyLower.includes("value_tb")) {
                bg = "rgba(52, 168, 83, 0.1)"; // Google Green bg
                text = "#188038"; // Google Green text
                border = "rgba(52, 168, 83, 0.2)"; // Google Green border
            }
            else if (numVal > 15) {
                bg = "rgba(168, 85, 247, 0.1)"; // Purple
                text = "#7e22ce";
                border = "rgba(168, 85, 247, 0.2)";
            }
            else if (numVal > 5) {
                bg = "rgba(249, 115, 22, 0.1)"; // Orange
                text = "#c2410c";
                border = "rgba(249, 115, 22, 0.2)";
            } else if (numVal > 1) {
                bg = "rgba(20, 184, 166, 0.1)"; // Teal
                text = "#0f766e";
                border = "rgba(20, 184, 166, 0.2)";
            } else if (numVal > 0) {
                bg = "rgba(59, 130, 246, 0.08)"; // Light Blue
                text = "#1d4ed8";
                border = "rgba(59, 130, 246, 0.15)";
            }

            const formatted = `â‚¹${key.includes("Lakhs") ? numVal.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "L" : numVal.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} `;

            return (
                <Box sx={{
                    fontFamily: "'IBM Plex Sans', monospace",
                    fontWeight: 800,
                    fontSize: "12px",
                    color: text,
                    backgroundColor: bg,
                    border: `1px solid ${border} `,
                    px: 1.2,
                    py: 0.6,
                    borderRadius: "6px",
                    display: "inline-block",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.01)"
                }}>
                    {formatted}
                </Box>
            );
        }

        // 6. Default string fallback - make it bold and crisp
        return (
            <Typography sx={{
                fontSize: "12px",
                fontWeight: 700,
                color: "#1e293b",
                textAlign: "inherit"
            }}>
                {valStr}
            </Typography>
        );
    };

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            maxWidth={isChatOpen ? "xl" : "lg"}
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: "12px",
                    overflow: "hidden",
                    backgroundColor: "#ffffff",
                    maxHeight: "90vh",
                    height: "85vh",
                    display: "flex",
                    flexDirection: "column",
                    transition: "all 0.5s"
                }
            }}
        >
            {/* Modal Header */}
            <Box sx={{ px: 3, py: 2, borderBottom: "1px solid rgba(226, 232, 240, 0.8)", display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "#ffffff" }}>
                <Typography sx={{ fontSize: "18px", fontWeight: 800, color: "#0f172a", letterSpacing: "-0.01em" }}>{title} â€“ material details</Typography>
                <Stack direction="row" spacing={2} alignItems="center">
                    <Stack direction="row" spacing={1.5} position="relative">
                        <Button
                            variant={isEmailOpen ? "contained" : "outlined"}
                            onClick={() => setIsEmailOpen(!isEmailOpen)}
                            startIcon={<Icon name="mail" sx={{ fontSize: "18px" }} />}
                            sx={{
                                textTransform: "uppercase",
                                fontSize: "11px",
                                fontWeight: 700,
                                letterSpacing: "0.05em",
                                borderRadius: "8px",
                                borderWidth: "1.5px",
                                px: 2,
                                py: 0.75,
                                borderColor: "#1e3a8a",
                                backgroundColor: isEmailOpen ? "#1e3a8a" : "transparent",
                                color: isEmailOpen ? "#ffffff" : "#1e3a8a",
                                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                "&:hover": {
                                    backgroundColor: isEmailOpen ? "#172554" : "rgba(30, 58, 138, 0.08)",
                                    borderColor: "#1e3a8a",
                                    borderWidth: "1.5px",
                                    boxShadow: "0 4px 12px rgba(30, 58, 138, 0.2)",
                                    transform: "translateY(-1px)"
                                },
                                "&:active": {
                                    transform: "translateY(0)"
                                }
                            }}
                        >
                            Compose
                        </Button>

                        {/* Email Popover */}
                        {isEmailOpen && (
                            <Paper sx={{
                                position: "absolute",
                                top: "100%",
                                mt: 1,
                                right: 0,
                                w: 320,
                                backgroundColor: "#ffffff",
                                border: "1px solid rgba(195, 198, 214, 0.5)",
                                boxShadow: "0 20px 50px rgba(0,0,0,0.15)",
                                borderRadius: "12px",
                                p: 2,
                                zIndex: 120
                            }}>
                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                                    <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#1e3a8a", textTransform: "uppercase" }}>Compose Email</Typography>
                                    <IconButton onClick={() => setIsEmailOpen(false)} size="small" sx={{ p: 0 }}>
                                        <Icon name="close" sx={{ fontSize: "18px" }} />
                                    </IconButton>
                                </Box>
                                <Stack spacing={1}>
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#737685", textTransform: "uppercase", width: 48 }}>From</Typography>
                                        <TextField fullWidth variant="outlined" placeholder="finance@company.com" size="small" inputProps={{ sx: { py: 0.5, px: 1, fontSize: "11px" } }} sx={{ backgroundColor: "#f1f4f7", "& fieldset": { border: "none" } }} />
                                    </Stack>
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#737685", textTransform: "uppercase", width: 48 }}>To</Typography>
                                        <TextField fullWidth variant="outlined" placeholder="manager@company.com" size="small" inputProps={{ sx: { py: 0.5, px: 1, fontSize: "11px" } }} sx={{ backgroundColor: "#f1f4f7", "& fieldset": { border: "none" } }} />
                                    </Stack>
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#737685", textTransform: "uppercase", width: 48 }}>Sub</Typography>
                                        <TextField fullWidth variant="outlined" placeholder="Material Detail Review" size="small" inputProps={{ sx: { py: 0.5, px: 1, fontSize: "11px" } }} sx={{ backgroundColor: "#f1f4f7", "& fieldset": { border: "none" } }} />
                                    </Stack>
                                    <Box pt={1}>
                                        <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#737685", textTransform: "uppercase", mb: 0.5 }}>Message Body</Typography>
                                        <TextField fullWidth multiline rows={5} variant="outlined" placeholder="Please find the details below..." inputProps={{ sx: { py: 1, px: 1.5, fontSize: "12px" } }} sx={{ backgroundColor: "#f1f4f7", "& fieldset": { border: "none" } }} />
                                    </Box>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        onClick={handleSendEmail}
                                        sx={{
                                            backgroundColor: "#1e3a8a",
                                            color: "#ffffff",
                                            borderRadius: "8px",
                                            fontSize: "11px",
                                            fontWeight: 700,
                                            textTransform: "uppercase",
                                            letterSpacing: "0.05em",
                                            mt: 1,
                                            "&:hover": { backgroundColor: "#172554", opacity: 0.9 }
                                        }}
                                    >
                                        Send Email
                                    </Button>
                                </Stack>
                            </Paper>
                        )}

                        <Button
                            variant={isChatOpen ? "contained" : "outlined"}
                            onClick={onChatToggle}
                            startIcon={<Icon name="chat" sx={{ fontSize: "18px" }} />}
                            sx={{
                                textTransform: "uppercase",
                                fontSize: "11px",
                                fontWeight: 700,
                                letterSpacing: "0.05em",
                                borderRadius: "8px",
                                borderWidth: "1.5px",
                                px: 2,
                                py: 0.75,
                                borderColor: "#6d28d9",
                                backgroundColor: isChatOpen ? "#6d28d9" : "transparent",
                                color: isChatOpen ? "#ffffff" : "#6d28d9",
                                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                "&:hover": {
                                    backgroundColor: isChatOpen ? "#5b21b6" : "rgba(109, 40, 217, 0.08)",
                                    borderColor: "#6d28d9",
                                    borderWidth: "1.5px",
                                    boxShadow: "0 4px 12px rgba(109, 40, 217, 0.2)",
                                    transform: "translateY(-1px)"
                                },
                                "&:active": {
                                    transform: "translateY(0)"
                                }
                            }}
                        >
                            Communication
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={onDownload}
                            startIcon={<Icon name="download" sx={{ fontSize: "18px" }} />}
                            sx={{
                                textTransform: "uppercase",
                                fontSize: "11px",
                                fontWeight: 700,
                                letterSpacing: "0.05em",
                                borderRadius: "8px",
                                borderWidth: "1.5px",
                                px: 2,
                                py: 0.75,
                                borderColor: "#047857",
                                backgroundColor: "transparent",
                                color: "#047857",
                                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                "&:hover": {
                                    backgroundColor: "rgba(4, 120, 87, 0.08)",
                                    borderColor: "#047857",
                                    borderWidth: "1.5px",
                                    boxShadow: "0 4px 12px rgba(4, 120, 87, 0.2)",
                                    transform: "translateY(-1px)"
                                },
                                "&:active": {
                                    transform: "translateY(0)"
                                }
                            }}
                        >
                            Download
                        </Button>
                    </Stack>
                    <Divider orientation="vertical" flexItem sx={{ height: 24, mx: 1 }} />
                    <IconButton onClick={onClose} size="small" sx={{ color: "#475569", transition: "all 0.2s", "&:hover": { backgroundColor: "#ffdad6", color: "#ba1a1a" } }}>
                        <Icon name="close" />
                    </IconButton>
                </Stack>
            </Box>

            {/* Modal Body / Split View */}
            <Box sx={{ flex: 1, display: "flex", overflow: "hidden" }}>
                {/* Left Side: Table */}
                <Box sx={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
                    {/* Table Container - expands when footer is closed */}
                    <Box sx={{
                        flex: isFooterOpen ? "none" : 1,
                        height: (title?.toLowerCase() === "depreciation not ready" || title?.toLowerCase() === "asset addition not tagged" || title?.toLowerCase().includes("pending capitalization") || title?.toLowerCase().includes("retirement pending") || title?.toLowerCase().includes("cwip ageing above threshold") || title?.toLowerCase().includes("service confirmation pending") || title?.toLowerCase().includes("crm billing vs fi revenue mismatch") || title?.toLowerCase().includes("retrofit wip not settled") || title?.toLowerCase().includes("spare consumption not linked") || title?.toLowerCase().includes("deferred revenue mismatch"))
                            ? (isFooterOpen ? "calc(45% - 60px)" : "calc(100% - 28px)")
                            : (!hasJournalEntry
                                ? "90%"
                                : isFooterOpen ? "calc(45% - 60px)" : "calc(100% - 28px)"),
                        overflow: "auto",
                        transition: "height 0.35s cubic-bezier(0.4,0,0.2,1), flex 0.35s"
                    }} className="custom-scrollbar">
                        <Table stickyHeader size="small">
                            <TableHead>
                                {(() => {
                                    const isTargetTitle = title?.toLowerCase().includes("slow moving") || title?.toLowerCase().includes("non-moving") || title?.toLowerCase().includes("obsolete");
                                    if (isTargetTitle) {
                                        const topRow = [];
                                        const bottomRow = [];
                                        let i = 0;
                                        while (i < headers.length) {
                                            const key = headers[i];
                                            if (key.toLowerCase().includes("days -")) {
                                                const prefix = key.split(/days\s+-/i)[0].trim();
                                                if (i + 1 < headers.length && headers[i + 1].toLowerCase().includes("days -") && headers[i + 1].split(/days\s+-/i)[0].trim() === prefix) {
                                                    topRow.push({ label: prefix, colSpan: 2, rowSpan: 1, key: key });
                                                    bottomRow.push("Qty", "Value");
                                                    i += 2;
                                                } else {
                                                    topRow.push({ label: prefix, colSpan: 1, rowSpan: 1, key: key });
                                                    bottomRow.push(key.toLowerCase().includes("qty") ? "Qty" : "Value");
                                                    i += 1;
                                                }
                                            } else {
                                                topRow.push({ label: key, colSpan: 1, rowSpan: 2, key: key });
                                                i += 1;
                                            }
                                        }

                                        return (
                                            <>
                                                <TableRow>
                                                    {topRow.map((cell, idx) => (
                                                        <TableCell
                                                            key={`top-${idx}`}
                                                            colSpan={cell.colSpan}
                                                            rowSpan={cell.rowSpan}
                                                            sx={{
                                                                px: 2,
                                                                py: 1.5,
                                                                fontSize: "11px",
                                                                fontWeight: 800,
                                                                color: "#ffffff",
                                                                textAlign: "center",
                                                                textTransform: "uppercase",
                                                                letterSpacing: "0.06em",
                                                                background: "#1e3a8a",
                                                                borderBottom: "1px solid rgba(255,255,255,0.2)",
                                                                borderRight: "1px solid rgba(255,255,255,0.1)",
                                                                boxShadow: "2px 0 5px -2px rgba(0,0,0,0.5)",
                                                                position: "sticky",
                                                                top: 0,
                                                                left: cell.key.toLowerCase() === "material code" ? 0 : "auto",
                                                                zIndex: cell.key.toLowerCase() === "material code" ? 5 : 3
                                                            }}
                                                        >
                                                            {cell.label}
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                                {bottomRow.length > 0 && (
                                                    <TableRow>
                                                        {bottomRow.map((label, idx) => (
                                                            <TableCell
                                                                key={`bottom-${idx}`}
                                                                sx={{
                                                                    px: 2,
                                                                    py: 1,
                                                                    fontSize: "10px",
                                                                    fontWeight: 800,
                                                                    color: "#ffffff",
                                                                    textAlign: "center",
                                                                    textTransform: "uppercase",
                                                                    letterSpacing: "0.06em",
                                                                    background: "#1e3a8a",
                                                                    borderBottom: "2px solid #0f172a",
                                                                    borderRight: "1px solid rgba(255,255,255,0.1)",
                                                                    boxShadow: "2px 0 5px -2px rgba(0,0,0,0.5)",
                                                                    position: "sticky",
                                                                    top: 45,
                                                                    zIndex: 3
                                                                }}
                                                            >
                                                                {label}
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                )}
                                            </>
                                        );
                                    }

                                    return (
                                        <TableRow>
                                            {headers.map((key, i) => {
                                                return (((title === "Opening Balance (Stock vs. TB)" && !key.includes("Closing")) ||
                                                    (title === "Closing Balance (Stock vs. TB)" && !key.includes("Opening"))) || (title !== "Opening Balance (Stock vs. TB)" && title !== "Closing Balance (Stock vs. TB)")) && <TableCell
                                                        key={i}
                                                        sx={{
                                                            px: 2,
                                                            py: 1.5,
                                                            fontSize: "11px",
                                                            fontWeight: 800,
                                                            color: "#ffffff",
                                                            textAlign: "center",
                                                            textTransform: "uppercase",
                                                            letterSpacing: "0.06em",
                                                            background: "#1e3a8a",
                                                            borderBottom: "2px solid #0f172a",
                                                            boxShadow: "2px 0 5px -2px rgba(0,0,0,0.5)",
                                                            position: "sticky",
                                                            top: 0,
                                                            left: key.toLowerCase() === "material code" ? 0 : "auto",
                                                            zIndex: key.toLowerCase() === "material code" ? 5 : 3
                                                        }}
                                                    >
                                                        {key}
                                                    </TableCell>
                                            })}
                                        </TableRow>
                                    );
                                })()}
                            </TableHead>
                            <TableBody>
                                {data.rows.map((row, i) => {
                                    const isLastRow = i === data.rows.length - 1;
                                    const isTargetTitle = title?.toLowerCase().includes("slow moving") || title?.toLowerCase().includes("non-moving") || title?.toLowerCase().includes("obsolete");
                                    const isStickyBottomRow = isLastRow && isTargetTitle;

                                    return (
                                        <TableRow
                                            key={i}
                                            sx={{
                                                backgroundColor: isStickyBottomRow ? "#f1f5f9" : (i % 2 === 0 ? "#ffffff" : "#f8fafc"),
                                                transition: "all 0.2s ease-in-out",
                                                position: isStickyBottomRow ? "sticky" : "static",
                                                bottom: isStickyBottomRow ? 0 : "auto",
                                                zIndex: isStickyBottomRow ? 4 : "auto",
                                                boxShadow: isStickyBottomRow ? "0 -2px 10px rgba(0,0,0,0.1)" : "none",
                                                "&:hover": {
                                                    backgroundColor: isStickyBottomRow ? "#e2e8f0" : "rgba(59, 130, 246, 0.08)",
                                                    boxShadow: isStickyBottomRow ? "0 -2px 10px rgba(0,0,0,0.1)" : "inset 4px 0 0 #3b82f6",
                                                    transform: isStickyBottomRow ? "none" : "scale(1.002)"
                                                }
                                            }}
                                        >
                                            {headers.map((key, j) => {
                                                const val = row[key];
                                                const valStr = String(val || "").trim();
                                                const isNumericCell = /\d/.test(valStr) && !/[a-zA-Z]/.test(valStr);
                                                const cellAlign = isNumericCell ? "right" : "left";
                                                const isStickyColumn = (title?.toLowerCase().includes("slow moving") || title?.toLowerCase().includes("non-moving") || title?.toLowerCase().includes("obsolete")) && key.toLowerCase() === "material code";

                                                return ((((title === "Opening Balance (Stock vs. TB)" && !key.includes("Closing")) ||
                                                    (title === "Closing Balance (Stock vs. TB)" && !key.includes("Opening"))) || (title !== "Opening Balance (Stock vs. TB)" && title !== "Closing Balance (Stock vs. TB)")) && <TableCell
                                                        key={j}
                                                        sx={{
                                                            px: 2,
                                                            py: 1,
                                                            fontSize: "11.5px",
                                                            fontWeight: isStickyBottomRow ? 800 : 500,
                                                            color: isStickyBottomRow ? "#0f172a" : "#334155",
                                                            textAlign: cellAlign,
                                                            whiteSpace: "nowrap",
                                                            borderBottom: "1px solid rgba(226, 232, 240, 0.8)",
                                                            backgroundColor: isStickyColumn ? (isStickyBottomRow ? "#f1f5f9" : (i % 2 === 0 ? "#ffffff" : "#f8fafc")) : "inherit",
                                                            position: isStickyColumn ? "sticky" : "static",
                                                            left: isStickyColumn ? 0 : "auto",
                                                            zIndex: isStickyColumn ? (isStickyBottomRow ? 5 : 2) : (isStickyBottomRow ? 4 : 1),
                                                            boxShadow: isStickyColumn ? "2px 0 5px -2px rgba(0,0,0,0.1)" : "none"
                                                        }}
                                                    >
                                                        {renderColorfulCell(key, val, row, i, title)}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    )
                                })}
                                {data.rows.length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={headers.length || 6} sx={{ textAlign: "center", py: 4, color: "#64748b" }}>
                                            No data available in this table
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </Box>
                    {/* Total Row */}
                    {!(title?.toLowerCase().includes("slow moving") || title?.toLowerCase().includes("non-moving") || title?.toLowerCase().includes("obsolete")) && (
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mx: 2 }}>
                            <Typography sx={{ fontWeight: 800, color: "#1e3a8a", textTransform: "uppercase", fontSize: "11px", letterSpacing: "0.05em" }}>Total</Typography>
                            <Box sx={{
                                background: "linear-gradient(90deg, rgba(30, 58, 138, 0.05) 0%, rgba(59, 130, 246, 0.05) 100%)",
                                border: "1px solid rgba(30, 58, 138, 0.12)",
                                borderRadius: "8px",
                                px: 1.5,
                                py: 0.5,
                                display: "flex",
                                alignItems: "center"
                            }}>
                                <Typography sx={{
                                    fontFamily: "'IBM Plex Sans', monospace",
                                    fontWeight: 800,
                                    color: "#1e3a8a",
                                    fontSize: "15px"
                                }}>
                                    {displayTotalStr}
                                </Typography>
                            </Box>
                        </Box>
                    )}

                    {/* Slide Toggle Handle */}
                    {(hasJournalEntry || title?.toLowerCase() === "depreciation not ready" || title?.toLowerCase() === "asset addition not tagged" || title?.toLowerCase().includes("pending capitalization") || title?.toLowerCase().includes("retirement pending") || title?.toLowerCase().includes("cwip ageing above threshold") || title?.toLowerCase().includes("service confirmation pending") || title?.toLowerCase().includes("crm billing vs fi revenue mismatch") || title?.toLowerCase().includes("retrofit wip not settled") || title?.toLowerCase().includes("spare consumption not linked") || title?.toLowerCase().includes("deferred revenue mismatch")) && (
                        <Box
                            onClick={() => setIsFooterOpen(prev => !prev)}
                            sx={{
                                height: 28,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                backgroundColor: "#f1f5f9",
                                borderTop: "1px solid rgba(226,232,240,0.8)",
                                borderBottom: isFooterOpen ? "none" : "1px solid rgba(226,232,240,0.8)",
                                gap: 0.75,
                                transition: "background-color 0.2s",
                                flexShrink: 0,
                                "&:hover": { backgroundColor: "#e2e8f0" }
                            }}
                        >
                            <Box sx={{ width: 32, height: 3, borderRadius: 2, backgroundColor: "#94a3b8" }} />
                            <Icon name={isFooterOpen ? "expand_more" : "expand_less"} sx={{ fontSize: "16px", color: "#64748b" }} />
                            <Typography sx={{ fontSize: "9px", fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.06em" }}>
                                {isFooterOpen ? "Hide" : "Show"} {(title?.toLowerCase() === "depreciation not ready" || title?.toLowerCase() === "asset addition not tagged" || title?.toLowerCase().includes("pending capitalization") || title?.toLowerCase().includes("retirement pending") || title?.toLowerCase().includes("cwip ageing above threshold") || title?.toLowerCase().includes("service confirmation pending") || title?.toLowerCase().includes("crm billing vs fi revenue mismatch") || title?.toLowerCase().includes("retrofit wip not settled") || title?.toLowerCase().includes("spare consumption not linked") || title?.toLowerCase().includes("deferred revenue mismatch")) ? "Quick Actions" : "Journal Entry"}
                            </Typography>
                        </Box>
                    )}

                    {/* Fixed Footer Bar - slides open/closed */}
                    <Box sx={{
                        height: (title?.toLowerCase() === "depreciation not ready" || title?.toLowerCase() === "asset addition not tagged" || title?.toLowerCase().includes("pending capitalization") || title?.toLowerCase().includes("retirement pending") || title?.toLowerCase().includes("cwip ageing above threshold") || title?.toLowerCase().includes("service confirmation pending") || title?.toLowerCase().includes("crm billing vs fi revenue mismatch") || title?.toLowerCase().includes("retrofit wip not settled") || title?.toLowerCase().includes("spare consumption not linked") || title?.toLowerCase().includes("deferred revenue mismatch"))
                            ? (isFooterOpen ? "55%" : "0px")
                            : (hasJournalEntry
                                ? (isFooterOpen ? "55%" : "0px")
                                : "10%"),
                        overflow: "hidden",
                        transition: "height 0.35s cubic-bezier(0.4,0,0.2,1)",
                        flexShrink: 0,
                        boxSizing: "border-box"
                    }}>
                        <Box sx={{
                            backgroundColor: "#ffffff",
                            boxShadow: "0 -6px 20px rgba(0,0,0,0.04)",
                            px: 3,
                            py: hasJournalEntry || title?.toLowerCase() === "depreciation not ready" || title?.toLowerCase() === "asset addition not tagged" || title?.toLowerCase().includes("pending capitalization") || title?.toLowerCase().includes("retirement pending") || title?.toLowerCase().includes("cwip ageing above threshold") || title?.toLowerCase().includes("service confirmation pending") || title?.toLowerCase().includes("crm billing vs fi revenue mismatch") || title?.toLowerCase().includes("retrofit wip not settled") || title?.toLowerCase().includes("spare consumption not linked") || title?.toLowerCase().includes("deferred revenue mismatch") ? 1 : 1.5,
                            display: "flex",
                            flexDirection: "column",
                            borderTop: "1px solid rgba(226, 232, 240, 0.8)",
                            gap: hasJournalEntry || title?.toLowerCase() === "depreciation not ready" || title?.toLowerCase() === "asset addition not tagged" || title?.toLowerCase().includes("pending capitalization") || title?.toLowerCase().includes("retirement pending") || title?.toLowerCase().includes("cwip ageing above threshold") || title?.toLowerCase().includes("service confirmation pending") || title?.toLowerCase().includes("crm billing vs fi revenue mismatch") || title?.toLowerCase().includes("retrofit wip not settled") || title?.toLowerCase().includes("spare consumption not linked") || title?.toLowerCase().includes("deferred revenue mismatch") ? 0.75 : 1.5,
                            zIndex: 10,
                            overflow: "auto",
                            boxSizing: "border-box",
                            height: "100%"
                        }}>

                            {/* Suggested JE & Approvals */}
                            {hasJournalEntry && (
                                <Box sx={{ borderTop: "1px solid rgba(226, 232, 240, 0.8)", pt: 1, backgroundColor: "#f8fafc", mx: -3, px: 3, mb: -1.5, pb: 1 }}>
                                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between" sx={{ mb: 0.75 }}>
                                        <Typography sx={{ fontSize: "10px", fontWeight: 800, color: "#1e3a8a", textTransform: "uppercase", letterSpacing: "0.08em", display: "flex", alignItems: "center", gap: 0.5 }}>
                                            <Icon name="history_edu" sx={{ fontSize: "14px" }} />
                                            Suggested JE {title ? `(${getContextId(title)})` : ""}
                                            <input
                                                value={currentJournalAmt}
                                                onChange={(e) => {
                                                    let rawValue = e.target.value.replace(/[^0-9\-]/g, '');
                                                    if (rawValue === "" || rawValue === "-") {
                                                        setEditedJournalAmt(rawValue);
                                                        return;
                                                    }
                                                    const isNegative = rawValue.startsWith('-');
                                                    rawValue = rawValue.replace(/\-/g, '');
                                                    const num = parseInt(rawValue, 10);
                                                    if (!isNaN(num)) {
                                                        let formatted = 'â‚¹' + num.toLocaleString('en-IN');
                                                        if (isNegative) formatted = '-' + formatted;
                                                        setEditedJournalAmt(formatted);
                                                    }
                                                }}
                                                style={{
                                                    marginLeft: "8px",
                                                    fontSize: "10px",
                                                    fontWeight: 800,
                                                    color: "#1e3a8a",
                                                    border: "1px solid rgba(30, 58, 138, 0.2)",
                                                    borderRadius: "4px",
                                                    padding: "2px 6px",
                                                    width: "150px",
                                                    outline: "none",
                                                    background: "white",
                                                    fontFamily: "inherit"
                                                }}
                                                title="Edit Journal Amount"
                                            />
                                        </Typography>

                                        <Stack direction="row" spacing={1.5} alignItems="center">
                                            <Typography sx={{ fontSize: "9px", fontWeight: 800, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                                                Approvals:
                                            </Typography>

                                            <Button
                                                variant={storeManagerApproved ? "contained" : "outlined"}
                                                onClick={() => {
                                                    const newState = !storeManagerApproved;
                                                    setStoreManagerApproved(newState);
                                                    store.dispatch(showAlert(newState ? "Store Manager approved journal entry successfully" : "Store Manager approval revoked", "success"));
                                                    if (newState) {
                                                        if (!isChatOpen) onChatToggle();
                                                        setApprovalMessages(prev => [...prev, {
                                                            from: "System",
                                                            to: "All",
                                                            time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                                                            status: "APPROVED",
                                                            subject: "Approval Notification",
                                                            body: "Store Manager has approved the journal entry.",
                                                            isAI: false
                                                        }]);
                                                    }
                                                }}
                                                startIcon={storeManagerApproved ? <Icon name="check_circle" sx={{ fontSize: "13px" }} /> : <Icon name="radio_button_unchecked" sx={{ fontSize: "13px" }} />}
                                                sx={{
                                                    textTransform: "none",
                                                    fontSize: "11px",
                                                    fontWeight: 700,
                                                    borderRadius: "6px",
                                                    py: 0.4,
                                                    px: 1.5,
                                                    borderColor: "#0f766e",
                                                    backgroundColor: storeManagerApproved ? "#0f766e" : "transparent",
                                                    color: storeManagerApproved ? "#ffffff" : "#0f766e",
                                                    "&:hover": {
                                                        backgroundColor: storeManagerApproved ? "#0d5c56" : "rgba(15, 118, 110, 0.08)",
                                                        borderColor: "#0f766e"
                                                    }
                                                }}
                                            >
                                                {storeManagerApproved ? "Store Approved" : "Store Mgr"}
                                            </Button>

                                            <Button
                                                variant={financeManagerApproved ? "contained" : "outlined"}
                                                onClick={() => {
                                                    const newState = !financeManagerApproved;
                                                    setFinanceManagerApproved(newState);
                                                    store.dispatch(showAlert(newState ? "Finance Manager approved journal entry successfully" : "Finance Manager approval revoked", "success"));
                                                    if (newState) {
                                                        if (!isChatOpen) onChatToggle();
                                                        setApprovalMessages(prev => [...prev, {
                                                            from: "System",
                                                            to: "All",
                                                            time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                                                            status: "APPROVED",
                                                            subject: "Approval Notification",
                                                            body: "Finance Manager has approved the journal entry.",
                                                            isAI: false
                                                        }]);
                                                    }
                                                }}
                                                startIcon={financeManagerApproved ? <Icon name="check_circle" sx={{ fontSize: "13px" }} /> : <Icon name="radio_button_unchecked" sx={{ fontSize: "13px" }} />}
                                                sx={{
                                                    textTransform: "none",
                                                    fontSize: "11px",
                                                    fontWeight: 700,
                                                    borderRadius: "6px",
                                                    py: 0.4,
                                                    px: 1.5,
                                                    borderColor: "#1e3a8a",
                                                    backgroundColor: financeManagerApproved ? "#1e3a8a" : "transparent",
                                                    color: financeManagerApproved ? "#ffffff" : "#1e3a8a",
                                                    "&:hover": {
                                                        backgroundColor: financeManagerApproved ? "#172554" : "rgba(30, 58, 138, 0.08)",
                                                        borderColor: "#1e3a8a"
                                                    }
                                                }}
                                            >
                                                {financeManagerApproved ? "Finance Approved" : "Finance Mgr"}
                                            </Button>
                                        </Stack>
                                    </Stack>

                                    <Paper variant="outlined" sx={{ borderRadius: "8px", borderColor: "rgba(226, 232, 240, 0.8)", overflow: "hidden" }}>
                                        {/* Ledger Table Header */}
                                        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 120px 120px", backgroundColor: "linear-gradient(90deg, #1e3a8a 0%, #3b82f6 100%)", background: "linear-gradient(90deg, #1e3a8a 0%, #3b82f6 100%)" }}>
                                            <Typography sx={{ px: 1.5, py: 0.75, fontSize: "9px", fontWeight: 800, color: "#ffffff", textTransform: "uppercase", letterSpacing: "0.08em" }}>Entries</Typography>
                                            <Typography sx={{ px: 1.5, py: 0.75, fontSize: "9px", fontWeight: 800, color: "#ffffff", textTransform: "uppercase", letterSpacing: "0.08em", textAlign: "right" }}>Debit</Typography>
                                            <Typography sx={{ px: 1.5, py: 0.75, fontSize: "9px", fontWeight: 800, color: "#ffffff", textTransform: "uppercase", letterSpacing: "0.08em", textAlign: "right" }}>Credit</Typography>
                                        </Box>
                                        {/* DR Row */}
                                        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 120px 120px", backgroundColor: "#fff8f8", borderBottom: "1px solid rgba(226, 232, 240, 0.6)", alignItems: "center" }}>
                                            <Box sx={{ px: 1.5, py: 0.75, display: "flex", alignItems: "center", gap: 1 }}>
                                                <Chip label="DR" size="small" sx={{ height: 16, fontSize: "9px", fontWeight: 800, backgroundColor: "#fee2e2", color: "#b91c1c", borderRadius: "4px", px: 0.5, flexShrink: 0 }} />
                                                <Typography sx={{ fontSize: "10.5px", fontWeight: 600, color: "#1e293b", fontFamily: "'IBM Plex Sans', monospace" }}>
                                                    {journalEntry.drAccount}
                                                </Typography>
                                            </Box>
                                            <Typography sx={{ px: 1.5, py: 0.75, fontSize: "11px", fontWeight: 800, color: "#b91c1c", textAlign: "right", fontFamily: "'IBM Plex Sans', monospace", whiteSpace: "nowrap" }}>
                                                {currentJournalAmt}
                                            </Typography>
                                            <Typography sx={{ px: 1.5, py: 0.75, fontSize: "11px", fontWeight: 500, color: "#94a3b8", textAlign: "right", fontFamily: "'IBM Plex Sans', monospace" }}>
                                                â€”
                                            </Typography>
                                        </Box>
                                        {/* CR Row */}
                                        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 120px 120px", backgroundColor: "#f0fdf9", alignItems: "center" }}>
                                            <Box sx={{ px: 1.5, py: 0.75, display: "flex", alignItems: "center", gap: 1 }}>
                                                <Chip label="CR" size="small" sx={{ height: 16, fontSize: "9px", fontWeight: 800, backgroundColor: "#ccfbf1", color: "#0f766e", borderRadius: "4px", px: 0.5, flexShrink: 0 }} />
                                                <Typography sx={{ fontSize: "10.5px", fontWeight: 600, color: "#475569", fontFamily: "'IBM Plex Sans', monospace" }}>
                                                    {journalEntry.crAccount}
                                                </Typography>
                                            </Box>
                                            <Typography sx={{ px: 1.5, py: 0.75, fontSize: "11px", fontWeight: 500, color: "#94a3b8", textAlign: "right", fontFamily: "'IBM Plex Sans', monospace" }}>
                                                â€”
                                            </Typography>
                                            <Typography sx={{ px: 1.5, py: 0.75, fontSize: "11px", fontWeight: 800, color: "#0f766e", textAlign: "right", fontFamily: "'IBM Plex Sans', monospace", whiteSpace: "nowrap" }}>
                                                {currentJournalAmt}
                                            </Typography>
                                        </Box>
                                        {/* Totals Row */}
                                        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 120px 120px", backgroundColor: "rgba(30, 58, 138, 0.04)", borderTop: "2px solid rgba(30, 58, 138, 0.15)", alignItems: "center" }}>
                                            <Typography sx={{ px: 1.5, py: 0.6, fontSize: "9px", fontWeight: 800, color: "#1e3a8a", textTransform: "uppercase", letterSpacing: "0.06em" }}>Total</Typography>
                                            <Typography sx={{ px: 1.5, py: 0.6, fontSize: "11px", fontWeight: 800, color: "#b91c1c", textAlign: "right", fontFamily: "'IBM Plex Sans', monospace", whiteSpace: "nowrap" }}>{currentJournalAmt}</Typography>
                                            <Typography sx={{ px: 1.5, py: 0.6, fontSize: "11px", fontWeight: 800, color: "#0f766e", textAlign: "right", fontFamily: "'IBM Plex Sans', monospace", whiteSpace: "nowrap" }}>{currentJournalAmt}</Typography>
                                        </Box>
                                    </Paper>
                                    {journalEntry.closeImpact && (
                                        <Typography sx={{ fontSize: "10px", fontWeight: 600, color: "#64748b", mt: 1, fontStyle: "italic" }}>
                                            <span style={{ fontWeight: 800, color: "#475569" }}>Close impact:</span> {journalEntry.closeImpact}
                                        </Typography>
                                    )}
                                </Box>
                            )}

                            {title?.toLowerCase() === "depreciation not ready" && (
                                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', gap: 2 }}>
                                    {/* Header */}
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1, borderBottom: '1px solid rgba(226, 232, 240, 0.8)' }}>
                                        <Typography sx={{ fontSize: '14px', fontWeight: 800, color: '#1e293b', display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Icon name="block" sx={{ color: '#dc2626', fontSize: '18px' }} />
                                            Asset Blocker - Quick Actions
                                        </Typography>
                                        <Box sx={{ backgroundColor: '#e0e7ff', color: '#3730a3', px: 2, py: 0.5, borderRadius: '12px', fontSize: '11px', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                            <Icon name="info" sx={{ fontSize: '14px', color: '#3730a3' }} />
                                            <Box component="span" sx={{ fontWeight: 700 }}>Suggestion:</Box> Update depreciation fields and run depreciation.
                                        </Box>
                                    </Box>

                                    {/* Body */}
                                    <Box sx={{ display: 'flex', gap: 3, flex: 1, overflowY: 'auto', minHeight: 0, pb: 1, mb: -1 }}>
                                        {/* Resolution Actions */}
                                        <Box sx={{ flex: 1 }}>
                                            <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#475569', mb: 1 }}>Resolution Actions</Typography>
                                            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1 }}>
                                                <ActionDropdown
                                                    label="Update Master Data"
                                                    options={[
                                                        "Update Depreciation Key",
                                                        "Update Useful Life",
                                                        "Update Depreciation Start Date",
                                                        "Update Capitalization Date",
                                                        "Update Asset Class",
                                                        "Update Cost Center",
                                                        "Update Responsible Person",
                                                        "Update Asset Status",
                                                        "Update Location / Plant",
                                                        "Update Tag Number"
                                                    ]}
                                                />
                                                <ActionDropdown
                                                    label="Run Simulation"
                                                    options={[
                                                        "Run Depreciation Simulation",
                                                        "Run Close Impact Check",
                                                        "Run NBV Validation",
                                                        "Run Asset Master Validation",
                                                        "Run Period-End Readiness Check"
                                                    ]}
                                                />
                                                <ActionDropdown
                                                    label="Post Depreciation"
                                                    options={[
                                                        "Post Current Period Depreciation",
                                                        "Recalculate Depreciation",
                                                        "Post Catch-up Depreciation",
                                                        "Reverse and Repost Depreciation",
                                                        "Post Manual Depreciation Adjustment"
                                                    ]}
                                                />
                                                <ActionDropdown
                                                    label="Mark as Reviewed"
                                                    options={[
                                                        "Reviewed by FA Accountant",
                                                        "Reviewed by Controller",
                                                        "Reviewed by Asset Owner",
                                                        "Review Completed",
                                                        "Review Pending Supporting Data",
                                                        "Review Escalated this values"
                                                    ]}
                                                />
                                            </Box>
                                        </Box>

                                        {/* AI Assistant */}
                                        <Box sx={{ flex: 1.2 }}>
                                            <Box sx={{ border: '1px solid #059669', borderRadius: '8px', p: 1.5, backgroundColor: '#ffffff', position: 'relative', height: '100%', boxSizing: 'border-box', borderLeft: '4px solid #059669' }}>
                                                <Typography sx={{ fontSize: '10px', fontWeight: 800, color: '#059669', mb: 0.5, display: 'flex', alignItems: 'center', gap: 0.5, textTransform: 'uppercase' }}>
                                                    <Icon name="psychology" sx={{ fontSize: '14px' }} /> AI ASSISTANT
                                                </Typography>
                                                <Typography sx={{ fontSize: '12px', color: '#334155', lineHeight: 1.4 }}>
                                                    Missing 'Useful Life' value detected for Period 6. Adding '36 months' will resolve blocking error E-242.
                                                </Typography>
                                            </Box>
                                        </Box>

                                        {/* Stakeholder Notifications */}
                                        <Box sx={{ flex: 1 }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                                <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#475569' }}>Stakeholder Notifications</Typography>
                                                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                                    {!isEditingDepComm && (
                                                        <Typography sx={{ fontSize: '10px', color: '#2563eb', fontWeight: 600, cursor: 'pointer' }} onClick={() => setIsEmailExpandedDialogOpen(true)}>Edit Content</Typography>
                                                    )}
                                                    <IconButton size="small" onClick={() => setIsEmailExpandedDialogOpen(true)} sx={{ color: '#3b82f6', p: 0 }} title="Expand Email">
                                                        <Icon name="open_in_new" sx={{ fontSize: '14px' }} />
                                                    </IconButton>
                                                </Box>
                                            </Box>
                                            <Box sx={{ display: 'flex', flexDirection: 'column', border: '1px solid #cbd5e1', borderRadius: '4px', overflow: 'hidden', backgroundColor: '#ffffff', p: 1, maxHeight: '130px', overflowY: 'auto' }} className="custom-scrollbar">
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                        <Typography sx={{ fontSize: '9px', fontWeight: 700, color: '#475569' }}>To:</Typography>
                                                        {isEditingDepComm ? (
                                                            <input value={depCommTo} onChange={(e) => setDepCommTo(e.target.value)} style={{ fontSize: '9px', padding: '1px 4px', border: '1px solid #cbd5e1', borderRadius: '3px' }} />
                                                        ) : (
                                                            <Chip label={depCommTo} size="small" sx={{ height: '18px', fontSize: '8px', backgroundColor: '#f1f5f9' }} />
                                                        )}
                                                    </Box>
                                                    {isEditingDepComm ? (
                                                        <Box sx={{ display: 'flex', gap: 1 }}>
                                                            <Button variant="outlined" size="small" onClick={() => setIsEditingDepComm(false)} sx={{ fontSize: '9px', py: 0.25, px: 1, borderColor: '#cbd5e1', color: '#475569', textTransform: 'none' }}>Cancel</Button>
                                                            <Button variant="contained" onClick={() => { setIsEditingDepComm(false); store.dispatch(showAlert("Email send successfully", "success")); }} sx={{ backgroundColor: '#003d9b', color: '#fff', fontSize: '9px', fontWeight: 600, py: 0.25, px: 1, textTransform: 'none', boxShadow: 'none' }}>
                                                                Save & Send
                                                            </Button>
                                                        </Box>
                                                    ) : (
                                                        <Button variant="contained" onClick={() => store.dispatch(showAlert("Email send successfully", "success"))} sx={{ backgroundColor: '#003d9b', color: '#fff', fontSize: '9px', fontWeight: 600, py: 0.25, px: 1, textTransform: 'none', boxShadow: 'none' }}>
                                                            <Icon name="send" sx={{ fontSize: '10px', mr: 0.5 }} /> Send
                                                        </Button>
                                                    )}
                                                </Box>
                                                {isEditingDepComm ? (
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <Typography sx={{ fontWeight: 700, fontSize: '10px', width: '25px' }}>Sub:</Typography>
                                                            <input value={depCommSub} onChange={(e) => setDepCommSub(e.target.value)} style={{ flex: 1, fontSize: '10px', padding: '2px 4px', border: '1px solid #cbd5e1', borderRadius: '4px' }} />
                                                        </Box>
                                                        <textarea value={depCommBody} onChange={(e) => setDepCommBody(e.target.value)} style={{ width: '100%', boxSizing: 'border-box', fontSize: '10px', padding: '4px', border: '1px solid #cbd5e1', borderRadius: '4px', marginTop: '2px', resize: 'none', fontFamily: 'inherit' }} rows={3} />
                                                    </Box>
                                                ) : (
                                                    <Box>
                                                        <Typography sx={{ fontWeight: 700, fontSize: '9px', color: '#475569', mb: 0.5 }}>Subj: {depCommSub}</Typography>
                                                        <Typography sx={{ fontSize: '10px', whiteSpace: 'pre-wrap', color: '#0f172a' }}>{depCommBody}</Typography>
                                                    </Box>
                                                )}
                                            </Box>
                                        </Box>
                                    </Box>

                                    {/* Footer buttons */}
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 3, pt: 1.5, mt: 'auto', backgroundColor: '#ebeef1', mx: -3, px: 3, mb: -1, pb: 1, flexShrink: 0 }}>
                                        <Typography sx={{ display: 'none', fontSize: '12px', fontWeight: 600, color: '#475569', cursor: 'pointer', '&:hover': { color: '#0f172a' } }}>Escalate</Typography>
                                        <Box sx={{ display: 'none', width: '1px', height: '14px', backgroundColor: '#cbd5e1' }} />
                                        <Typography sx={{ fontSize: '12px', fontWeight: 600, color: '#475569', cursor: 'pointer', '&:hover': { color: '#0f172a' } }} onClick={() => setIsFooterOpen(false)}>Close</Typography>
                                        <Button variant="contained" onClick={() => { store.dispatch(showAlert("successfully saved", "success")); onClose(); }} sx={{ backgroundColor: '#003d9b', color: '#fff', fontSize: '12px', fontWeight: 600, textTransform: 'none', px: 3, py: 0.75, borderRadius: '6px', '&:hover': { backgroundColor: '#002868' }, boxShadow: 'none' }}>
                                            Save Action
                                        </Button>
                                    </Box>
                                </Box>
                            )}

                            {title?.toLowerCase() === "asset addition not tagged" && (
                                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', gap: 2 }}>

                                    {/* Body */}
                                    <Box sx={{ display: 'flex', gap: 3, flex: 1, overflowX: 'auto', overflowY: 'hidden', minHeight: 0, pb: 1, mb: -1 }}>
                                        {/* Dynamic Form List for Dropdowns */}
                                        <Box sx={{ flex: 1, minWidth: '350px', display: 'flex', flexDirection: 'column', pr: 2, borderRight: '1px solid #cbd5e1' }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#1e293b' }}>Tag Assignments</Typography>
                                                    <IconButton size="small" onClick={() => setIsTagAssignmentDialogOpen(true)} sx={{ color: '#3b82f6', p: 0 }} title="Expand">
                                                        <Icon name="unfold_more" sx={{ fontSize: '18px' }} />
                                                    </IconButton>
                                                </Box>
                                                <Button size="small" variant="outlined" onClick={() => setTagRows([...tagRows, { id: Date.now(), productId: "PRD-1001", employeeRef: "John Doe - EMP123", assetsLocation: "Mumbai", costCenter: "CC-IT", tagUpdate: "Update Asset Tag", ownership: "Update Responsible Person", validation: "Verification Action" }])} startIcon={<Icon name="add" sx={{ fontSize: '14px' }} />} sx={{ fontSize: '10px', textTransform: 'none', py: 0.25, px: 1 }}>Add Row</Button>
                                            </Box>
                                            <Box sx={{ flex: 1, overflowY: 'auto', pr: 1, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                                {tagRows.map((row, idx) => (
                                                    <Box key={row.id} sx={{ p: 1, border: '1px solid #e2e8f0', borderRadius: '4px', backgroundColor: '#f8fafc', position: 'relative' }}>
                                                        <Typography sx={{ fontSize: '10px', fontWeight: 700, mb: 1, color: '#475569' }}>Row {idx + 1}</Typography>
                                                        <IconButton size="small" onClick={() => setTagRows(tagRows.filter(r => r.id !== row.id))} sx={{ position: 'absolute', top: 2, right: 2, p: 0.5, color: '#ef4444' }}>
                                                            <Icon name="close" sx={{ fontSize: '12px' }} />
                                                        </IconButton>
                                                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1 }}>
                                                            <select value={row.productId} onChange={(e) => setTagRows(tagRows.map(r => r.id === row.id ? { ...r, productId: e.target.value } : r))} style={{ fontSize: '10px', width: '100%', padding: '4px', borderRadius: '4px', border: '1px solid #cbd5e1' }}>
                                                                <option value="PRD-1001">PRD-1001</option>
                                                                <option value="PRD-1002">PRD-1002</option>
                                                                <option value="PRD-1003">PRD-1003</option>
                                                                <option value="PRD-1004">PRD-1004</option>
                                                            </select>
                                                            <select value={row.employeeRef} onChange={(e) => setTagRows(tagRows.map(r => r.id === row.id ? { ...r, employeeRef: e.target.value } : r))} style={{ fontSize: '10px', width: '100%', padding: '4px', borderRadius: '4px', border: '1px solid #cbd5e1' }}>
                                                                <option value="John Doe - EMP123">John Doe - EMP123</option>
                                                                <option value="Jane Smith - EMP124">Jane Smith - EMP124</option>
                                                                <option value="Alice Johnson - EMP125">Alice Johnson - EMP125</option>
                                                                <option value="Bob Brown - EMP126">Bob Brown - EMP126</option>
                                                            </select>
                                                            <select value={row.assetsLocation} onChange={(e) => setTagRows(tagRows.map(r => r.id === row.id ? { ...r, assetsLocation: e.target.value } : r))} style={{ fontSize: '10px', width: '100%', padding: '4px', borderRadius: '4px', border: '1px solid #cbd5e1' }}>
                                                                <option value="Mumbai">Mumbai</option>
                                                                <option value="Delhi">Delhi</option>
                                                                <option value="Bangalore">Bangalore</option>
                                                                <option value="Chennai">Chennai</option>
                                                            </select>
                                                            <select value={row.costCenter} onChange={(e) => setTagRows(tagRows.map(r => r.id === row.id ? { ...r, costCenter: e.target.value } : r))} style={{ fontSize: '10px', width: '100%', padding: '4px', borderRadius: '4px', border: '1px solid #cbd5e1' }}>
                                                                <option value="CC-IT">CC-IT</option>
                                                                <option value="CC-HR">CC-HR</option>
                                                                <option value="CC-FIN">CC-FIN</option>
                                                                <option value="CC-SALES">CC-SALES</option>
                                                            </select>
                                                            <select value={row.tagUpdate} onChange={(e) => setTagRows(tagRows.map(r => r.id === row.id ? { ...r, tagUpdate: e.target.value } : r))} style={{ fontSize: '10px', width: '100%', padding: '4px', borderRadius: '4px', border: '1px solid #cbd5e1' }}>
                                                                <option value="Update Asset Tag">Update Asset Tag</option>
                                                                <option value="Enter Tag Number">Enter Tag Number</option>
                                                                <option value="Validate Tag">Validate Tag</option>
                                                                <option value="Reassign Tag">Reassign Tag</option>
                                                                <option value="Tag Pending">Tag Pending</option>
                                                                <option value="Tag Confirmed">Tag Confirmed</option>
                                                            </select>
                                                            <select value={row.ownership} onChange={(e) => setTagRows(tagRows.map(r => r.id === row.id ? { ...r, ownership: e.target.value } : r))} style={{ fontSize: '10px', width: '100%', padding: '4px', borderRadius: '4px', border: '1px solid #cbd5e1' }}>
                                                                <option value="Update Responsible Person">Update Responsible Person</option>
                                                                <option value="Assign Asset Owner">Assign Asset Owner</option>
                                                                <option value="Assign FA Accountant">Assign FA Accountant</option>
                                                                <option value="Update Custodian">Update Custodian</option>
                                                                <option value="Update Cost Center Owner">Update Cost Center Owner</option>
                                                                <option value="Owner Confirmation Pending">Owner Confirmation Pending</option>
                                                            </select>
                                                            <select value={row.validation} onChange={(e) => setTagRows(tagRows.map(r => r.id === row.id ? { ...r, validation: e.target.value } : r))} style={{ fontSize: '10px', width: '100%', padding: '4px', borderRadius: '4px', border: '1px solid #cbd5e1', gridColumn: 'span 2' }}>
                                                                <option value="Verification Action">Verification Action</option>
                                                                <option value="Confirm Physical Existence">Confirm Physical Existence</option>
                                                                <option value="Validate Asset Location">Validate Asset Location</option>
                                                                <option value="Review Master Data">Review Master Data</option>
                                                                <option value="Mark as Reviewed">Mark as Reviewed</option>
                                                                <option value="Escalate for Clarification">Escalate for Clarification</option>
                                                            </select>
                                                        </Box>
                                                    </Box>
                                                ))}
                                            </Box>
                                        </Box>

                                        {/* Column 3: Smart Suggestion */}
                                        <Box sx={{ width: '180px', flexShrink: 0, backgroundColor: '#dcfce7', p: 1.5, borderRadius: '8px', border: '1px solid #86efac', display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
                                            <Typography sx={{ fontSize: '11px', fontWeight: 800, color: '#166534', display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                                                <Icon name="check_circle" sx={{ fontSize: '14px' }} /> Smart Suggestion
                                            </Typography>
                                            <Typography sx={{ fontSize: '11px', color: '#14532d' }}>
                                                Update asset tag and responsible person. Validate physical existence and complete master data correction.
                                            </Typography>
                                        </Box>

                                        {/* Column 4: Action Communication */}
                                        <Box sx={{ width: '280px', flexShrink: 0, backgroundColor: '#f8fafc', p: 1.5, borderRadius: '8px', border: '1px solid #cbd5e1', display: 'flex', flexDirection: 'column' }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5, alignItems: 'center' }}>
                                                <Typography sx={{ fontSize: '10px', fontWeight: 800, color: '#334155', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                    <Icon name="mail" sx={{ fontSize: '14px', color: '#3b82f6' }} /> Action Communication
                                                </Typography>
                                                <IconButton size="small" onClick={() => setIsEmailExpandedDialogOpen(true)} sx={{ color: '#3b82f6', p: 0 }} title="Expand Email">
                                                    <Icon name="open_in_new" sx={{ fontSize: '14px' }} />
                                                </IconButton>
                                            </Box>
                                            <Box sx={{ backgroundColor: '#ffffff', p: 1, borderRadius: '4px', border: '1px solid #e2e8f0', fontSize: '10px', color: '#0f172a', flex: 1, overflowY: 'auto', minHeight: 0 }}>
                                                {isEditingComm ? (
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <Typography sx={{ fontWeight: 700, fontSize: '10px', width: '25px' }}>To:</Typography>
                                                            <input value={commTo} onChange={(e) => setCommTo(e.target.value)} style={{ flex: 1, fontSize: '10px', padding: '2px 4px', border: '1px solid #cbd5e1', borderRadius: '4px' }} />
                                                        </Box>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <Typography sx={{ fontWeight: 700, fontSize: '10px', width: '25px' }}>Sub:</Typography>
                                                            <input value={commSub} onChange={(e) => setCommSub(e.target.value)} style={{ flex: 1, fontSize: '10px', padding: '2px 4px', border: '1px solid #cbd5e1', borderRadius: '4px' }} />
                                                        </Box>
                                                        <textarea value={commBody} onChange={(e) => setCommBody(e.target.value)} style={{ width: '100%', boxSizing: 'border-box', fontSize: '10px', padding: '4px', border: '1px solid #cbd5e1', borderRadius: '4px', marginTop: '2px', resize: 'vertical', fontFamily: 'inherit' }} rows={4} />
                                                    </Box>
                                                ) : (
                                                    <React.Fragment>
                                                        <Box sx={{ display: 'flex', gap: 1, mb: 0.25 }}><Typography sx={{ fontWeight: 700, fontSize: '10px' }}>To:</Typography> {commTo}</Box>
                                                        <Box sx={{ display: 'flex', gap: 1, mb: 0.25 }}><Typography sx={{ fontWeight: 700, fontSize: '10px' }}>Sub:</Typography> {commSub}</Box>
                                                        <Typography sx={{ fontSize: '10px', whiteSpace: 'pre-wrap' }}>{commBody}</Typography>
                                                    </React.Fragment>
                                                )}
                                            </Box>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1, pt: 1, borderTop: '1px solid #e2e8f0' }}>
                                                <Box />
                                                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                                    {isEditingComm ? (
                                                        <Button variant="outlined" size="small" onClick={() => setIsEditingComm(false)} sx={{ fontSize: '9px', py: 0.25, px: 1, borderColor: '#cbd5e1', color: '#475569', textTransform: 'none' }}>Cancel</Button>
                                                    ) : (
                                                        <Typography sx={{ fontSize: '10px', color: '#2563eb', fontWeight: 600, cursor: 'pointer' }} onClick={() => setIsEmailExpandedDialogOpen(true)}>Edit Content</Typography>
                                                    )}
                                                    <Button variant="contained" onClick={() => { setIsEditingComm(false); store.dispatch(showAlert("Email send successfully", "success")); }} sx={{ backgroundColor: '#003d9b', color: '#fff', fontSize: '10px', fontWeight: 600, py: 0.5, px: 1.5, textTransform: 'none', boxShadow: 'none' }}>
                                                        {isEditingComm ? "Save & Send" : "Send Email"} <Icon name="arrow_forward" sx={{ fontSize: '12px', ml: 0.5 }} />
                                                    </Button>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>

                                    {/* Footer buttons pinned to bottom */}
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 3, pt: 1.5, mt: 'auto', backgroundColor: '#ebeef1', mx: -3, px: 3, mb: -1, pb: 1, flexShrink: 0 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Typography sx={{ fontSize: '11px', color: '#475569', fontWeight: 600 }}>Lifecycle Status:</Typography>
                                            <Button variant="outlined" endIcon={<Icon name="arrow_drop_down" />} sx={{ backgroundColor: '#ffffff', borderColor: '#cbd5e1', color: '#0f172a', fontWeight: 600, fontSize: '11px', py: 0.25, px: 1.5, textTransform: 'none' }}>Open</Button>
                                        </Box>
                                        <Box sx={{ width: '1px', height: '14px', backgroundColor: '#cbd5e1' }} />
                                        <Typography sx={{ display: 'none', fontSize: '12px', fontWeight: 600, color: '#475569', cursor: 'pointer', '&:hover': { color: '#0f172a' } }}>Escalate</Typography>
                                        <Box sx={{ display: 'none', width: '1px', height: '14px', backgroundColor: '#cbd5e1' }} />
                                        <Typography sx={{ fontSize: '12px', fontWeight: 600, color: '#475569', cursor: 'pointer', '&:hover': { color: '#0f172a' } }} onClick={() => setIsFooterOpen(false)}>Close</Typography>
                                        <Button variant="contained" onClick={() => {
                                            store.dispatch({ type: 'SAVE_TAG_ROWS', payload: tagRows });
                                            store.dispatch(showAlert("successfully saved", "success"));
                                            onClose();
                                        }} sx={{ backgroundColor: '#003d9b', color: '#fff', fontSize: '12px', fontWeight: 600, textTransform: 'none', px: 3, py: 0.75, borderRadius: '6px', '&:hover': { backgroundColor: '#002868' }, boxShadow: 'none' }}>
                                            Save Action
                                        </Button>
                                    </Box>
                                </Box>
                            )}

                            {title?.toLowerCase().includes("pending capitalization") && (
                                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', gap: 2 }}>

                                    {/* Body */}
                                    <Box sx={{ display: 'flex', gap: 3, flex: 1, overflowY: 'auto', minHeight: 0, pb: 1, mb: -1 }}>

                                        {/* Column 2: Dropdowns */}
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, flexShrink: 0, justifyContent: 'center' }}>
                                            <ActionDropdown label="Capitalization Action" options={["Review Capitalization Readiness", "Post Capitalization", "Keep Under CWIP", "Capitalization Pending", "Escalate for Project Confirmation"]} />
                                            <ActionDropdown label="Project Status" options={["Ready for Use", "Under Installation", "Pending Technical Completion", "Awaiting Business Confirmation", "On Hold"]} />
                                            <ActionDropdown label="Verification" options={["Validate CWIP Balance", "Validate Capitalization Date", "Review Supporting Documents", "Mark as Reviewed", "Escalate to Controller"]} />
                                        </Box>

                                        {/* Column 3: Smart Suggestion */}
                                        <Box sx={{ flex: 1, backgroundColor: '#f1f5f9', p: 1.5, borderRadius: '8px', border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                            <Typography sx={{ fontSize: '11px', fontWeight: 800, color: '#1e40af', mb: 0.5 }}>Closure Suggestion</Typography>
                                            <Typography sx={{ fontSize: '11px', color: '#334155', mb: 1 }}>
                                                Review capitalization readiness and post CWIP settlement if asset is ready for use.
                                            </Typography>
                                            <Chip label="CWIP open value exists without capitalization" sx={{ backgroundColor: '#dcfce7', color: '#166534', fontWeight: 700, fontSize: '9px', borderRadius: '4px', height: '20px', width: 'fit-content' }} icon={<Icon name="info" sx={{ fontSize: '12px' }} />} size="small" />
                                        </Box>

                                        {/* Column 4: Proposed Entry */}
                                        <Box sx={{ flex: 1, p: 1.5, borderRadius: '8px', border: '1px solid #cbd5e1', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                            <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#475569', mb: 1 }}>Proposed Entry</Typography>
                                            <Box sx={{ backgroundColor: '#f8fafc', p: 1, borderRadius: '4px', border: '1px solid #e2e8f0' }}>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                                    <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#2563eb' }}>Dr Fixed Asset</Typography>
                                                    <Typography sx={{ fontSize: '11px', fontWeight: 800, color: '#1e40af' }}>â‚¹42,00,000</Typography>
                                                </Box>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', pl: 2 }}>
                                                    <Typography sx={{ fontSize: '11px', fontWeight: 600, color: '#475569' }}>Cr CWIP</Typography>
                                                    <Typography sx={{ fontSize: '11px', fontWeight: 600, color: '#475569' }}>â‚¹42,00,000</Typography>
                                                </Box>
                                            </Box>
                                        </Box>

                                        {/* Column 5: Action Communication */}
                                        <Box sx={{ flex: 1.5, backgroundColor: '#f8fafc', p: 1.5, borderRadius: '8px', border: '1px solid #cbd5e1', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                                                <Box sx={{ display: 'flex', gap: -1 }}>
                                                    <Box sx={{ width: 24, height: 24, borderRadius: '50%', backgroundColor: '#2563eb', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', fontWeight: 700, border: '2px solid #fff', zIndex: 3 }}>PC</Box>
                                                    <Box sx={{ width: 24, height: 24, borderRadius: '50%', backgroundColor: '#64748b', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', fontWeight: 700, border: '2px solid #fff', zIndex: 2, ml: -1 }}>FM</Box>
                                                    <Box sx={{ width: 24, height: 24, borderRadius: '50%', backgroundColor: '#059669', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', fontWeight: 700, border: '2px solid #fff', zIndex: 1, ml: -1 }}>C</Box>
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <Typography sx={{ fontSize: '10px', fontWeight: 800, color: '#1e40af', display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer' }}>
                                                        <Icon name="mark_email_read" sx={{ fontSize: '14px' }} /> Notify All
                                                    </Typography>
                                                    <IconButton size="small" onClick={() => setIsEmailExpandedDialogOpen(true)} sx={{ color: '#1e40af', p: 0 }} title="Expand Email">
                                                        <Icon name="open_in_new" sx={{ fontSize: '14px' }} />
                                                    </IconButton>
                                                </Box>
                                            </Box>
                                            <Box sx={{ backgroundColor: '#ffffff', p: 1, borderRadius: '4px', border: '1px solid #e2e8f0', fontSize: '10px', color: '#0f172a', maxHeight: '130px', overflowY: 'auto' }} className="custom-scrollbar">
                                                {isEditingRetComm ? (
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <Typography sx={{ fontWeight: 700, fontSize: '10px', width: '25px' }}>TO:</Typography>
                                                            <input value={retCommTo} onChange={(e) => setRetCommTo(e.target.value)} style={{ flex: 1, fontSize: '10px', padding: '2px 4px', border: '1px solid #cbd5e1', borderRadius: '4px' }} />
                                                        </Box>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <Typography sx={{ fontWeight: 700, fontSize: '10px', width: '25px' }}>Sub:</Typography>
                                                            <input value={retCommSub} onChange={(e) => setRetCommSub(e.target.value)} style={{ flex: 1, fontSize: '10px', padding: '2px 4px', border: '1px solid #cbd5e1', borderRadius: '4px' }} />
                                                        </Box>
                                                        <textarea value={retCommBody} onChange={(e) => setRetCommBody(e.target.value)} style={{ width: '100%', boxSizing: 'border-box', fontSize: '10px', padding: '4px', border: '1px solid #cbd5e1', borderRadius: '4px', marginTop: '2px', resize: 'vertical', minHeight: '60px', fontFamily: 'inherit' }} />
                                                    </Box>
                                                ) : (
                                                    <React.Fragment>
                                                        <Box sx={{ display: 'flex', gap: 1, mb: 0.5 }}><Typography sx={{ fontWeight: 700, fontSize: '10px' }}>TO:</Typography> <Typography sx={{ fontSize: '10px', color: '#2563eb' }}>{retCommTo}</Typography></Box>
                                                        <Typography sx={{ fontWeight: 800, fontSize: '10px', mb: 0.5 }}>{retCommSub}</Typography>
                                                        <Typography sx={{ fontSize: '10px', whiteSpace: 'pre-wrap' }}>{retCommBody}</Typography>
                                                    </React.Fragment>
                                                )}
                                            </Box>
                                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1, gap: 1, alignItems: 'center' }}>
                                                {isEditingRetComm ? (
                                                    <Button variant="outlined" size="small" onClick={() => setIsEditingRetComm(false)} sx={{ fontSize: '9px', py: 0.25, px: 1, borderColor: '#cbd5e1', color: '#475569', textTransform: 'none' }}>Cancel</Button>
                                                ) : (
                                                    <Typography sx={{ fontSize: '10px', color: '#475569', fontWeight: 600, cursor: 'pointer' }} onClick={() => setIsEmailExpandedDialogOpen(true)}>Edit Content</Typography>
                                                )}
                                                <Typography sx={{ fontSize: '10px', color: '#475569', fontWeight: 600, cursor: 'pointer', display: isEditingRetComm ? 'none' : 'block' }}>Preview</Typography>
                                                <Button variant="contained" onClick={() => { setIsEditingRetComm(false); store.dispatch(showAlert("Email send successfully", "success")); }} sx={{ backgroundColor: '#003d9b', color: '#fff', fontSize: '10px', fontWeight: 600, py: 0.25, px: 1.5, textTransform: 'none', boxShadow: 'none' }}>
                                                    {isEditingRetComm ? "Save & Send" : "Send"}
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Box>

                                    {/* Footer buttons pinned to bottom */}
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pt: 1.5, mt: 'auto', backgroundColor: '#ebeef1', mx: -3, px: 3, mb: -1, pb: 1, flexShrink: 0 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Typography sx={{ fontSize: '9px', color: '#94a3b8', textTransform: 'uppercase', fontWeight: 700 }}>UPDATE STATUS</Typography>
                                            <select style={{ backgroundColor: '#ffffff', border: '1px solid #cbd5e1', color: '#0f172a', fontWeight: 600, fontSize: '11px', padding: '4px 8px', borderRadius: '4px', outline: 'none', cursor: 'pointer', fontFamily: 'inherit' }}>
                                                <option value="In Progress">In Progress</option>
                                                <option value="Complete">Complete</option>
                                            </select>
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                            <Button variant="outlined" sx={{ display: 'none', borderColor: '#cbd5e1', color: '#334155', fontWeight: 600, fontSize: '11px', textTransform: 'none', py: 0.5 }}>Escalate</Button>
                                            <Button variant="contained" onClick={() => { store.dispatch(showAlert("successfully saved", "success")); onClose(); }} sx={{ backgroundColor: '#003d9b', color: '#fff', fontWeight: 600, fontSize: '11px', textTransform: 'none', py: 0.5, boxShadow: 'none' }}>Save Action</Button>
                                        </Box>
                                    </Box>
                                </Box>
                            )}

                            {title?.toLowerCase().includes("retirement pending") && (
                                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', gap: 2 }}>

                                    {/* Body */}
                                    <Box sx={{ display: 'flex', gap: 3, flex: 1, overflowY: 'auto', overflowX: 'auto', minHeight: 0, pb: 1, mb: -1 }}>

                                        {/* Column 2: Dropdowns */}
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, flexShrink: 0, justifyContent: 'flex-start' }}>
                                            <ActionDropdown label="Retirement Action" options={["Confirm Retirement", "Post Asset Retirement", "Post Scrap Entry", "Keep Asset Active", "Escalate for Disposal Confirmation"]} />
                                            <ActionDropdown label="Asset Status Update" options={["Ready for Retirement", "Physical Disposal Confirmed", "Awaiting Disposal Confirmation", "Awaiting Finance Posting", "Under Review"]} />
                                            <ActionDropdown label="Verification Action" options={["Validate NBV", "Validate Accumulated Depreciation", "Validate Asset Status", "Review Disposal Evidence", "Mark as Reviewed", "Escalate to Controller"]} />
                                        </Box>

                                        {/* Column 3: Closure Suggestion */}
                                        <Box sx={{ flex: 1, minWidth: '150px', backgroundColor: '#f8fafc', p: 1.5, borderRadius: '4px', borderLeft: '3px solid #2563eb', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                            <Typography sx={{ fontSize: '11px', fontWeight: 800, color: '#1e40af', mb: 0.5, display: 'flex', alignItems: 'center', gap: 0.5 }}><Icon name="lightbulb_outline" sx={{ fontSize: '14px' }} /> Closure Suggestion</Typography>
                                            <Typography sx={{ fontSize: '10px', color: '#475569' }}>
                                                Post retirement / scrap entry and clear NBV. Update asset status from Active to Retired.
                                            </Typography>
                                        </Box>

                                        {/* Column 4: Account Detail */}
                                        <Box sx={{ flex: 1.5, minWidth: '180px', p: 1, borderRadius: '4px', backgroundColor: '#f1f5f9', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #cbd5e1', pb: 0.5, mb: 0.5 }}>
                                                <Typography sx={{ fontSize: '9px', fontWeight: 700, color: '#475569' }}>Account Detail</Typography>
                                                <Typography sx={{ fontSize: '9px', fontWeight: 700, color: '#475569' }}>Type</Typography>
                                            </Box>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.25 }}>
                                                <Typography sx={{ fontSize: '10px', fontWeight: 600, color: '#2563eb' }}>Accumulated Depreciation</Typography>
                                                <Typography sx={{ fontSize: '10px', fontWeight: 600, color: '#1e293b' }}>Dr</Typography>
                                            </Box>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.25 }}>
                                                <Typography sx={{ fontSize: '10px', fontWeight: 600, color: '#2563eb' }}>Loss on Asset Retirement</Typography>
                                                <Typography sx={{ fontSize: '10px', fontWeight: 600, color: '#1e293b' }}>Dr</Typography>
                                            </Box>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                                <Typography sx={{ fontSize: '10px', fontWeight: 600, color: '#475569' }}>Fixed Asset</Typography>
                                                <Typography sx={{ fontSize: '10px', fontWeight: 600, color: '#1e293b' }}>Cr</Typography>
                                            </Box>
                                            <Typography sx={{ fontSize: '8px', color: '#94a3b8', fontStyle: 'italic' }}>*Use actual asset cost and accumulated depreciation from master*</Typography>
                                        </Box>

                                        {/* Column 5: Copilot Insight */}
                                        <Box sx={{ flex: 1, minWidth: '160px', backgroundColor: '#f0fdf4', p: 1.5, borderRadius: '8px', border: '1px solid #bbf7d0', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                            <Typography sx={{ fontSize: '11px', fontWeight: 800, color: '#166534', mb: 0.5, display: 'flex', alignItems: 'center', gap: 0.5 }}><Icon name="psychology" sx={{ fontSize: '14px' }} /> Copilot Insight</Typography>
                                            <Typography sx={{ fontSize: '10px', color: '#14532d' }}>
                                                Retirement flag is active but the asset is still open in books. Confirm physical disposal, validate NBV, post retirement entry, and update status.
                                            </Typography>
                                        </Box>

                                        {/* Column 6: Action Communication */}
                                        <Box sx={{ flex: 1.5, minWidth: '220px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5, flexWrap: 'wrap' }}>
                                                <Typography sx={{ fontSize: '9px', fontWeight: 600, color: '#475569' }}>Notify:</Typography>
                                                {retPendingNotifyList.map((notifyTo, idx) => (
                                                    <Chip key={idx} label={notifyTo} size="small" onDelete={() => setRetPendingNotifyList(prev => prev.filter((_, i) => i !== idx))} sx={{ height: '20px', fontSize: '9px', backgroundColor: '#e2e8f0' }} />
                                                ))}
                                                <input
                                                    value={retPendingNotifyInput}
                                                    onChange={(e) => setRetPendingNotifyInput(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter' && retPendingNotifyInput.trim() !== '') {
                                                            setRetPendingNotifyList(prev => [...prev, retPendingNotifyInput.trim()]);
                                                            setRetPendingNotifyInput('');
                                                        }
                                                    }}
                                                    placeholder="Add..."
                                                    style={{ border: 'none', outline: 'none', background: 'transparent', fontSize: '9px', width: '60px', color: '#0f172a' }}
                                                />
                                            </Box>
                                            <Box sx={{ backgroundColor: '#ffffff', p: 1, borderRadius: '4px', border: '1px solid #cbd5e1', fontSize: '10px', color: '#0f172a' }}>
                                                {isEditingRetirementPendingComm ? (
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <Typography sx={{ fontWeight: 700, fontSize: '10px', width: '25px' }}>Sub:</Typography>
                                                            <input value={retPendingCommSub} onChange={(e) => setRetPendingCommSub(e.target.value)} style={{ flex: 1, fontSize: '10px', padding: '2px 4px', border: '1px solid #cbd5e1', borderRadius: '4px' }} />
                                                        </Box>
                                                        <textarea value={retPendingCommBody} onChange={(e) => setRetPendingCommBody(e.target.value)} style={{ width: '100%', boxSizing: 'border-box', fontSize: '10px', padding: '4px', border: '1px solid #cbd5e1', borderRadius: '4px', marginTop: '2px', resize: 'none', fontFamily: 'inherit' }} rows={2} />
                                                    </Box>
                                                ) : (
                                                    <React.Fragment>
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', backgroundColor: '#f1f5f9', p: 0.5, borderRadius: '4px', mb: 0.5, alignItems: 'center' }}>
                                                            <Typography sx={{ fontWeight: 800, fontSize: '10px' }}>Sub: {retPendingCommSub}</Typography>
                                                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                                                <Typography sx={{ fontSize: '9px', color: '#2563eb', fontWeight: 600, cursor: 'pointer' }}>Preview</Typography>
                                                                <Typography sx={{ fontSize: '9px', color: '#2563eb', fontWeight: 600, cursor: 'pointer' }} onClick={() => setIsEmailExpandedDialogOpen(true)}>Edit Content</Typography>
                                                                <IconButton size="small" onClick={() => setIsEmailExpandedDialogOpen(true)} sx={{ color: '#2563eb', p: 0 }} title="Expand Email">
                                                                    <Icon name="open_in_new" sx={{ fontSize: '14px' }} />
                                                                </IconButton>
                                                            </Box>
                                                        </Box>
                                                        <Typography sx={{ fontSize: '10px', whiteSpace: 'pre-wrap', color: '#475569', p: 0.5 }}>{retPendingCommBody}</Typography>
                                                    </React.Fragment>
                                                )}
                                            </Box>
                                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 0.5 }}>
                                                {isEditingRetirementPendingComm ? (
                                                    <Box sx={{ display: 'flex', gap: 1 }}>
                                                        <Button variant="outlined" size="small" onClick={() => setIsEditingRetirementPendingComm(false)} sx={{ fontSize: '9px', py: 0.25, px: 1, borderColor: '#cbd5e1', color: '#475569', textTransform: 'none' }}>Cancel</Button>
                                                        <Button variant="contained" onClick={() => { setIsEditingRetirementPendingComm(false); store.dispatch(showAlert("Email send successfully", "success")); }} sx={{ backgroundColor: '#003d9b', color: '#fff', fontSize: '10px', fontWeight: 600, py: 0.25, px: 1.5, textTransform: 'none', boxShadow: 'none' }}>Save & Send</Button>
                                                    </Box>
                                                ) : (
                                                    <Button variant="contained" onClick={() => { store.dispatch(showAlert("Email send successfully", "success")); }} sx={{ backgroundColor: '#003d9b', color: '#fff', fontSize: '10px', fontWeight: 600, py: 0.25, px: 1.5, textTransform: 'none', boxShadow: 'none' }}>
                                                        <Icon name="send" sx={{ fontSize: '12px', mr: 0.5 }} /> Send Email
                                                    </Button>
                                                )}
                                            </Box>
                                        </Box>
                                    </Box>

                                    {/* Footer buttons pinned to bottom */}
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pt: 1.5, mt: 'auto', backgroundColor: '#ebeef1', mx: -3, px: 3, mb: -1, pb: 1, flexShrink: 0 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Typography sx={{ fontSize: '9px', color: '#94a3b8', textTransform: 'uppercase', fontWeight: 700 }}>RESOLUTION STATUS</Typography>
                                            <select style={{ backgroundColor: '#ffffff', border: '1px solid #cbd5e1', color: '#0f172a', fontWeight: 600, fontSize: '11px', padding: '4px 8px', borderRadius: '4px', outline: 'none', cursor: 'pointer', fontFamily: 'inherit' }}>
                                                <option value="Open">Open</option>
                                                <option value="In Progress">In Progress</option>
                                                <option value="Closed">Closed</option>
                                                <option value="Pending Input">Pending Input</option>
                                                <option value="Escalated">Escalated</option>
                                            </select>
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                            <Button variant="outlined" sx={{ display: 'none', borderColor: '#ef4444', color: '#ef4444', fontWeight: 600, fontSize: '11px', textTransform: 'none', py: 0.5 }}>Escalate</Button>
                                            <Button variant="outlined" sx={{ borderColor: '#cbd5e1', color: '#334155', fontWeight: 600, fontSize: '11px', textTransform: 'none', py: 0.5 }} onClick={() => setIsFooterOpen(false)}>Close</Button>
                                            <Button variant="contained" onClick={() => { store.dispatch(showAlert("successfully saved", "success")); onClose(); }} sx={{ backgroundColor: '#003d9b', color: '#fff', fontWeight: 600, fontSize: '11px', textTransform: 'none', py: 0.5, boxShadow: 'none' }}>Save Action</Button>
                                        </Box>
                                    </Box>
                                </Box>
                            )}

                            {title?.toLowerCase().includes("cwip ageing above threshold") && (
                                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', gap: 2 }}>

                                    {/* Header */}
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pb: 1, borderBottom: '1px solid #e2e8f0' }}>
                                        <Icon name="warning" sx={{ color: '#b91c1c', fontSize: '18px' }} />
                                        <Typography sx={{ fontWeight: 800, fontSize: '14px', color: '#1e293b' }}>Asset Blocker â€“ Quick Actions</Typography>
                                        <Chip label="High Severity" size="small" sx={{ height: '20px', fontSize: '9px', fontWeight: 700, backgroundColor: '#fee2e2', color: '#b91c1c' }} />
                                        <Chip label="In Review" size="small" sx={{ height: '20px', fontSize: '9px', fontWeight: 700, backgroundColor: '#dbeafe', color: '#1e40af' }} />
                                        <Typography sx={{ fontWeight: 600, fontSize: '12px', color: '#475569', ml: 1 }}>â‚¹18,00,000</Typography>
                                    </Box>

                                    {/* Body */}
                                    <Box sx={{ display: 'flex', gap: 3, flex: 1, overflowY: 'auto', overflowX: 'auto', minHeight: 0, pb: 1, mb: -1 }}>

                                        {/* Column 2 */}
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, flexShrink: 0, justifyContent: 'flex-start' }}>
                                            <Typography sx={{ fontSize: '9px', fontWeight: 700, color: '#64748b', mb: 0.5 }}>RESOLUTION FRAMEWORK</Typography>
                                            <ActionDropdown label="CWIP Treatment Action" options={["Review Capitalization Readiness", "Continue Under CWIP", "Capitalize Asset", "Assess Impairment / Provision", "Escalate for Management Review"]} />
                                            <ActionDropdown label="Project Status Update" options={["Ready for Use", "Under Construction", "Delayed Project", "On Hold", "Cancelled / No Longer Active"]} />
                                            <ActionDropdown label="Verification Action" options={["Validate CWIP Balance", "Review Supporting Documents", "Validate Ageing Basis", "Mark as Reviewed", "Escalate to Controller"]} />
                                        </Box>

                                        {/* Column 3 */}
                                        <Box sx={{ flex: 1, minWidth: '150px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                            <Typography sx={{ fontSize: '9px', fontWeight: 700, color: '#64748b', mb: 0.5 }}>SYSTEM RECOMMENDATION</Typography>
                                            <Box sx={{ backgroundColor: '#f8fafc', p: 1.5, borderRadius: '4px', borderLeft: '3px solid #16a34a' }}>
                                                <Typography sx={{ fontSize: '10px', color: '#334155' }}>
                                                    Review project status, capitalization possibility, or impairment/provision requirement.
                                                </Typography>
                                            </Box>
                                        </Box>

                                        {/* Column 4 */}
                                        <Box sx={{ flex: 1.5, minWidth: '200px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                                                <Typography sx={{ fontSize: '9px', fontWeight: 700, color: '#64748b' }}>PROPOSED ACCOUNTING ENTRY</Typography>
                                                <Chip label="If Approved" size="small" sx={{ height: '16px', fontSize: '8px', backgroundColor: '#e2e8f0', color: '#475569' }} />
                                            </Box>
                                            <Box sx={{ backgroundColor: '#ffffff', border: '1px solid #cbd5e1', borderRadius: '4px', p: 1 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 0.5 }}>
                                                    <input type="radio" name="accountingEntry" value="cap" checked={cwipAccountingEntry === 'cap'} onChange={() => setCwipAccountingEntry('cap')} style={{ marginTop: '2px', cursor: 'pointer' }} />
                                                    <Typography sx={{ fontSize: '10px', fontWeight: cwipAccountingEntry === 'cap' ? 700 : 500, color: '#0f172a' }}>Cap: Dr Bldg/Whse, Cr CWIP â‚¹18,00,000</Typography>
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 1 }}>
                                                    <input type="radio" name="accountingEntry" value="imp" checked={cwipAccountingEntry === 'imp'} onChange={() => setCwipAccountingEntry('imp')} style={{ marginTop: '2px', cursor: 'pointer' }} />
                                                    <Typography sx={{ fontSize: '10px', fontWeight: cwipAccountingEntry === 'imp' ? 700 : 500, color: '#0f172a' }}>Imp: Dr Exp, Cr Provision â‚¹18,00,000</Typography>
                                                </Box>
                                                <Typography sx={{ fontSize: '8px', color: '#94a3b8', fontStyle: 'italic' }}>Post only after project status and management approval are confirmed.</Typography>
                                            </Box>
                                        </Box>

                                        {/* Column 5 */}
                                        <Box sx={{ flex: 1.5, minWidth: '240px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                                                <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                                                    {cwipNotifyList.map((notifyTo, idx) => (
                                                        <Chip key={idx} label={notifyTo} size="small" onDelete={() => setCwipNotifyList(prev => prev.filter((_, i) => i !== idx))} sx={{ height: '18px', fontSize: '8px', backgroundColor: '#f1f5f9' }} />
                                                    ))}
                                                    <input
                                                        value={cwipNotifyInput}
                                                        onChange={(e) => setCwipNotifyInput(e.target.value)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter' && cwipNotifyInput.trim() !== '') {
                                                                setCwipNotifyList(prev => [...prev, cwipNotifyInput.trim()]);
                                                                setCwipNotifyInput('');
                                                            }
                                                        }}
                                                        placeholder="Add..."
                                                        style={{ border: 'none', outline: 'none', background: 'transparent', fontSize: '9px', width: '40px', color: '#0f172a' }}
                                                    />
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    {isEditingCwipComm ? (
                                                        <Box sx={{ display: 'flex', gap: 1 }}>
                                                            <Button variant="outlined" size="small" onClick={() => setIsEditingCwipComm(false)} sx={{ fontSize: '9px', py: 0.25, px: 1, borderColor: '#cbd5e1', color: '#475569', textTransform: 'none' }}>Cancel</Button>
                                                            <Button variant="contained" onClick={() => { setIsEditingCwipComm(false); store.dispatch(showAlert("Email sent successfully", "success")); }} sx={{ backgroundColor: '#0ea5e9', color: '#fff', fontSize: '10px', fontWeight: 600, py: 0.25, px: 1.5, textTransform: 'none', boxShadow: 'none' }}>Save & Send</Button>
                                                        </Box>
                                                    ) : (
                                                        <Button variant="contained" onClick={() => { store.dispatch(showAlert("Email sent successfully", "success")); }} sx={{ backgroundColor: '#0ea5e9', color: '#fff', fontSize: '10px', fontWeight: 600, py: 0.25, px: 1.5, textTransform: 'none', boxShadow: 'none' }}>
                                                            <Icon name="send" sx={{ fontSize: '12px', mr: 0.5 }} /> Send Email
                                                        </Button>
                                                    )}
                                                </Box>
                                            </Box>
                                            <Box sx={{ backgroundColor: '#ffffff', p: 1, borderRadius: '4px', border: '1px solid #cbd5e1', fontSize: '10px', color: '#0f172a', display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, maxHeight: '85px' }}>
                                                {isEditingCwipComm ? (
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, flex: 1, minHeight: 0 }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <Typography sx={{ fontWeight: 700, fontSize: '10px', width: '25px', flexShrink: 0 }}>Sub:</Typography>
                                                            <input value={cwipCommSub} onChange={(e) => setCwipCommSub(e.target.value)} style={{ flex: 1, fontSize: '10px', padding: '2px 4px', border: '1px solid #cbd5e1', borderRadius: '4px', minWidth: 0 }} />
                                                        </Box>
                                                        <textarea value={cwipCommBody} onChange={(e) => setCwipCommBody(e.target.value)} style={{ width: '100%', boxSizing: 'border-box', fontSize: '10px', padding: '4px', border: '1px solid #cbd5e1', borderRadius: '4px', marginTop: '2px', resize: 'none', fontFamily: 'inherit', flex: 1, minHeight: 0 }} />
                                                    </Box>
                                                ) : (
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5, alignItems: 'center', flexShrink: 0 }}>
                                                            <Typography sx={{ fontWeight: 700, fontSize: '9px', color: '#475569', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', pr: 1 }}>Subj: {cwipCommSub}</Typography>
                                                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexShrink: 0 }}>
                                                                <Typography sx={{ fontSize: '9px', color: '#2563eb', fontWeight: 600, cursor: 'pointer' }}>Preview</Typography>
                                                                <Typography sx={{ fontSize: '9px', color: '#2563eb', fontWeight: 600, cursor: 'pointer' }} onClick={() => setIsEmailExpandedDialogOpen(true)}>Edit</Typography>
                                                                <IconButton size="small" onClick={() => setIsEmailExpandedDialogOpen(true)} sx={{ color: '#2563eb', p: 0 }} title="Expand Email">
                                                                    <Icon name="open_in_new" sx={{ fontSize: '14px' }} />
                                                                </IconButton>
                                                            </Box>
                                                        </Box>
                                                        <Box sx={{ flex: 1, overflowY: 'auto', minHeight: 0 }} className="custom-scrollbar">
                                                            <Typography sx={{ fontSize: '10px', whiteSpace: 'pre-wrap', color: '#0f172a' }}>{cwipCommBody}</Typography>
                                                        </Box>
                                                    </Box>
                                                )}
                                            </Box>
                                        </Box>
                                    </Box>

                                    {/* Footer buttons pinned to bottom */}
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pt: 1.5, mt: 'auto', backgroundColor: '#ebeef1', mx: -3, px: 3, mb: -1, pb: 1, flexShrink: 0 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Typography sx={{ fontSize: '9px', color: '#94a3b8', textTransform: 'uppercase', fontWeight: 700 }}>STATUS UPDATE:</Typography>
                                            <select style={{ backgroundColor: '#ffffff', border: '1px solid #cbd5e1', color: '#0f172a', fontWeight: 600, fontSize: '11px', padding: '4px 8px', borderRadius: '4px', outline: 'none', cursor: 'pointer', fontFamily: 'inherit' }}>
                                                <option value="Open">Open</option>
                                                <option value="In Progress">In Progress</option>
                                                <option value="In Review">In Review</option>
                                                <option value="Closed">Closed</option>
                                                <option value="Pending Input">Pending Input</option>
                                                <option value="Escalated">Escalated</option>
                                            </select>
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                            <Button variant="outlined" sx={{ display: 'none', borderColor: '#ef4444', color: '#ef4444', fontWeight: 600, fontSize: '11px', textTransform: 'none', py: 0.5 }}>Escalate</Button>
                                            <Button variant="outlined" sx={{ borderColor: '#cbd5e1', color: '#334155', fontWeight: 600, fontSize: '11px', textTransform: 'none', py: 0.5 }} onClick={() => setIsFooterOpen(false)}>Close</Button>
                                            <Button variant="contained" onClick={() => { store.dispatch(showAlert("successfully saved", "success")); onClose(); }} sx={{ backgroundColor: '#003d9b', color: '#fff', fontWeight: 600, fontSize: '11px', textTransform: 'none', py: 0.5, boxShadow: 'none' }}>Save Action</Button>
                                        </Box>
                                    </Box>
                                </Box>
                            )}
                            {title?.toLowerCase().includes("service confirmation pending") && (
                                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', gap: 2 }}>
                                    {/* Header */}
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1, borderBottom: '1px solid #e2e8f0' }}>
                                        <Typography sx={{ fontWeight: 800, fontSize: '14px', color: '#1e293b' }}>Service Confirmation â€“ Quick Actions</Typography>
                                        <Chip label="Suggestion: Complete CRM service confirmation before revenue close" size="small" sx={{ height: '24px', fontSize: '10px', fontWeight: 600, backgroundColor: '#eff6ff', color: '#2563eb' }} />
                                    </Box>

                                    {/* Body */}
                                    <Box sx={{ display: 'flex', gap: 3, flex: 1, overflowY: 'auto', minHeight: 0, pb: 1, mb: -1 }}>
                                        {/* Resolution Actions */}
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '220px', flexShrink: 0 }}>
                                            <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#64748b', mb: 0.5 }}>Resolution Actions</Typography>
                                            <Box sx={{ display: 'flex', gap: 1 }}>
                                                <Button onClick={() => setSelectedServiceAction("Complete Service Confirmation")} variant={selectedServiceAction === "Complete Service Confirmation" ? "contained" : "outlined"} sx={{ flex: 1, backgroundColor: selectedServiceAction === "Complete Service Confirmation" ? '#003d9b' : 'transparent', borderColor: '#cbd5e1', color: selectedServiceAction === "Complete Service Confirmation" ? '#fff' : '#0f172a', fontSize: '10px', fontWeight: 600, textTransform: 'none', px: 1, py: 0.5, lineHeight: 1.2, boxShadow: 'none' }}>Complete Service<br />Confirmation</Button>
                                                <Button onClick={() => setSelectedServiceAction("Request CRM Update")} variant={selectedServiceAction === "Request CRM Update" ? "contained" : "outlined"} sx={{ flex: 1, backgroundColor: selectedServiceAction === "Request CRM Update" ? '#003d9b' : 'transparent', borderColor: '#cbd5e1', color: selectedServiceAction === "Request CRM Update" ? '#fff' : '#0f172a', fontSize: '10px', fontWeight: 600, textTransform: 'none', px: 1, py: 0.5, lineHeight: 1.2, boxShadow: 'none' }}>Request CRM Update</Button>
                                            </Box>
                                            <Box sx={{ display: 'flex', gap: 1 }}>
                                                <Button onClick={() => setSelectedServiceAction("Notify Service Owner")} variant={selectedServiceAction === "Notify Service Owner" ? "contained" : "outlined"} sx={{ flex: 1, backgroundColor: selectedServiceAction === "Notify Service Owner" ? '#003d9b' : 'transparent', borderColor: '#cbd5e1', color: selectedServiceAction === "Notify Service Owner" ? '#fff' : '#0f172a', fontSize: '10px', fontWeight: 600, textTransform: 'none', px: 1, py: 0.5, boxShadow: 'none' }}>Notify Service Owner</Button>
                                                <Button onClick={() => setSelectedServiceAction("Mark as Reviewed")} variant={selectedServiceAction === "Mark as Reviewed" ? "contained" : "outlined"} sx={{ flex: 1, backgroundColor: selectedServiceAction === "Mark as Reviewed" ? '#003d9b' : 'transparent', borderColor: '#cbd5e1', color: selectedServiceAction === "Mark as Reviewed" ? '#fff' : '#0f172a', fontSize: '10px', fontWeight: 600, textTransform: 'none', px: 1, py: 0.5, boxShadow: 'none' }}>Mark as Reviewed</Button>
                                            </Box>
                                        </Box>

                                        {/* Stakeholder Notifications */}
                                        <Box sx={{ flex: 1.2, display: 'flex', flexDirection: 'column', minWidth: '300px' }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                                <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#64748b' }}>Stakeholder Notifications</Typography>
                                                <Typography sx={{ fontSize: '11px', fontWeight: 600, color: '#2563eb', cursor: 'pointer' }} onClick={() => setIsEmailExpandedDialogOpen(true)}>Edit Content</Typography>
                                            </Box>
                                            <Box sx={{ border: '1px solid #e2e8f0', borderRadius: '6px', p: 1.5, display: 'flex', flexDirection: 'column', gap: 1, height: '100%' }}>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                                                        <Typography sx={{ fontSize: '11px', color: '#94a3b8' }}>To:</Typography>
                                                        <Chip label={serviceCommTo} size="small" sx={{ height: '20px', fontSize: '10px', backgroundColor: '#f1f5f9', color: '#475569' }} />
                                                    </Box>
                                                    <Button variant="contained" size="small" onClick={() => { store.dispatch(showAlert("Email sent successfully", "success")); }} sx={{ backgroundColor: '#003d9b', color: '#fff', fontSize: '10px', fontWeight: 600, textTransform: 'none', py: 0.25, minWidth: '60px', boxShadow: 'none' }}><Icon name="send" sx={{ fontSize: '12px', mr: 0.5 }} /> Send</Button>
                                                </Box>
                                                <React.Fragment>
                                                    <Typography sx={{ fontSize: '11px', fontWeight: 800, color: '#0f172a' }}>Subj: {serviceCommSub}</Typography>
                                                    <Typography sx={{ fontSize: '11px', color: '#64748b', lineHeight: 1.4, whiteSpace: 'pre-wrap' }}>
                                                        {serviceCommBody}
                                                    </Typography>
                                                </React.Fragment>
                                            </Box>
                                        </Box>

                                        {/* AI ASSISTANT */}
                                        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: '250px' }}>
                                            <Box sx={{ border: '1px solid #10b981', borderRadius: '6px', p: 1.5, display: 'flex', flexDirection: 'column', gap: 1, height: '100%', mt: '22px' }}>
                                                <Typography sx={{ fontSize: '11px', fontWeight: 800, color: '#059669' }}>AI ASSISTANT</Typography>
                                                <Typography sx={{ fontSize: '11px', color: '#475569', lineHeight: 1.4 }}>
                                                    Service order SO-50001 is completed, but CRM confirmation is pending.<br />
                                                    Completing the service confirmation will remove the revenue close blocker and allow finance to proceed with revenue readiness validation.
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>

                                    {/* Footer buttons pinned to bottom */}
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', pt: 1, mt: 'auto', borderTop: '1px dashed #3b82f6', mx: -3, px: 3, mb: -1, pb: 1, flexShrink: 0, gap: 3 }}>
                                        <Typography sx={{ fontSize: '12px', fontWeight: 600, color: '#475569', cursor: 'pointer', '&:hover': { color: '#0f172a' } }} onClick={() => setIsFooterOpen(false)}>Close</Typography>
                                        <Button variant="contained" onClick={() => { store.dispatch(showAlert("successfully saved", "success")); onClose(); }} sx={{ backgroundColor: '#003d9b', color: '#fff', fontWeight: 600, fontSize: '11px', textTransform: 'none', py: 0.75, px: 3, borderRadius: '4px', boxShadow: 'none' }}>Save Action</Button>
                                    </Box>
                                </Box>
                            )}
                            {title?.toLowerCase().includes("spare consumption not linked") && (
                                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', gap: 2 }}>
                                    {/* Header */}
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pb: 1, borderBottom: '1px solid #e2e8f0' }}>
                                        <Typography sx={{ fontWeight: 800, fontSize: '14px', color: '#1e3a8a' }}>Spare Consumption - Quick Actions</Typography>
                                    </Box>

                                    <Box sx={{ display: 'flex', gap: 2, flex: 1, minHeight: 0 }}>
                                        {/* Resolution Actions (Left) */}
                                        <Box sx={{ width: '220px', display: 'flex', flexDirection: 'column', gap: 1 }}>
                                            <Typography sx={{ fontSize: '9px', fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.05em', mb: 0.5 }}>Resolution Actions</Typography>

                                            <Button
                                                onClick={() => setSelectedSpareAction("Link to CRM Service Order")}
                                                variant={selectedSpareAction === "Link to CRM Service Order" ? "contained" : "outlined"}
                                                sx={{
                                                    backgroundColor: selectedSpareAction === "Link to CRM Service Order" ? '#001e5c' : 'transparent',
                                                    borderColor: '#cbd5e1',
                                                    color: selectedSpareAction === "Link to CRM Service Order" ? '#fff' : '#0f172a',
                                                    fontSize: '11px', fontWeight: 600, textTransform: 'none', py: 0.75, justifyContent: 'center', boxShadow: 'none',
                                                    '&:hover': { backgroundColor: selectedSpareAction === "Link to CRM Service Order" ? '#001e5c' : '#f8fafc' }
                                                }}
                                            >
                                                Link to CRM Service Order
                                            </Button>

                                            <Button
                                                onClick={() => setSelectedSpareAction("Trigger Billing Review")}
                                                variant={selectedSpareAction === "Trigger Billing Review" ? "contained" : "outlined"}
                                                sx={{
                                                    backgroundColor: selectedSpareAction === "Trigger Billing Review" ? '#001e5c' : 'transparent',
                                                    borderColor: '#cbd5e1',
                                                    color: selectedSpareAction === "Trigger Billing Review" ? '#fff' : '#0f172a',
                                                    fontSize: '11px', fontWeight: 600, textTransform: 'none', py: 0.75, justifyContent: 'center', boxShadow: 'none',
                                                    '&:hover': { backgroundColor: selectedSpareAction === "Trigger Billing Review" ? '#001e5c' : '#f8fafc' }
                                                }}
                                            >
                                                Trigger Billing Review
                                            </Button>

                                            <Button
                                                onClick={() => setSelectedSpareAction("Notify Inventory Owner")}
                                                variant={selectedSpareAction === "Notify Inventory Owner" ? "contained" : "outlined"}
                                                sx={{
                                                    backgroundColor: selectedSpareAction === "Notify Inventory Owner" ? '#001e5c' : 'transparent',
                                                    borderColor: '#cbd5e1',
                                                    color: selectedSpareAction === "Notify Inventory Owner" ? '#fff' : '#0f172a',
                                                    fontSize: '11px', fontWeight: 600, textTransform: 'none', py: 0.75, justifyContent: 'center', boxShadow: 'none',
                                                    '&:hover': { backgroundColor: selectedSpareAction === "Notify Inventory Owner" ? '#001e5c' : '#f8fafc' }
                                                }}
                                            >
                                                Notify Inventory Owner
                                            </Button>

                                            <Button
                                                onClick={() => setSelectedSpareAction("Mark as Reviewed")}
                                                variant={selectedSpareAction === "Mark as Reviewed" ? "contained" : "outlined"}
                                                sx={{
                                                    backgroundColor: selectedSpareAction === "Mark as Reviewed" ? '#001e5c' : 'transparent',
                                                    borderColor: '#cbd5e1',
                                                    color: selectedSpareAction === "Mark as Reviewed" ? '#fff' : '#0f172a',
                                                    fontSize: '11px', fontWeight: 600, textTransform: 'none', py: 0.75, justifyContent: 'center', boxShadow: 'none',
                                                    '&:hover': { backgroundColor: selectedSpareAction === "Mark as Reviewed" ? '#001e5c' : '#f8fafc' }
                                                }}
                                            >
                                                Mark as Reviewed
                                            </Button>
                                        </Box>

                                        {/* AI Suggestions (Middle) */}
                                        <Box sx={{ flex: 1.2, display: 'flex', flexDirection: 'column', gap: 1 }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
                                                <Chip label="Suggestion: Link spare consumption to CRM service order and review billing" size="small" sx={{ height: '22px', fontSize: '10px', fontWeight: 600, backgroundColor: '#e0e7ff', color: '#1e3a8a', borderRadius: '4px' }} />
                                            </Box>

                                            <Box sx={{ p: 1.5, border: '1px solid #166534', borderRadius: '6px', backgroundColor: '#fff', position: 'relative' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                                    <Icon name="smart_toy" sx={{ color: '#166534', fontSize: '16px' }} />
                                                    <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#166534' }}>AI ASSISTANT</Typography>
                                                </Box>
                                                <Typography sx={{ fontSize: '11px', color: '#475569', lineHeight: 1.5 }}>
                                                    Material document MAT-80002 has chargeable spare consumption of â‚¹0.18 L, but it is not linked to a CRM service order and is not billed. Link the material consumption to the correct CRM service order and trigger billing review to prevent margin leakage.
                                                </Typography>
                                            </Box>
                                        </Box>

                                        {/* Stakeholder Notifications (Right) */}
                                        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                                                <Typography sx={{ fontSize: '9px', fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Stakeholder Notifications</Typography>
                                                <Typography
                                                    onClick={() => setIsEmailExpandedDialogOpen(true)}
                                                    sx={{ fontSize: '10px', color: '#166534', fontWeight: 700, cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                                                >
                                                    Edit Content
                                                </Typography>
                                            </Box>
                                            <Box sx={{ border: '1px solid #e2e8f0', borderRadius: '6px', backgroundColor: '#f8fafc', p: 1.5, display: 'flex', flexDirection: 'column', gap: 1, flex: 1 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <Typography sx={{ fontSize: '10px', color: '#475569', width: '35px' }}>To:</Typography>
                                                    <Chip label={spareCommTo} size="small" sx={{ height: '20px', fontSize: '10px', fontWeight: 600, backgroundColor: '#e2e8f0', color: '#334155', borderRadius: '4px' }} />
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #e2e8f0', pb: 1 }}>
                                                    <Typography sx={{ fontSize: '10px', color: '#475569', width: '35px' }}>Subj:</Typography>
                                                    <Typography sx={{ fontSize: '11px', color: '#1e293b', fontWeight: 700, noWrap: true, textOverflow: 'ellipsis', overflow: 'hidden' }}>{spareCommSub}</Typography>
                                                </Box>
                                                <Box sx={{ mt: 0.5, flex: 1, position: 'relative' }}>
                                                    <Typography sx={{ fontSize: '10px', color: '#64748b', lineHeight: 1.5, display: '-webkit-box', WebkitLineClamp: 5, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                                        {spareCommBody}
                                                    </Typography>
                                                </Box>

                                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 'auto' }}>
                                                    <Button
                                                        variant="contained"
                                                        onClick={() => store.dispatch(showAlert("Email sent successfully", "success"))}
                                                        sx={{ backgroundColor: '#001e5c', color: '#fff', fontSize: '10px', fontWeight: 700, py: 0.5, px: 2, textTransform: 'none', '&:hover': { backgroundColor: '#001238' }, boxShadow: 'none', minWidth: 'auto' }}
                                                        endIcon={<Icon name="send" sx={{ fontSize: '12px' }} />}
                                                    >
                                                        SEND
                                                    </Button>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            )}

                            {title?.toLowerCase().includes("retrofit wip not settled") && (
                                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', gap: 2 }}>
                                    {/* Header */}
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pb: 1, borderBottom: '1px solid #e2e8f0' }}>
                                        <Typography sx={{ fontWeight: 800, fontSize: '14px', color: '#1e3a8a' }}>Retrofit WIP Not Settled â€“ Quick Actions</Typography>
                                    </Box>

                                    <Box sx={{ display: 'flex', gap: 2, flex: 1, minHeight: 0 }}>
                                        {/* Resolution Actions (Left) */}
                                        <Box sx={{ width: '220px', display: 'flex', flexDirection: 'column', gap: 1 }}>
                                            <Typography sx={{ fontSize: '9px', fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.05em', mb: 0.5 }}>Resolution Actions</Typography>

                                            <Button
                                                onClick={() => setSelectedRetrofitAction("Settle WIP")}
                                                variant={selectedRetrofitAction === "Settle WIP" ? "contained" : "outlined"}
                                                sx={{
                                                    backgroundColor: selectedRetrofitAction === "Settle WIP" ? '#001e5c' : 'transparent',
                                                    borderColor: '#cbd5e1',
                                                    color: selectedRetrofitAction === "Settle WIP" ? '#fff' : '#0f172a',
                                                    fontSize: '11px', fontWeight: 600, textTransform: 'none', py: 0.75, justifyContent: 'center', boxShadow: 'none',
                                                    '&:hover': { backgroundColor: selectedRetrofitAction === "Settle WIP" ? '#001e5c' : '#f8fafc' }
                                                }}
                                            >
                                                Settle WIP
                                            </Button>

                                            <Button
                                                onClick={() => setSelectedRetrofitAction("Validate Cost Allocation")}
                                                variant={selectedRetrofitAction === "Validate Cost Allocation" ? "contained" : "outlined"}
                                                sx={{
                                                    backgroundColor: selectedRetrofitAction === "Validate Cost Allocation" ? '#001e5c' : 'transparent',
                                                    borderColor: '#cbd5e1',
                                                    color: selectedRetrofitAction === "Validate Cost Allocation" ? '#fff' : '#0f172a',
                                                    fontSize: '11px', fontWeight: 600, textTransform: 'none', py: 0.75, justifyContent: 'center', boxShadow: 'none',
                                                    '&:hover': { backgroundColor: selectedRetrofitAction === "Validate Cost Allocation" ? '#001e5c' : '#f8fafc' }
                                                }}
                                            >
                                                Validate Cost Allocation
                                            </Button>

                                            <Button
                                                onClick={() => setSelectedRetrofitAction("Notify Project Finance")}
                                                variant={selectedRetrofitAction === "Notify Project Finance" ? "contained" : "outlined"}
                                                sx={{
                                                    backgroundColor: selectedRetrofitAction === "Notify Project Finance" ? '#001e5c' : 'transparent',
                                                    borderColor: '#cbd5e1',
                                                    color: selectedRetrofitAction === "Notify Project Finance" ? '#fff' : '#0f172a',
                                                    fontSize: '11px', fontWeight: 600, textTransform: 'none', py: 0.75, justifyContent: 'center', boxShadow: 'none',
                                                    '&:hover': { backgroundColor: selectedRetrofitAction === "Notify Project Finance" ? '#001e5c' : '#f8fafc' }
                                                }}
                                            >
                                                Notify Project Finance
                                            </Button>

                                            <Button
                                                onClick={() => setSelectedRetrofitAction("Mark as Reviewed")}
                                                variant={selectedRetrofitAction === "Mark as Reviewed" ? "contained" : "outlined"}
                                                sx={{
                                                    backgroundColor: selectedRetrofitAction === "Mark as Reviewed" ? '#001e5c' : 'transparent',
                                                    borderColor: '#cbd5e1',
                                                    color: selectedRetrofitAction === "Mark as Reviewed" ? '#fff' : '#0f172a',
                                                    fontSize: '11px', fontWeight: 600, textTransform: 'none', py: 0.75, justifyContent: 'center', boxShadow: 'none',
                                                    '&:hover': { backgroundColor: selectedRetrofitAction === "Mark as Reviewed" ? '#001e5c' : '#f8fafc' }
                                                }}
                                            >
                                                Mark as Reviewed
                                            </Button>
                                        </Box>

                                        {/* AI Suggestions & Account Entries (Middle) */}
                                        <Box sx={{ flex: 1.2, display: 'flex', flexDirection: 'column', gap: 1 }}>
                                            <Typography sx={{ fontSize: '9px', fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.05em', mb: 0.5 }}>AI Suggestions & Account Entries</Typography>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                                <Chip label="Suggestion: Settle retrofit WIP before period close" size="small" sx={{ height: '22px', fontSize: '10px', fontWeight: 600, backgroundColor: '#dcfce7', color: '#166534', borderRadius: '4px' }} />
                                            </Box>

                                            <Box sx={{ p: 1.5, border: '1px solid #166534', borderRadius: '6px', backgroundColor: '#fff', position: 'relative' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                                    <Icon name="smart_toy" sx={{ color: '#166534', fontSize: '16px' }} />
                                                    <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#166534' }}>AI ASSISTANT</Typography>
                                                </Box>
                                                <Typography sx={{ fontSize: '11px', color: '#475569', lineHeight: 1.5, mb: 2 }}>
                                                    Retrofit project RET-WIP-30001 is technically completed with WIP of â‚¹1.85 L, but settlement is pending. Settle WIP after validating cost allocation and project completion status.
                                                </Typography>
                                            </Box>

                                            <Box sx={{ border: '1px solid #e2e8f0', borderRadius: '6px', p: 1.5, backgroundColor: '#fff' }}>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                                                    <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#475569', textTransform: 'uppercase' }}>Suggested JE</Typography>
                                                    <Box sx={{ display: 'flex', gap: 1 }}>
                                                        <Chip label="Project Finance Approved" size="small" sx={{ height: '20px', fontSize: '9px', fontWeight: 600, backgroundColor: '#dcfce7', color: '#166534', borderRadius: '4px' }} />
                                                        <Chip label="Finance Mgr" size="small" sx={{ height: '20px', fontSize: '9px', fontWeight: 600, backgroundColor: '#f1f5f9', color: '#475569', borderRadius: '4px' }} />
                                                    </Box>
                                                </Box>

                                                <Typography sx={{ fontSize: '16px', fontWeight: 800, color: '#1e3a8a', mb: 1.5 }}>â‚¹1,85,000</Typography>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5, borderBottom: '1px solid #f1f5f9' }}>
                                                        <Typography sx={{ fontSize: '10px', color: '#475569' }}>DR Cost of Retrofit / Project Cost</Typography>
                                                        <Typography sx={{ fontSize: '10px', fontWeight: 600, color: '#475569' }}>â‚¹1,85,000</Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
                                                        <Typography sx={{ fontSize: '10px', color: '#475569' }}>CR Retrofit WIP</Typography>
                                                        <Typography sx={{ fontSize: '10px', fontWeight: 600, color: '#475569' }}>â‚¹1,85,000</Typography>
                                                    </Box>
                                                </Box>
                                                <Typography sx={{ fontSize: '9px', color: '#64748b', mt: 2, fontStyle: 'italic' }}>
                                                    Post WIP settlement entry only after validating technical completion, cost allocation status, and customer acceptance.
                                                </Typography>
                                            </Box>
                                        </Box>

                                        {/* Stakeholder Notifications (Right) */}
                                        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
                                            <Typography sx={{ fontSize: '9px', fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.05em', mb: 0.5 }}>Stakeholder Notifications</Typography>
                                            <Box sx={{ border: '1px solid #e2e8f0', borderRadius: '6px', backgroundColor: '#f8fafc', p: 1.5, display: 'flex', flexDirection: 'column', gap: 1, flex: 1 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <Typography sx={{ fontSize: '10px', color: '#475569', width: '50px' }}>To:</Typography>
                                                    <Typography sx={{ fontSize: '11px', color: '#1e293b', fontWeight: 500 }}>{retrofitCommTo}</Typography>
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <Typography sx={{ fontSize: '10px', color: '#475569', width: '50px' }}>Subject:</Typography>
                                                    <Typography sx={{ fontSize: '11px', color: '#1e293b', fontWeight: 500, noWrap: true, textOverflow: 'ellipsis', overflow: 'hidden' }}>{retrofitCommSub}</Typography>
                                                </Box>
                                                <Box sx={{ mt: 1, flex: 1, position: 'relative' }}>
                                                    <Typography sx={{ fontSize: '11px', color: '#475569', lineHeight: 1.5, display: '-webkit-box', WebkitLineClamp: 4, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                                        {retrofitCommBody}
                                                    </Typography>
                                                    <Typography
                                                        onClick={() => setIsEmailExpandedDialogOpen(true)}
                                                        sx={{ fontSize: '10px', color: '#2563eb', fontWeight: 600, cursor: 'pointer', mt: 1, display: 'inline-block', '&:hover': { textDecoration: 'underline' } }}
                                                    >
                                                        Edit Content
                                                    </Typography>
                                                </Box>

                                                <Button
                                                    variant="contained"
                                                    onClick={() => store.dispatch(showAlert("Email sent successfully", "success"))}
                                                    sx={{ mt: 'auto', backgroundColor: '#001e5c', color: '#fff', fontSize: '11px', fontWeight: 600, textTransform: 'none', '&:hover': { backgroundColor: '#001238' }, boxShadow: 'none' }}
                                                    endIcon={<Icon name="send" sx={{ fontSize: '14px' }} />}
                                                >
                                                    Send
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            )}

                            {title?.toLowerCase().includes("crm billing vs fi revenue mismatch") && (
                                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', gap: 2 }}>

                                    {/* Header */}
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1, borderBottom: '1px solid #e2e8f0' }}>
                                        <Typography sx={{ fontWeight: 800, fontSize: '14px', color: '#1e293b' }}>Revenue Mismatch â€“ Quick Actions</Typography>
                                        <Chip label="Suggestion: Reprocess CRM-FI interface and post missing revenue." size="small" sx={{ height: '24px', fontSize: '10px', fontWeight: 600, backgroundColor: '#3b82f6', color: '#ffffff' }} icon={<Icon name="lightbulb" sx={{ fontSize: '12px !important', color: '#ffffff !important' }} />} />
                                    </Box>

                                    {/* Body */}
                                    <Box sx={{ display: 'flex', gap: 3, flex: 1, overflowY: 'auto', minHeight: 0, pb: 1, mb: -1 }}>
                                        {/* Resolution Actions */}
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '220px', flexShrink: 0 }}>
                                            <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#64748b', mb: 0.5 }}>RESOLUTION ACTIONS</Typography>
                                            <Button onClick={() => setSelectedRevAction("Trigger FI Posting")} variant={selectedRevAction === "Trigger FI Posting" ? "contained" : "outlined"} sx={{ width: '100%', backgroundColor: selectedRevAction === "Trigger FI Posting" ? '#002868' : 'transparent', borderColor: '#cbd5e1', color: selectedRevAction === "Trigger FI Posting" ? '#fff' : '#0f172a', fontSize: '10px', fontWeight: 600, textTransform: 'none', py: 0.5, boxShadow: 'none' }}>Trigger FI Posting</Button>
                                            <Button onClick={() => setSelectedRevAction("Reprocess CRM-FI Interface")} variant={selectedRevAction === "Reprocess CRM-FI Interface" ? "contained" : "outlined"} sx={{ width: '100%', backgroundColor: selectedRevAction === "Reprocess CRM-FI Interface" ? '#002868' : 'transparent', borderColor: '#cbd5e1', color: selectedRevAction === "Reprocess CRM-FI Interface" ? '#fff' : '#0f172a', fontSize: '10px', fontWeight: 600, textTransform: 'none', py: 0.5, boxShadow: 'none' }}>Reprocess CRM-FI Interface</Button>
                                            <Button onClick={() => setSelectedRevAction("Notify Revenue Owner")} variant={selectedRevAction === "Notify Revenue Owner" ? "contained" : "outlined"} sx={{ width: '100%', backgroundColor: selectedRevAction === "Notify Revenue Owner" ? '#002868' : 'transparent', borderColor: '#cbd5e1', color: selectedRevAction === "Notify Revenue Owner" ? '#fff' : '#0f172a', fontSize: '10px', fontWeight: 600, textTransform: 'none', py: 0.5, boxShadow: 'none' }}>Notify Revenue Owner</Button>
                                            <Button onClick={() => setSelectedRevAction("Mark as Reviewed")} variant={selectedRevAction === "Mark as Reviewed" ? "contained" : "outlined"} sx={{ width: '100%', backgroundColor: selectedRevAction === "Mark as Reviewed" ? '#002868' : 'transparent', borderColor: '#cbd5e1', color: selectedRevAction === "Mark as Reviewed" ? '#fff' : '#0f172a', fontSize: '10px', fontWeight: 600, textTransform: 'none', py: 0.5, boxShadow: 'none' }}>Mark as Reviewed</Button>
                                        </Box>

                                        {/* Center Block (AI Assistant + JE) */}
                                        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, minWidth: '280px' }}>
                                            <Box sx={{ border: '1px solid #10b981', borderRadius: '4px', p: 1.5, display: 'flex', flexDirection: 'column', flex: 1, backgroundColor: '#ffffff' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
                                                    <Icon name="smart_toy" sx={{ fontSize: '14px', color: '#059669' }} />
                                                    <Typography sx={{ fontSize: '12px', fontWeight: 800, color: '#059669' }}>AI ASSISTANT</Typography>
                                                </Box>
                                                <Typography sx={{ fontSize: '11px', color: '#475569', lineHeight: 1.5, mb: 1.5, flex: 1 }}>
                                                    CRM billing document CRM-BILL-90002 is billed for â‚¹2.50 L, but FI revenue posted value is â‚¹0.<br /><br />
                                                    This creates a revenue close mismatch. Reprocess the CRM-FI interface or trigger FI posting after validation to resolve this discrepancy.
                                                </Typography>
                                                <Chip label="SUGGESTED ACTION READY" size="small" sx={{ width: 'fit-content', height: '22px', fontSize: '9px', fontWeight: 700, backgroundColor: '#a7f3d0', color: '#047857', borderRadius: '4px' }} icon={<Icon name="bolt" sx={{ fontSize: '12px !important', color: '#047857 !important' }} />} />
                                            </Box>
                                            <Box sx={{ border: '1px solid #e2e8f0', borderRadius: '4px', p: 1.5, backgroundColor: '#ffffff' }}>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                                                    <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase' }}>SUGGESTED JE</Typography>
                                                    <Chip label="APPROVED" size="small" sx={{ height: '20px', fontSize: '9px', fontWeight: 700, backgroundColor: '#a7f3d0', color: '#047857', borderRadius: '4px' }} />
                                                </Box>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5, pb: 1, borderBottom: '1px solid #e2e8f0' }}>
                                                    <Typography sx={{ fontSize: '12px', fontWeight: 800, color: '#1e293b' }}>Total Amount</Typography>
                                                    <Typography sx={{ fontSize: '12px', fontWeight: 800, color: '#1e3a8a' }}>â‚¹2,50,000</Typography>
                                                </Box>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <Typography sx={{ fontSize: '9px', fontWeight: 700, color: '#64748b' }}>Account</Typography>
                                                        <Typography sx={{ fontSize: '9px', fontWeight: 700, color: '#64748b' }}>Dr/Cr</Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', backgroundColor: '#f8fafc', p: 0.5, borderRadius: '4px' }}>
                                                        <Typography sx={{ fontSize: '10px', color: '#334155', fontWeight: 500 }}>Unbilled Revenue</Typography>
                                                        <Typography sx={{ fontSize: '10px', color: '#334155', fontWeight: 500 }}>â‚¹2.50L (D)</Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', backgroundColor: '#f8fafc', p: 0.5, borderRadius: '4px' }}>
                                                        <Typography sx={{ fontSize: '10px', color: '#334155', fontWeight: 500 }}>Retrofit Revenue</Typography>
                                                        <Typography sx={{ fontSize: '10px', color: '#334155', fontWeight: 500 }}>â‚¹2.50L (C)</Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>

                                        {/* Stakeholder Notifications */}
                                        <Box sx={{ flex: 1.2, display: 'flex', flexDirection: 'column', minWidth: '300px' }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                                <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#64748b' }}>STAKEHOLDER NOTIFICATIONS</Typography>
                                                <Typography sx={{ fontSize: '11px', fontWeight: 600, color: '#2563eb', cursor: 'pointer' }} onClick={() => setIsEmailExpandedDialogOpen(true)}>Edit Content</Typography>
                                            </Box>
                                            <Box sx={{ border: '1px solid #e2e8f0', borderRadius: '4px', p: 1.5, display: 'flex', flexDirection: 'column', gap: 1, height: '100%', backgroundColor: '#ffffff' }}>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                                                        <Typography sx={{ fontSize: '11px', color: '#94a3b8' }}>To:</Typography>
                                                        <Chip label={revCommTo} size="small" sx={{ height: '20px', fontSize: '10px', backgroundColor: '#f1f5f9', color: '#475569', borderRadius: '4px' }} />
                                                    </Box>
                                                    <Button variant="contained" size="small" onClick={() => { store.dispatch(showAlert("Email sent successfully", "success")); }} sx={{ backgroundColor: '#002868', color: '#fff', fontSize: '10px', fontWeight: 600, textTransform: 'none', py: 0.25, minWidth: '70px', boxShadow: 'none' }}><Icon name="send" sx={{ fontSize: '12px', mr: 0.5 }} /> Send</Button>
                                                </Box>
                                                <React.Fragment>
                                                    <Typography sx={{ fontSize: '11px', fontWeight: 800, color: '#0f172a' }}>Subj: {revCommSub}</Typography>
                                                    <Typography sx={{ fontSize: '11px', color: '#64748b', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>
                                                        {revCommBody}
                                                    </Typography>
                                                </React.Fragment>
                                            </Box>
                                        </Box>
                                    </Box>

                                    {/* Footer buttons pinned to bottom */}
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', pt: 1, mt: 'auto', borderTop: '1px solid #e2e8f0', mx: -3, px: 3, mb: -1, pb: 1, flexShrink: 0, gap: 3 }}>
                                        <Typography sx={{ fontSize: '12px', fontWeight: 600, color: '#475569', cursor: 'pointer', '&:hover': { color: '#0f172a' } }} onClick={() => setIsFooterOpen(false)}>Close</Typography>
                                        <Button variant="contained" onClick={() => { store.dispatch(showAlert("successfully saved", "success")); onClose(); }} sx={{ backgroundColor: '#003d9b', color: '#fff', fontWeight: 600, fontSize: '11px', textTransform: 'none', py: 0.75, px: 3, borderRadius: '4px', boxShadow: 'none' }}>Save Action</Button>
                                    </Box>
                                </Box>
                            )}

                            {title?.toLowerCase().includes("deferred revenue mismatch") && (
                                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', gap: 2 }}>
                                    {/* Header */}
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1, borderBottom: '1px solid #e2e8f0' }}>
                                        <Typography sx={{ fontWeight: 800, fontSize: '14px', color: '#1e3a8a' }}>Deferred Revenue - Quick Actions</Typography>
                                        <Chip label="Suggestion: Run AMC revenue recognition for Apr-2026" size="small" sx={{ height: '24px', fontSize: '10px', fontWeight: 600, backgroundColor: '#a7f3d0', color: '#047857' }} icon={<Icon name="lightbulb" sx={{ fontSize: '12px !important', color: '#047857 !important' }} />} />
                                    </Box>

                                    <Box sx={{ display: 'flex', gap: 2, flex: 1, minHeight: 0 }}>
                                        {/* Resolution Actions (Left) */}
                                        <Box sx={{ width: '220px', display: 'flex', flexDirection: 'column', gap: 1 }}>
                                            <Typography sx={{ fontSize: '9px', fontWeight: 700, color: '#475569', mb: 0.5 }}>Resolution Actions</Typography>

                                            <Button
                                                onClick={() => setSelectedDeferredAction("Run Revenue Recognition")}
                                                variant={selectedDeferredAction === "Run Revenue Recognition" ? "contained" : "outlined"}
                                                sx={{
                                                    backgroundColor: selectedDeferredAction === "Run Revenue Recognition" ? '#001e5c' : 'transparent',
                                                    borderColor: '#cbd5e1',
                                                    color: selectedDeferredAction === "Run Revenue Recognition" ? '#fff' : '#0f172a',
                                                    fontSize: '11px', fontWeight: 600, textTransform: 'none', py: 0.75, justifyContent: 'space-between', boxShadow: 'none',
                                                    '&:hover': { backgroundColor: selectedDeferredAction === "Run Revenue Recognition" ? '#001e5c' : '#f8fafc' }
                                                }}
                                                endIcon={selectedDeferredAction === "Run Revenue Recognition" ? <Icon name="play_arrow" sx={{ fontSize: '14px' }} /> : null}
                                            >
                                                Run Revenue Recognition
                                            </Button>

                                            <Button
                                                onClick={() => setSelectedDeferredAction("Validate Contract Period")}
                                                variant={selectedDeferredAction === "Validate Contract Period" ? "contained" : "outlined"}
                                                sx={{
                                                    backgroundColor: selectedDeferredAction === "Validate Contract Period" ? '#001e5c' : 'transparent',
                                                    borderColor: '#cbd5e1',
                                                    color: selectedDeferredAction === "Validate Contract Period" ? '#fff' : '#0f172a',
                                                    fontSize: '11px', fontWeight: 600, textTransform: 'none', py: 0.75, justifyContent: 'flex-start', boxShadow: 'none',
                                                    '&:hover': { backgroundColor: selectedDeferredAction === "Validate Contract Period" ? '#001e5c' : '#f8fafc' }
                                                }}
                                            >
                                                Validate Contract Period
                                            </Button>

                                            <Button
                                                onClick={() => setSelectedDeferredAction("Notify Revenue Owner")}
                                                variant={selectedDeferredAction === "Notify Revenue Owner" ? "contained" : "outlined"}
                                                sx={{
                                                    backgroundColor: selectedDeferredAction === "Notify Revenue Owner" ? '#001e5c' : 'transparent',
                                                    borderColor: '#cbd5e1',
                                                    color: selectedDeferredAction === "Notify Revenue Owner" ? '#fff' : '#0f172a',
                                                    fontSize: '11px', fontWeight: 600, textTransform: 'none', py: 0.75, justifyContent: 'flex-start', boxShadow: 'none',
                                                    '&:hover': { backgroundColor: selectedDeferredAction === "Notify Revenue Owner" ? '#001e5c' : '#f8fafc' }
                                                }}
                                            >
                                                Notify Revenue Owner
                                            </Button>

                                            <Button
                                                onClick={() => setSelectedDeferredAction("Mark as Reviewed")}
                                                variant={selectedDeferredAction === "Mark as Reviewed" ? "contained" : "outlined"}
                                                sx={{
                                                    backgroundColor: selectedDeferredAction === "Mark as Reviewed" ? '#001e5c' : 'transparent',
                                                    borderColor: '#cbd5e1',
                                                    color: selectedDeferredAction === "Mark as Reviewed" ? '#fff' : '#0f172a',
                                                    fontSize: '11px', fontWeight: 600, textTransform: 'none', py: 0.75, justifyContent: 'flex-start', boxShadow: 'none',
                                                    '&:hover': { backgroundColor: selectedDeferredAction === "Mark as Reviewed" ? '#001e5c' : '#f8fafc' }
                                                }}
                                            >
                                                Mark as Reviewed
                                            </Button>
                                        </Box>

                                        {/* AI Suggestions & Account Entries (Middle) */}
                                        <Box sx={{ flex: 1.2, display: 'flex', flexDirection: 'column', gap: 1 }}>
                                            <Box sx={{ p: 1.5, border: '1px solid #10b981', borderRadius: '6px', backgroundColor: '#fff', position: 'relative' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                                    <Icon name="auto_awesome" sx={{ color: '#059669', fontSize: '16px' }} />
                                                    <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#059669' }}>AI ASSISTANT</Typography>
                                                </Box>
                                                <Typography sx={{ fontSize: '11px', color: '#475569', lineHeight: 1.5 }}>
                                                    AMC contract AMC-10001 has deferred revenue of â‚¹1.20 L, but monthly revenue recognition of â‚¹0.10 L is pending for Apr-2026. Run revenue recognition after validating contract period and billing status.
                                                </Typography>
                                            </Box>

                                            <Box sx={{ border: '1px solid #e2e8f0', borderRadius: '6px', p: 1.5, backgroundColor: '#fff', mt: 1 }}>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                                                    <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#475569', textTransform: 'uppercase' }}>SUGGESTED JE</Typography>
                                                    <Typography sx={{ fontSize: '16px', fontWeight: 800, color: '#10b981' }}>â‚¹10,000</Typography>
                                                </Box>

                                                <Box sx={{ display: 'flex', gap: 1, mb: 1.5 }}>
                                                    <Chip label="Revenue Owner Approved" size="small" sx={{ height: '20px', fontSize: '9px', fontWeight: 600, backgroundColor: '#f1f5f9', color: '#475569', borderRadius: '4px' }} />
                                                    <Chip label="Finance Mgr" size="small" sx={{ height: '20px', fontSize: '9px', fontWeight: 600, backgroundColor: '#f1f5f9', color: '#475569', borderRadius: '4px' }} />
                                                </Box>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5, borderBottom: '1px solid #f1f5f9' }}>
                                                        <Typography sx={{ fontSize: '10px', color: '#475569' }}>DR Deferred Revenue</Typography>
                                                        <Typography sx={{ fontSize: '10px', fontWeight: 600, color: '#475569' }}>â‚¹10,000</Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
                                                        <Typography sx={{ fontSize: '10px', color: '#475569' }}>CR AMC Revenue</Typography>
                                                        <Typography sx={{ fontSize: '10px', fontWeight: 600, color: '#475569' }}>â‚¹10,000</Typography>
                                                    </Box>
                                                </Box>
                                                <Typography sx={{ fontSize: '9px', color: '#64748b', mt: 2 }}>
                                                    * Post revenue recognition entry only after validating AMC contract period, billing status, and service eligibility.
                                                </Typography>
                                            </Box>
                                        </Box>

                                        {/* Stakeholder Notifications (Right) */}
                                        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                                                <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#1e3a8a' }}>Stakeholder Notifications</Typography>
                                                <Typography
                                                    onClick={() => setIsEmailExpandedDialogOpen(true)}
                                                    sx={{ fontSize: '10px', color: '#2563eb', fontWeight: 600, cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                                                >
                                                    Edit Content
                                                </Typography>
                                            </Box>
                                            <Box sx={{ border: '1px solid #e2e8f0', borderRadius: '6px', backgroundColor: '#f8fafc', p: 1.5, display: 'flex', flexDirection: 'column', gap: 1, flex: 1 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <Typography sx={{ fontSize: '10px', color: '#475569', width: '35px' }}>TO</Typography>
                                                    <Chip label={deferredCommTo} size="small" sx={{ height: '22px', fontSize: '10px', fontWeight: 500, backgroundColor: '#fff', border: '1px solid #e2e8f0', color: '#334155', borderRadius: '4px', flex: 1, justifyContent: 'flex-start' }} />
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
                                                    <Typography sx={{ fontSize: '10px', color: '#475569', width: '35px' }}>SUBJECT</Typography>
                                                    <Chip label={deferredCommSub} size="small" sx={{ height: '22px', fontSize: '10px', fontWeight: 500, backgroundColor: '#fff', border: '1px solid #e2e8f0', color: '#334155', borderRadius: '4px', flex: 1, justifyContent: 'flex-start' }} />
                                                </Box>
                                                <Box sx={{ mt: 1, flex: 1, position: 'relative' }}>
                                                    <Typography sx={{ fontSize: '10px', color: '#475569', mb: 0.5 }}>BODY</Typography>
                                                    <Box sx={{ backgroundColor: '#fff', border: '1px solid #e2e8f0', borderRadius: '4px', p: 1 }}>
                                                        <Typography sx={{ fontSize: '10px', color: '#334155', lineHeight: 1.4 }}>
                                                            {deferredCommBody}
                                                        </Typography>
                                                    </Box>
                                                </Box>

                                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 'auto' }}>
                                                    <Button
                                                        variant="contained"
                                                        onClick={() => store.dispatch(showAlert("Email sent successfully", "success"))}
                                                        sx={{ backgroundColor: '#001e5c', color: '#fff', fontSize: '11px', fontWeight: 600, py: 0.5, px: 2, textTransform: 'none', '&:hover': { backgroundColor: '#001238' }, boxShadow: 'none', minWidth: 'auto' }}
                                                        endIcon={<Icon name="send" sx={{ fontSize: '14px' }} />}
                                                    >
                                                        Send
                                                    </Button>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            )}
                        </Box>  {/* closes inner footer content Box */}
                    </Box>  {/* closes outer slide wrapper Box */}
                </Box>  {/* closes Left Side */}

                {/* Right Side: Chat Partition */}
                {isChatOpen && (
                    <Box sx={{ display: "flex" }}>
                        <ChatSection isOpen={true} isEmbedded={true} subTitle={data?.title || ""} parentTitle={parentTitle} additionalMessages={approvalMessages} />
                    </Box>
                )}
            </Box>

            {/* Tag Assignment Expand Dialog */}
            <Dialog open={isTagAssignmentDialogOpen} onClose={() => setIsTagAssignmentDialogOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#1e293b' }}>Tag Assignments</Typography>
                    <IconButton onClick={() => setIsTagAssignmentDialogOpen(false)} size="small">
                        <Icon name="close" sx={{ fontSize: '18px' }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                        <Button size="small" variant="outlined" onClick={() => setTagRows([...tagRows, { id: Date.now(), productId: "PRD-1001", employeeRef: "John Doe - EMP123", assetsLocation: "Mumbai", costCenter: "CC-IT", tagUpdate: "Update Asset Tag", ownership: "Update Responsible Person", validation: "Verification Action" }])} startIcon={<Icon name="add" sx={{ fontSize: '14px' }} />} sx={{ fontSize: '12px', textTransform: 'none' }}>Add Row</Button>
                    </Box>
                    <TableContainer component={Paper} variant="outlined">
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontSize: '12px', fontWeight: 700 }}>Product ID</TableCell>
                                    <TableCell sx={{ fontSize: '12px', fontWeight: 700 }}>Employee Ref</TableCell>
                                    <TableCell sx={{ fontSize: '12px', fontWeight: 700 }}>Assets Location</TableCell>
                                    <TableCell sx={{ fontSize: '12px', fontWeight: 700 }}>Cost Center</TableCell>
                                    <TableCell sx={{ fontSize: '12px', fontWeight: 700 }}>Tag Update</TableCell>
                                    <TableCell sx={{ fontSize: '12px', fontWeight: 700 }}>Ownership</TableCell>
                                    <TableCell sx={{ fontSize: '12px', fontWeight: 700 }}>Validation</TableCell>
                                    <TableCell sx={{ fontSize: '12px', fontWeight: 700 }} align="center">Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tagRows.map((row) => (
                                    <TableRow key={row.id}>
                                        <TableCell>
                                            <select value={row.productId} onChange={(e) => setTagRows(tagRows.map(r => r.id === row.id ? { ...r, productId: e.target.value } : r))} style={{ fontSize: '12px', width: '100%', padding: '6px', borderRadius: '4px', border: '1px solid #cbd5e1' }}>
                                                <option value="PRD-1001">PRD-1001</option>
                                                <option value="PRD-1002">PRD-1002</option>
                                                <option value="PRD-1003">PRD-1003</option>
                                                <option value="PRD-1004">PRD-1004</option>
                                            </select>
                                        </TableCell>
                                        <TableCell>
                                            <select value={row.employeeRef} onChange={(e) => setTagRows(tagRows.map(r => r.id === row.id ? { ...r, employeeRef: e.target.value } : r))} style={{ fontSize: '12px', width: '100%', padding: '6px', borderRadius: '4px', border: '1px solid #cbd5e1' }}>
                                                <option value="John Doe - EMP123">John Doe - EMP123</option>
                                                <option value="Jane Smith - EMP124">Jane Smith - EMP124</option>
                                                <option value="Alice Johnson - EMP125">Alice Johnson - EMP125</option>
                                                <option value="Bob Brown - EMP126">Bob Brown - EMP126</option>
                                            </select>
                                        </TableCell>
                                        <TableCell>
                                            <select value={row.assetsLocation} onChange={(e) => setTagRows(tagRows.map(r => r.id === row.id ? { ...r, assetsLocation: e.target.value } : r))} style={{ fontSize: '12px', width: '100%', padding: '6px', borderRadius: '4px', border: '1px solid #cbd5e1' }}>
                                                <option value="Mumbai">Mumbai</option>
                                                <option value="Delhi">Delhi</option>
                                                <option value="Bangalore">Bangalore</option>
                                                <option value="Chennai">Chennai</option>
                                            </select>
                                        </TableCell>
                                        <TableCell>
                                            <select value={row.costCenter} onChange={(e) => setTagRows(tagRows.map(r => r.id === row.id ? { ...r, costCenter: e.target.value } : r))} style={{ fontSize: '12px', width: '100%', padding: '6px', borderRadius: '4px', border: '1px solid #cbd5e1' }}>
                                                <option value="CC-IT">CC-IT</option>
                                                <option value="CC-HR">CC-HR</option>
                                                <option value="CC-FIN">CC-FIN</option>
                                                <option value="CC-SALES">CC-SALES</option>
                                            </select>
                                        </TableCell>
                                        <TableCell>
                                            <select value={row.tagUpdate} onChange={(e) => setTagRows(tagRows.map(r => r.id === row.id ? { ...r, tagUpdate: e.target.value } : r))} style={{ fontSize: '12px', width: '100%', padding: '6px', borderRadius: '4px', border: '1px solid #cbd5e1' }}>
                                                <option value="Update Asset Tag">Update Asset Tag</option>
                                                <option value="Enter Tag Number">Enter Tag Number</option>
                                                <option value="Validate Tag">Validate Tag</option>
                                                <option value="Reassign Tag">Reassign Tag</option>
                                                <option value="Tag Pending">Tag Pending</option>
                                                <option value="Tag Confirmed">Tag Confirmed</option>
                                            </select>
                                        </TableCell>
                                        <TableCell>
                                            <select value={row.ownership} onChange={(e) => setTagRows(tagRows.map(r => r.id === row.id ? { ...r, ownership: e.target.value } : r))} style={{ fontSize: '12px', width: '100%', padding: '6px', borderRadius: '4px', border: '1px solid #cbd5e1' }}>
                                                <option value="Update Responsible Person">Update Responsible Person</option>
                                                <option value="Assign Asset Owner">Assign Asset Owner</option>
                                                <option value="Assign FA Accountant">Assign FA Accountant</option>
                                                <option value="Update Custodian">Update Custodian</option>
                                                <option value="Update Cost Center Owner">Update Cost Center Owner</option>
                                                <option value="Owner Confirmation Pending">Owner Confirmation Pending</option>
                                            </select>
                                        </TableCell>
                                        <TableCell>
                                            <select value={row.validation} onChange={(e) => setTagRows(tagRows.map(r => r.id === row.id ? { ...r, validation: e.target.value } : r))} style={{ fontSize: '12px', width: '100%', padding: '6px', borderRadius: '4px', border: '1px solid #cbd5e1' }}>
                                                <option value="Verification Action">Verification Action</option>
                                                <option value="Confirm Physical Existence">Confirm Physical Existence</option>
                                                <option value="Validate Asset Location">Validate Asset Location</option>
                                                <option value="Review Master Data">Review Master Data</option>
                                                <option value="Mark as Reviewed">Mark as Reviewed</option>
                                                <option value="Escalate for Clarification">Escalate for Clarification</option>
                                            </select>
                                        </TableCell>
                                        <TableCell align="center">
                                            <IconButton size="small" onClick={() => setTagRows(tagRows.filter(r => r.id !== row.id))} sx={{ color: '#ef4444' }}>
                                                <Icon name="close" sx={{ fontSize: '16px' }} />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
            </Dialog>

            {/* Email Expand Dialog */}
            <Dialog open={isEmailExpandedDialogOpen} onClose={() => setIsEmailExpandedDialogOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#1e293b' }}>Email Content</Typography>
                    <IconButton onClick={() => setIsEmailExpandedDialogOpen(false)} size="small">
                        <Icon name="close" sx={{ fontSize: '18px' }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    {(() => {
                        let to = "", sub = "", body = "";
                        let setTo = () => { }, setSub = () => { }, setBody = () => { };
                        const lowerTitle = title?.toLowerCase() || "";
                        if (lowerTitle === "asset addition not tagged") {
                            to = commTo; sub = commSub; body = commBody;
                            setTo = setCommTo; setSub = setCommSub; setBody = setCommBody;
                        } else if (lowerTitle === "depreciation not ready") {
                            to = depCommTo; sub = depCommSub; body = depCommBody;
                            setTo = setDepCommTo; setSub = setDepCommSub; setBody = setDepCommBody;
                        } else if (lowerTitle.includes("pending capitalization")) {
                            to = retCommTo; sub = retCommSub; body = retCommBody;
                            setTo = setRetCommTo; setSub = setRetCommSub; setBody = setRetCommBody;
                        } else if (lowerTitle.includes("retirement pending")) {
                            to = retPendingCommTo; sub = retPendingCommSub; body = retPendingCommBody;
                            setTo = setRetPendingCommTo; setSub = setRetPendingCommSub; setBody = setRetPendingCommBody;
                        } else if (lowerTitle.includes("cwip ageing above threshold")) {
                            to = cwipCommTo; sub = cwipCommSub; body = cwipCommBody;
                            setTo = setCwipCommTo; setSub = setCwipCommSub; setBody = setCwipCommBody;
                        } else if (lowerTitle.includes("service confirmation pending")) {
                            to = serviceCommTo; sub = serviceCommSub; body = serviceCommBody;
                            setTo = setServiceCommTo; setSub = setServiceCommSub; setBody = setServiceCommBody;
                        } else if (lowerTitle.includes("crm billing vs fi revenue mismatch")) {
                            to = revCommTo; sub = revCommSub; body = revCommBody;
                            setTo = setRevCommTo; setSub = setRevCommSub; setBody = setRevCommBody;
                        } else if (lowerTitle.includes("retrofit wip not settled")) {
                            to = retrofitCommTo; sub = retrofitCommSub; body = retrofitCommBody;
                            setTo = setRetrofitCommTo; setSub = setRetrofitCommSub; setBody = setRetrofitCommBody;
                        } else if (lowerTitle.includes("spare consumption not linked")) {
                            to = spareCommTo; sub = spareCommSub; body = spareCommBody;
                            setTo = setSpareCommTo; setSub = setSpareCommSub; setBody = setSpareCommBody;
                        }

                        return (
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography sx={{ fontWeight: 700, fontSize: '12px', width: '40px' }}>To:</Typography>
                                    <input value={to} onChange={(e) => setTo(e.target.value)} style={{ flex: 1, fontSize: '12px', padding: '6px 8px', border: '1px solid #cbd5e1', borderRadius: '4px' }} />
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography sx={{ fontWeight: 700, fontSize: '12px', width: '40px' }}>Sub:</Typography>
                                    <input value={sub} onChange={(e) => setSub(e.target.value)} style={{ flex: 1, fontSize: '12px', padding: '6px 8px', border: '1px solid #cbd5e1', borderRadius: '4px' }} />
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                    <Typography sx={{ fontWeight: 700, fontSize: '12px' }}>Body:</Typography>
                                    <textarea value={body} onChange={(e) => setBody(e.target.value)} style={{ width: '100%', boxSizing: 'border-box', fontSize: '12px', padding: '8px', border: '1px solid #cbd5e1', borderRadius: '4px', resize: 'vertical', fontFamily: 'inherit', minHeight: '150px' }} rows={8} />
                                </Box>
                            </Box>
                        );
                    })()}
                </DialogContent>
                <DialogActions sx={{ p: 2, borderTop: '1px solid #e2e8f0', backgroundColor: '#f8fafc' }}>
                    <Button onClick={() => setIsEmailExpandedDialogOpen(false)} sx={{ fontSize: '12px', color: '#475569', textTransform: 'none', fontWeight: 600 }}>Cancel</Button>
                    <Button onClick={() => { setIsEmailExpandedDialogOpen(false); store.dispatch(showAlert("Email send successfully", "success")); }} variant="contained" sx={{ backgroundColor: '#003d9b', color: '#fff', fontSize: '12px', fontWeight: 600, px: 3, textTransform: 'none', '&:hover': { backgroundColor: '#002868' }, boxShadow: 'none' }}>
                        Send Email
                    </Button>
                </DialogActions>
            </Dialog>
        </Dialog>
    );
}


/** Aggregated summary for collapsed card state */
function CardSummary({ rows, onNoIssueClick, onModerateClick, onBlockerClick }) {
    const totalNoIssues = rows.reduce((acc, r) => acc + (r.noIssues || 0), 0);
    const totalModerate = rows.reduce((acc, r) => acc + (r.moderate || 0), 0);
    const totalBlocker = rows.reduce((acc, r) => acc + (r.blocker || 0), 0);
    const total = totalNoIssues + totalModerate + totalBlocker || 1;

    return (
        <Box sx={{ p: 1.5 }}>
            <Stack direction="row" spacing={1} mb={2}>
                {[
                    { label: "No issues", value: totalNoIssues, bg: "#e8f5e9", border: "#c8e6c9", text: "#2e7d32", onClick: onNoIssueClick },
                    { label: "Moderate", value: totalModerate, bg: "#fff4e5", border: "#ffe0b2", text: "#663d00", onClick: onModerateClick },
                    { label: "Blocker", value: totalBlocker, bg: "#ffdad6", border: "#ffcdd2", text: "#ba1a1a", onClick: onBlockerClick }
                ].map((item, idx) => (
                    <Box
                        key={idx}
                        onClick={(e) => {
                            if (item.onClick) {
                                e.stopPropagation();
                                item.onClick();
                            }
                        }}
                        sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            p: 1,
                            borderRadius: "4px",
                            backgroundColor: item.bg,
                            border: `1px solid ${item.border} `,
                            cursor: item.onClick ? "pointer" : "default",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            "&:hover": item.onClick ? {
                                transform: "translateY(-1px)",
                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                                filter: "brightness(0.97)"
                            } : {},
                            "&:active": item.onClick ? {
                                transform: "scale(0.96)"
                            } : {}
                        }}
                    >
                        <Typography sx={{ fontSize: "8.5px", fontWeight: 700, color: item.text, textTransform: "uppercase", letterSpacing: "0.05em", textAlign: "center" }}>{item.label}</Typography>
                        <Typography sx={{ fontFamily: "'IBM Plex Sans', monospace", fontSize: "14px", color: item.text, fontWeight: 700, mt: 0.5, lineHeight: 1 }}>{item.value}</Typography>
                    </Box>
                ))}
            </Stack>
            <Box sx={{ width: "100%", height: 8, backgroundColor: "#ebeef1", borderRadius: "999px", display: "flex", overflow: "hidden" }}>
                <Box sx={{ width: `${(totalNoIssues / total) * 100}% `, backgroundColor: "#2e7d32", transition: "all 0.3s" }} />
                <Box sx={{ width: `${(totalModerate / total) * 100}% `, backgroundColor: "#ed6c02", transition: "all 0.3s" }} />
                <Box sx={{ width: `${(totalBlocker / total) * 100}% `, backgroundColor: "#d32f2f", transition: "all 0.3s" }} />
            </Box>
        </Box>
    );
}

/** Shared card header for all 9 cockpit cards */
function CardHeader({ title, icon, colorClass, borderClass, isExpanded, onToggle, onDownload }) {
    return (
        <Box sx={{ p: 1, display: "flex", alignItems: "center", justifyContent: "space-between", borderLeft: "4px solid", borderColor: "currentColor", color: colorClass }}>
            <Typography sx={{ fontSize: "12px", fontWeight: 700, display: "flex", alignItems: "center" }}>
                <Icon name={icon} sx={{ fontSize: "18px", mr: 1 }} />
                {title}
            </Typography>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ color: "#737685" }}>
                <IconButton size="small" onClick={onToggle} sx={{ color: "inherit", p: 0.5 }}>
                    <Icon name={isExpanded ? "unfold_less" : "unfold_more"} sx={{ fontSize: "14px" }} />
                </IconButton>
                <IconButton size="small" onClick={onDownload} sx={{ color: "inherit", p: 0.5 }}>
                    <Icon name="download" sx={{ fontSize: "14px" }} />
                </IconButton>
                <IconButton size="small" sx={{ color: "inherit", p: 0.5 }}>
                    <Icon name="more_vert" sx={{ fontSize: "14px" }} />
                </IconButton>
            </Stack>
        </Box>
    );
}

/* â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
   ROLES & RESPONSIBILITIES VIEW
â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */

const DOMAIN_DATA = {
    "Core Finance": {
        "General Ledger": [
            "Unposted Journal Count",
            "Open Journal Count",
            "Suspense Balance Value",
            "Trial Balance Difference Value",
            "Backdated Posting Count",
            "Reversal Pending Count"
        ],
        "Accounts Payable": [
            "Open Invoice Count",
            "Blocked Invoice Count",
            "Due / Overdue Payable Value",
            "GR/IR Pending Value",
            "Vendor Advance Unadjusted Value",
            "Duplicate Invoice Risk Count"
        ],
        "Accounts Receivable": [
            "Overdue Invoice Count",
            "Overdue AR Value",
            "Collection Pending Value",
            "Billing Block Count",
            "Unapplied Receipt Count",
            "Customer Dispute Count"
        ],
        "Fixed Assets": [
            "Pending Capitalization Count",
            "Depreciation Not Ready Count",
            "Retirement Pending Count",
            "Asset Addition Not Tagged Count",
            "CWIP Ageing Above Threshold Value"
        ],
        "Bank & Cash": [
            "Bank Reconciliation Pending Count",
            "Unmatched Bank Transaction Count",
            "Unmatched Bank Transaction Value",
            "Book vs Bank Balance Difference Value",
            "Open Payment / Receipt Clearing Count"
        ]
    },
    "Financial Planning": {
        "Revenue Budget Preparation": [
            "Revenue Budget Input Pending Count",
            "Revenue Budget Draft Pending Count",
            "Revenue Assumption Gap Count"
        ],
        "Revenue Budget Review": [
            "Revenue Budget Review Pending Count",
            "Revenue Budget Approval Pending Count",
            "Revenue Budget Variance %"
        ],
        "P&L Budget Preparation": [
            "Cost Input Pending Count",
            "Revenue Input Pending Count",
            "Budget Version Pending Count"
        ],
        "P&L Budget Review": [
            "P&L Budget Review Pending Count",
            "Review Comment Open Count",
            "P&L Budget Variance %"
        ],
        "P&L Budget Submission": [
            "Submission Pending Count",
            "Rejected Submission Count",
            "Final Approval Pending Count"
        ],
        "Revenue Re-forecast": [
            "Revenue Reforecast Pending Count",
            "Revenue Forecast Variance Value",
            "Forecast Accuracy Gap %"
        ],
        "P&L Re-forecast": [
            "P&L Reforecast Pending Count",
            "P&L Forecast Variance Value",
            "Margin Variance %"
        ],
        "Final Budget / Forecast Sign-off": [
            "Final Sign-off Pending Count",
            "Sign-off Exception Count"
        ]
    },
    "General Accounting": {
        "MDM & COA Readiness": [
            "Master Data Error Count",
            "COA Pending Change Count",
            "COA Readiness Gap Count"
        ],
        "Subledger Close": [
            "AP Subledger Close Pending Count",
            "AR Subledger Close Pending Count",
            "Subledger vs GL Difference Value"
        ],
        "Allocations": [
            "Allocation Run Pending Count",
            "Allocation Error Count",
            "Allocation Pending Value"
        ],
        "Revenue Review": [
            "Revenue Feed Exception Count",
            "Revenue Accrual Pending Value",
            "Deferred Revenue Difference Value"
        ],
        "Accrual Journals": [
            "Accrual JV Pending Count",
            "Accrual JV Pending Value",
            "Accrual Reversal Pending Count"
        ],
        "Provision Journals": [
            "Provision JV Pending Count",
            "Provision Pending Value",
            "Provision Approval Pending Count"
        ],
        "Tax Provision Journals": [
            "Tax Provision JV Pending Count",
            "Tax Provision Pending Value",
            "Tax Review Exception Count"
        ],
        "Manual Allocations": [
            "Manual Allocation Pending Count",
            "Manual Allocation Approval Pending Count",
            "Manual Allocation Exception Count"
        ],
        "Reclass & Recharge Journals": [
            "Reclass Pending Count",
            "Recharge Pending Count",
            "Reclass / Recharge Approval Pending Count"
        ],
        "Other Manual Journals": [
            "Other JV Pending Count",
            "High Risk JV Count",
            "JV Approval Pending Count"
        ],
        "P&L Preparation": [
            "P&L Preparation Pending Count",
            "P&L Variance Count",
            "Adjustment Pending Count"
        ],
        "P&L Review": [
            "P&L Review Pending Count",
            "Review Comment Open Count",
            "Unresolved Variance Count"
        ],
        "Month-End Close Monitoring": [
            "Close Task Pending Count",
            "Close Task SLA Breach Count",
            "Critical Open Item Count"
        ]
    },
    "Intelligence & Risk": {
        "Anomaly Detection": [
            "Anomaly Detected Count",
            "Critical Anomaly Count",
            "High-Value Anomaly Amount",
            "Duplicate Transaction Risk Count",
            "Unusual Posting Pattern Count"
        ],
        "Finance Recovery": [
            "Recovery Opportunity Count",
            "Recovery Opportunity Value",
            "Recovery Action Pending Count",
            "Realization Gap Value",
            "Recovery SLA Breach Count"
        ],
        "Audit Trail": [
            "Manual Touch Count",
            "Unauthorized Change Count",
            "Missing Approval Trail Count",
            "Backdated Change Count",
            "Critical Audit Exception Count"
        ]
    },
    "Intercompany Finance": {
        "AR Billing": [
            "Billing Pending Count",
            "Billing Pending Value",
            "Billing Exception Count",
            "SLA Breach Count"
        ],
        "AP Booking": [
            "AP Booking Pending Count",
            "AP Booking Pending Value",
            "AR vs AP Value Mismatch Count",
            "Document Reference Missing Count"
        ],
        "Settlement of AP": [
            "Settlement Pending Count",
            "Settlement Pending Value",
            "Settlement Overdue Count",
            "AR vs AP Settlement Mismatch Count"
        ],
        "Cash Applications": [
            "Cash Application Pending Count",
            "Cash Application Pending Value",
            "Unapplied Cash Count",
            "Bank Receipt Not Matched Count"
        ],
        "AR Confirmation & Reporting": [
            "Confirmation Not Received Count",
            "Balance Difference Count",
            "Balance Difference Value",
            "Confirmation SLA Breach Count"
        ],
        "AR Reconciliation, Confirmation & Reporting": [
            "AR Reconciliation Pending Count",
            "AR vs Counterparty Balance Difference Count",
            "AR vs Counterparty Balance Difference Value",
            "Ageing Above 60 Days Count"
        ],
        "Advances, Receivables & Confirmation": [
            "Advance / Receivable Confirmation Pending Count",
            "Advance / Receivable Balance Pending Value",
            "Confirmation Difference Count",
            "Ageing Above 60 Days Count"
        ]
    },
    "Planning & Control": {
        "Cost Accounting": [
            "Cost Allocation Variance Count",
            "Unallocated Cost Value",
            "Review Pending Count",
            "Cost Center Mapping Error Count",
            "Cost Absorption Difference Value"
        ],
        "Profit Center Analysis": [
            "Profit Center Alert Count",
            "Loss Center Count",
            "Margin Deviation %",
            "Profit Center Mapping Missing Count",
            "Intercompany Profit Elimination Difference Value"
        ],
        "FP&A Benchmarking": [
            "MIS Pack Pending Count",
            "Action Open Count",
            "Plan vs Actual Gap %",
            "Benchmark Variance Count",
            "Management Review Pending Count"
        ]
    },
    "Reporting & Compliance": {
        "Post-Close Reporting": [
            "Report Pending Count",
            "Report Delay Count",
            "Report Sign-off Pending Count"
        ],
        "Post-Close Financial Analysis": [
            "Financial Analysis Pending Count",
            "Variance Explanation Pending Count",
            "Material Variance Value"
        ],
        "Balance Sheet Notes / Schedules": [
            "Balance Sheet Schedule Pending Count",
            "Balance Reconciliation Difference Value",
            "Supporting Evidence Pending Count"
        ],
        "Internal Control Checklists": [
            "Control Checklist Pending Count",
            "Control Exception Count",
            "Control Sign-off Pending Count"
        ],
        "Consolidation Package Preparation & Corrections": [
            "Package Preparation Pending Count",
            "Package Upload Pending Count",
            "Upload Error Count",
            "Correction Entry Pending Count",
            "Resubmission Pending Count",
            "Correction Value"
        ],
        "GAAP Adjustments, Eliminations & Transfers": [
            "GAAP Adjustment Pending Count",
            "Elimination Entry Pending Count",
            "Top-side Entry Pending Count"
        ],
        "Management Sign-off / Certification": [
            "Final Sign-off Pending Count",
            "Certification Exception Count"
        ]
    },
    "Tax & Compliance": {
        "GST Compliance": [
            "GST Return Pending Count",
            "GST Filing Delay Count",
            "GST Input Credit Mismatch Value",
            "GST Liability Reconciliation Difference Value",
            "E-Invoice Generation Failure Count",
            "GST Payment Pending Value"
        ],
        "TDS Compliance": [
            "TDS Deduction Error Count",
            "TDS Return Pending Count",
            "TDS Payment Delay Count",
            "TDS Certificate Pending Count",
            "TDS Vendor PAN Error Count",
            "TDS Reconciliation Difference Value"
        ],
        "Tax Provisioning": [
            "Tax Provision JV Pending Count",
            "Tax Provision Pending Value",
            "Tax Review Exception Count",
            "Deferred Tax Calculation Pending Count",
            "Tax Accrual Reversal Pending Count",
            "Effective Tax Rate Variance %"
        ],
        "Statutory Returns": [
            "Statutory Return Pending Count",
            "Statutory Filing SLA Breach Count",
            "Regulatory Notice Open Count",
            "Compliance Calendar Missed Count",
            "Return Approval Pending Count",
            "Late Filing Penalty Value"
        ],
        "Audit Support": [
            "Audit Query Open Count",
            "Audit Evidence Pending Count",
            "Audit Observation Open Count",
            "Management Response Pending Count",
            "Repeat Audit Finding Count",
            "Audit Closure Pending Count"
        ],
        "Transfer Pricing": [
            "Transfer Pricing Adjustment Value",
            "Intercompany Pricing Variance Count",
            "Transfer Pricing Documentation Pending Count",
            "Armâ€™s Length Margin Deviation %",
            "Transfer Pricing Review Pending Count",
            "Cross-Border Transaction Exception Count"
        ]
    },
    "Transaction Finance": {
        "Procure-to-Pay": [
            "3-Way Match Exception Count",
            "GR/IR Open Value",
            "PO Pending Count",
            "Invoice Blocked Count",
            "Vendor Advance Unadjusted Value"
        ],
        "Order-to-Cash": [
            "Unbilled Revenue Count",
            "Billing Block Count",
            "Open Invoice Count",
            "Delivery Not Billed Count",
            "Revenue Recognition Exception Count"
        ],
        "Inventory Accounting": [
            "Inventory Value Exception Count",
            "MM-FI Difference Value",
            "Negative Stock Count",
            "GR/IR Ageing Above Threshold Count",
            "Stock Valuation Difference Value",
            "Non-Moving / Obsolete Review",
            "Slow Moving"
        ],
        "Payroll": [
            "Payroll Validation Pending Count",
            "Payroll Posting Exception Count",
            "Payroll Cost Variance Value",
            "Employee Master Mismatch Count",
            "Payroll Accrual Pending Count"
        ]
    }
};

const MATERIAL_DATA = {
    "Machinery Hire / Equipment Rental": [
        "Machinery Hire / Equipment Rental"
    ],
    "Material and Labour Cost": [
        "Purchases-Aluminium Materials",
        "Purchases-Electrical Items",
        "Purchases-Steels and Rods",
        "Purchases-Hardware Items",
        "Purchases-Ceiling Materials",
        "Purchases-Plumbing Items",
        "Purchases-Building Block and Bricks",
        "Purchases-Fabrication Items",
        "Purchases-Cement",
        "Civil-Ceiling Works",
        "Purchases-Glass",
        "Labour-Labour Charges and Work",
        "Purchases-Aggregate (Jelly)",
        "Equipment-Rental Equipments",
        "Other Expenses",
        "Purchases-Sanitary Items and CP Fittings",
        "Purchases-Paints",
        "Civil-Cement Plastering",
        "Civil-Concrete Curing",
        "Civil-Earth Filling with Compaction",
        "Civil-Earthwork Excavation",
        "Civil-Landscaping",
        "Civil-Laterite Stone Masonry",
        "Civil-PCC",
        "Civil-Providing Water Beeding / Patty",
        "Civil-Providing and Laying PCC for Sunken Slabs",
        "Civil-Providing and Laying Reinforcement Steel of High Yield Strength",
        "Civil-RCC Concrete",
        "Civil-Soil Testing",
        "Civil-Soling",
        "Civil-Temporary Works",
        "Civil-Waterproofing",
        "Purchases-Granite and Tiles",
        "Purchases-Sand",
        "Electricity Charges",
        "Fast Tag",
        "Forwarding and Handling Charges",
        "Freight Charges Intra",
        "Machinery Hire / Equipment Rental",
        "Purchases- AGR Fitting",
        "Purchases-Wood Items",
        "Purchases-Concrete Mixer",
        "Purchases-Windows and Doors",
        "Road Tax",
        "Repairs and Maintainance",
        "Purchases-Safety Equipment",
        "Transport Charges"
    ],
    "Miscellaneous Expenses": [
        "Other Expenses"
    ],
    "Repairs and Maintenance": [
        "Vehicle Maintainace",
        "Computer Maintenance Charges"
    ],
    "Site Overheads": [
        "Electricity Charges"
    ]
};

const SUBDOMAIN_ROLES_DATA = {
    // Intercompany Finance
    "AR Billing": ["Accounts Billing Officer", "Accounts Receivable Manager", "AR Analyst", "Finance Controller"],
    "AP Booking": ["Accounts Payable Officer", "AP Analyst", "Accounts Payable Manager", "Finance Controller"],
    "Settlement of AP": ["AP Settlement Officer", "AP Manager", "Finance Controller"],
    "Cash Applications": ["Cash Applications Officer", "Cash Applications Manager", "AR Manager", "Finance Controller"],
    "AR Confirmation & Reporting": ["Accounts Receivable Analyst", "Reporting Analyst", "AR Manager", "Finance Controller"],
    "AR Reconciliation, Confirmation & Reporting": ["Accounts Receivable Analyst", "Reconciliation Manager", "Reporting Analyst", "AR Manager", "Finance Controller"],
    "Advances, Receivables & Confirmation": ["Advance Analyst", "Receivables Manager", "Reconciliation Specialist", "AR Manager", "Finance Controller"],

    // Core Finance
    "General Ledger": ["GL Accountant", "Finance Manager", "Controller", "CFO"],
    "Accounts Payable": ["AP Accountant", "Accounts Payable Manager", "Finance Controller"],
    "Accounts Receivable": ["AR Accountant", "AR Manager", "Finance Controller"],
    "Fixed Assets": ["Fixed Asset Accountant", "Finance Manager", "Controller"],
    "Bank & Cash": ["Treasury Analyst", "Treasury Manager", "Finance Controller"],

    // Financial Planning
    "Revenue Budget Preparation": ["Revenue Analyst", "FP&A Manager", "Controller", "CFO"],
    "Revenue Budget Review": ["FP&A Manager", "Controller", "CFO"],
    "P&L Budget Preparation": ["Financial Analyst", "FP&A Manager", "Controller", "CFO"],
    "P&L Budget Review": ["FP&A Manager", "Controller", "CFO"],
    "P&L Budget Submission": ["FP&A Manager", "Controller", "CFO"],
    "Revenue Re-forecast": ["Revenue Analyst", "FP&A Manager", "Controller", "CFO"],
    "P&L Re-forecast": ["Financial Analyst", "FP&A Manager", "Controller", "CFO"],
    "Final Budget / Forecast Sign-off": ["Controller", "CFO", "CEO"],

    // General Accounting
    "MDM & COA Readiness": ["MDM Specialist", "Master Data Manager", "Controller"],
    "Subledger Close": ["Subledger Accountant", "Finance Manager", "Controller"],
    "Allocations": ["Cost Accountant", "Finance Manager", "Controller"],
    "Revenue Review": ["Revenue Analyst", "Finance Manager", "Controller"],
    "Accrual Journals": ["GL Accountant", "Finance Manager", "Controller"],
    "Provision Journals": ["GL Accountant", "Finance Manager", "Controller"],
    "Tax Provision Journals": ["Tax Analyst", "Tax Manager", "Finance Controller"],
    "Manual Allocations": ["Cost Accountant", "Finance Manager", "Controller"],
    "Reclass & Recharge Journals": ["GL Accountant", "Finance Manager", "Controller"],
    "Other Manual Journals": ["GL Accountant", "Finance Manager", "Controller"],
    "P&L Preparation": ["Financial Analyst", "Finance Manager", "Controller"],
    "P&L Review": ["Finance Manager", "Controller", "CFO"],
    "Month-End Close Monitoring": ["Close Coordinator", "Finance Manager", "Controller", "CFO"],

    // Intelligence & Risk
    "Anomaly Detection": ["Risk Analyst", "Internal Auditor", "Finance Manager"],
    "Finance Recovery": ["Recovery Specialist", "Finance Manager", "Controller"],
    "Audit Trail": ["Internal Auditor", "Compliance Officer", "Controller"],

    // Planning & Control
    "Cost Accounting": ["Cost Accountant", "Cost Analyst", "Finance Manager", "Plant Controller"],
    "Profit Center Analysis": ["Profit Center Analyst", "Business Analyst", "Finance Manager", "Regional Controller"],
    "FP&A Benchmarking": ["FP&A Analyst", "Business Analyst", "Finance Manager", "CFO"],

    // Reporting & Compliance
    "Post-Close Reporting": ["Reporting Analyst", "Finance Manager", "Controller", "CFO"],
    "Post-Close Financial Analysis": ["Financial Analyst", "FP&A Manager", "Controller", "CFO"],
    "Balance Sheet Notes / Schedules": ["GL Accountant", "Reporting Analyst", "Finance Manager", "Controller"],
    "Internal Control Checklists": ["Internal Auditor", "Compliance Officer", "Risk Manager", "CFO"],
    "Consolidation Package Preparation & Corrections": ["Consolidation Analyst", "Reporting Manager", "Corporate Controller", "CFO"],
    "GAAP Adjustments, Eliminations & Transfers": ["GL Accountant", "Consolidation Analyst", "Reporting Manager", "Corporate Controller"],
    "Management Sign-off / Certification": ["Finance Manager", "Corporate Controller", "CFO", "CEO"],

    // Tax & Compliance
    "GST Compliance": ["Tax Analyst", "Indirect Tax Manager", "Finance Controller", "CFO"],
    "TDS Compliance": ["Tax Analyst", "Direct Tax Manager", "Finance Controller", "CFO"],
    "Tax Provisioning": ["Tax Analyst", "Tax Manager", "Finance Controller", "CFO"],
    "Statutory Returns": ["Compliance Analyst", "Tax Manager", "Legal Head", "CFO"],
    "Audit Support": ["Internal Auditor", "Audit Manager", "Finance Controller", "CFO"],
    "Transfer Pricing": ["Transfer Pricing Analyst", "Tax Manager", "Finance Controller", "CFO"],

    // Transaction Finance
    "Procure-to-Pay": ["Accounts Payable Officer", "AP Analyst", "Accounts Payable Manager", "Finance Controller"],
    "Order-to-Cash": ["Accounts Billing Officer", "AR Analyst", "Accounts Receivable Manager", "Finance Controller"],
    "Inventory Accounting": ["Store Keeper", "Store Manager", "Material Owner", "Dept Manager", "Cost Accountant", "Audit Team", "Controller", "Fin Manager"],
    "Payroll": ["Payroll Specialist", "HR Manager", "Finance Controller", "CFO"],

    // Default fallback
    "Default": ["Data Provider", "Preparer", "Reviewer 1", "Reviewer 2", "Approver 1", "Approver 2", "Approver 3", "Functional Owner", "Process Owner"]
};

/* â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
   ROLES & RESPONSIBILITIES VIEW
â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */

function RolesResponsibilities() {
    const initialMatrixState = [
        { indicator: "Inventory Value Exception Count", activeCells: [1, 3, 7] },
        { indicator: "MM-FI Difference Value", activeCells: [2, 5] },
        { indicator: "Negative Stock Count", activeCells: [2] },
        { indicator: "GR/IR Ageing Above Threshold Count", activeCells: [1, 3, 7] },
        { indicator: "Stock Valuation Difference Value", activeCells: [2, 3, 7] },
        { indicator: "Non-Moving / Obsolete Review", activeCells: [2, 5] },
        { indicator: "Slow Moving", activeCells: [2, 7] }
    ];
    const [selectedDomain, setSelectedDomain] = useState("Financial Planning");
    const [selectedSubDomain, setSelectedSubDomain] = useState("Revenue Budget Preparation");
    const [matrixData, setMatrixData] = useState([]);
    const [selectedMaterialGroup, setSelectedMaterialGroup] = useState("Material and Labour Cost");
    const [selectedMaterialClass, setSelectedMaterialClass] = useState("Purchases-Aluminium Materials");
    const [assignedUsers, setAssignedUsers] = useState(["John", "Shalini", "Sanjay"]);
    const [newUserName, setNewUserName] = useState("");
    const [savedConfigs, setSavedConfigs] = useState({});
    const [isSaving, setIsSaving] = useState(false);
    const [assignments, setAssignments] = useState([
        {
            role: "Material Owner â€“ Slow Moving",
            materialGroup: "Material and Labour Cost",
            materialClass: "Purchases-Aluminium Materials",
            wef: "01-04-2026",
            users: ["John", "Shalini", "Sanjay"]
        }
    ]);

    const currentRoles = SUBDOMAIN_ROLES_DATA[selectedSubDomain] || SUBDOMAIN_ROLES_DATA["Default"];

    const handleSave = async () => {
        if (!selectedDomain || !selectedSubDomain) return;

        // Constraint Validation: Ensure active matrix cells have assigned users
        const slowMovingRow = matrixData.find(r => r.indicator === "Slow Moving");
        if (slowMovingRow && slowMovingRow.activeCells.includes(2)) { // Material Owner role index is 2
            if (assignedUsers.length === 0) {
                store.dispatch(showAlert("Validation Error: 'Material Owner' is marked active for 'Slow Moving' in the Matrix. You must assign at least one user to this role in the Access Assignment form below before saving.", "warning"));
                return;
            }
        }

        setIsSaving(true);
        try {
            const key = `${selectedDomain}-${selectedSubDomain}`;
            setSavedConfigs(prev => ({
                ...prev,
                [key]: matrixData
            }));

            const { res } = await postRequest("api/vr2/saveMatrixData", {
                domain: selectedDomain,
                subDomain: selectedSubDomain,
                matrixData: matrixData,
                currentRoles
            });

            console.log("saveMatrixData response:", res);

            store.dispatch(showAlert("Configuration saved successfully", "success"));
        } catch (error) {
            console.error(error);
            store.dispatch(showAlert("Error saving matrix data", "error"));
        } finally {
            setIsSaving(false);
        }
    };

    const handleSaveAssignment = () => {
        if (assignedUsers.length === 0) {
            store.dispatch(showAlert("Validation Error: Please assign at least one user to the role before saving.", "warning"));
            return;
        }

        setAssignments(prev => {
            const index = prev.findIndex(
                a => a.materialGroup === selectedMaterialGroup &&
                    a.materialClass === selectedMaterialClass
            );
            const newAssignment = {
                role: "Material Owner â€“ Slow Moving",
                materialGroup: selectedMaterialGroup,
                materialClass: selectedMaterialClass,
                wef: "01-04-2026",
                users: assignedUsers
            };
            if (index !== -1) {
                const updated = [...prev];
                updated[index] = newAssignment;
                return updated;
            } else {
                return [...prev, newAssignment];
            }
        });
        store.dispatch(showAlert("Access Assignment saved successfully!", "success"));
    };

    const handleAddUser = (e) => {
        if (e.key === 'Enter' && newUserName.trim() !== '') {
            e.preventDefault();
            if (!assignedUsers.includes(newUserName.trim())) {
                setAssignedUsers([...assignedUsers, newUserName.trim()]);
            }
            setNewUserName("");
        }
    };

    const handleRemoveUser = (userToRemove) => {
        setAssignedUsers(assignedUsers.filter(u => u !== userToRemove));
    };

    useEffect(() => {
        if (MATERIAL_DATA[selectedMaterialGroup]) {
            setSelectedMaterialClass(MATERIAL_DATA[selectedMaterialGroup][0]);
        }
    }, [selectedMaterialGroup]);

    useEffect(() => {
        if (!assignments) return;
        const found = assignments.find(
            a => a.materialGroup === selectedMaterialGroup &&
                a.materialClass === selectedMaterialClass
        );
        if (found) {
            setAssignedUsers(found.users);
        } else {
            setAssignedUsers([]);
        }
    }, [selectedMaterialGroup, selectedMaterialClass, assignments]);

    useEffect(() => {
        if (DOMAIN_DATA[selectedDomain]) {
            const firstSub = Object.keys(DOMAIN_DATA[selectedDomain])[0];
            setSelectedSubDomain(firstSub);
        } else {
            setSelectedSubDomain("");
            setMatrixData(initialMatrixState);
        }
    }, [selectedDomain]);

    const fetchMatrixData = async () => {
        if (!selectedDomain || !selectedSubDomain) return;

        try {
            const { type, res } = await getRequest(
                `api/vr2/getMatrixData ? domain = ${encodeURIComponent(selectedDomain)}& subDomain=${encodeURIComponent(selectedSubDomain)} `
            );

            if (type === 'success' && res?.data && res.data.length > 0) {
                const jsonData = res.data;
                const roles = currentRoles;
                const mappedMatrix = jsonData.map(item => {
                    const activeCells = [];
                    roles.forEach((role, idx) => {
                        const val = item[role.toUpperCase()] || item[role];
                        if (val === "âœ”" || val === "Active") {
                            activeCells.push(idx);
                        }
                    });
                    return {
                        indicator: item.INDICATORS || item.Indicator || "",
                        activeCells
                    };
                });
                setMatrixData(mappedMatrix);
                return;
            } else {
                console.log(res);
            }
        } catch (error) {
            console.error("Error fetching matrix data:", error);
        }

        // Fallback to local config or initial state
        const key = `${selectedDomain} -${selectedSubDomain} `;
        if (savedConfigs[key]) {
            setMatrixData(savedConfigs[key]);
        } else if (DOMAIN_DATA[selectedDomain] && DOMAIN_DATA[selectedDomain][selectedSubDomain]) {
            const indicators = DOMAIN_DATA[selectedDomain][selectedSubDomain];
            const newMatrix = indicators.map(ind => ({
                indicator: ind,
                activeCells: []
            }));
            setMatrixData(newMatrix);
        } else if (!selectedDomain) {
            setMatrixData(initialMatrixState);
        }
    };

    useEffect(() => {
        fetchMatrixData();
    }, [selectedSubDomain, selectedDomain, savedConfigs]);

    const handleCellToggle = (rowIdx, cellIdx) => {
        setMatrixData(prev => prev.map((row, i) => {
            if (i === rowIdx) {
                const newActiveCells = row.activeCells.includes(cellIdx)
                    ? row.activeCells.filter(c => c !== cellIdx)
                    : [...row.activeCells, cellIdx];
                return { ...row, activeCells: newActiveCells };
            }
            return row;
        }));
    };

    const handleExport = () => {
        if (!selectedDomain || !selectedSubDomain || matrixData.length === 0) {
            store.dispatch(showAlert("No matrix data available to export", "warning"));
            return;
        }

        const exportData = matrixData.map(row => {
            const rowData = { INDICATORS: row.indicator };
            currentRoles.forEach((role, idx) => {
                rowData[role.toUpperCase()] = row.activeCells.includes(idx) ? "âœ”" : "â€”";
            });
            return rowData;
        });

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Roles & Approvals");
        const fileName = `${selectedDomain}_${selectedSubDomain} _Roles_and_Approvals_Matrix.xlsx`.replace(/\s+/g, '_');
        XLSX.writeFile(wb, fileName);
        store.dispatch(showAlert("Matrix exported successfully!", "success"));
    };


    return (
        <Stack spacing={2} sx={{ height: "100%" }}>
            {/* KPIs Bar - Condensed */}
            {/* <Grid container spacing={1.5}>
                {[
                    { label: "Total Controls", value: "1,248", trend: "â†‘ 4.2%", color: "#003d9b" },
                    { label: "Approval Rate", value: "98.4%", trend: "Stable", color: "#006847" },
                    { label: "Open Exceptions", value: "12", trend: "+3 Priority", color: "#ba1a1a" },
                    { label: "Avg. TAT", value: "4.2h", trend: "Target 6h", color: "#545f72" }
                ].map((kpi, idx) => (
                    <Grid item xs={3} key={idx}>
                        <Paper elevation={0} sx={{ p: 1, px: 1.5, border: "1px solid rgba(195, 198, 214, 0.5)", borderLeft: `4px solid ${ kpi.color } `, borderRadius: "8px" }}>
                            <Typography sx={{ fontSize: "9px", fontWeight: 700, color: "#737685", textTransform: "uppercase", letterSpacing: "0.05em" }}>{kpi.label}</Typography>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                                <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>{kpi.value}</Typography>
                                <Typography sx={{ fontSize: "10px", color: kpi.color, fontWeight: 500 }}>{kpi.trend}</Typography>
                            </Box>
                        </Paper>
                    </Grid>
                ))}
            </Grid> */}

            {/* Roles & Approvals Matrix */}
            <Paper elevation={0} sx={{ borderRadius: "12px", border: "1px solid rgba(195, 198, 214, 0.5)", borderLeft: "4px solid #003d9b", overflow: "hidden", display: "flex", flexDirection: "column", minHeight: "60%", maxHeight: "70%" }}>
                <Box sx={{ px: 2, py: 1, borderBottom: "1px solid rgba(195, 198, 214, 0.5)", display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "#ffffff" }}>
                    <Stack direction="row" spacing={2} alignItems="center">
                        <Typography sx={{ fontSize: "11px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em" }}>Roles & Approvals Matrix</Typography>
                        <Stack direction="row" spacing={2}>
                            <Box sx={{ display: "flex", alignItems: "center", fontSize: "11px", color: "#434654" }}>
                                <Box sx={{ w: 10, h: 10, borderRadius: "50%", backgroundColor: "#006847", mr: 1 }} /> Active
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center", fontSize: "11px", color: "#434654" }}>
                                <Box sx={{ w: 10, h: 10, borderRadius: "50%", backgroundColor: "#c3c6d6", mr: 1 }} /> No Role
                            </Box>
                        </Stack>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                        <Button size="small" variant="outlined" onClick={handleSave} disabled={isSaving} startIcon={isSaving ? <CircularProgress size={16} color="inherit" /> : <Icon name="save" sx={{ fontSize: 16 }} />} sx={{ fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#181c1e", borderColor: "#c3c6d6" }}>{isSaving ? "Saving..." : "Save"}</Button>
                        <Button size="small" variant="outlined" startIcon={<Icon name="filter_list" sx={{ fontSize: 16 }} />} sx={{ fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#181c1e", borderColor: "#c3c6d6" }}>Filter</Button>
                        <Button size="small" variant="outlined" onClick={handleExport} startIcon={<Icon name="download" sx={{ fontSize: 16 }} />} sx={{ fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#181c1e", borderColor: "#c3c6d6" }}>Export</Button>
                    </Stack>
                </Box>
                <Box sx={{ px: 2, py: 1, borderBottom: "1px solid rgba(195, 198, 214, 0.5)", backgroundColor: "#f1f4f7", display: "flex", gap: 2 }}>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#737685", textTransform: "uppercase" }}>Domain</Typography>
                        <Select size="small" value={selectedDomain} onChange={(e) => setSelectedDomain(e.target.value)} sx={{ height: 28, fontSize: "12px", minWidth: 200, backgroundColor: "#ffffff" }}>
                            <MenuItem value="">Select Domain</MenuItem>
                            {Object.keys(DOMAIN_DATA).map(dom => (
                                <MenuItem key={dom} value={dom}>{dom}</MenuItem>
                            ))}
                        </Select>
                    </Stack>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#737685", textTransform: "uppercase" }}>Sub Domain</Typography>
                        <Select size="small" value={selectedSubDomain} onChange={(e) => setSelectedSubDomain(e.target.value)} sx={{ height: 28, fontSize: "12px", minWidth: 200, backgroundColor: "#ffffff" }} disabled={!selectedDomain}>
                            {DOMAIN_DATA[selectedDomain] ? (
                                Object.keys(DOMAIN_DATA[selectedDomain]).map(sub => (
                                    <MenuItem key={sub} value={sub}>{sub}</MenuItem>
                                ))
                            ) : (
                                <MenuItem value="">Select a Domain first</MenuItem>
                            )}
                        </Select>
                    </Stack>
                </Box>
                <TableContainer sx={{ flex: 1 }}>
                    <Table size="small" stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontSize: "10px", fontWeight: 700, textTransform: "uppercase", backgroundColor: "#d5e0f7", color: "#586377", minWidth: 250, borderRight: "1px solid rgba(195, 198, 214, 0.5)", position: "sticky", left: 0, zIndex: 3 }}>Indicators</TableCell>
                                {currentRoles.map((role, idx) => (
                                    <TableCell key={idx} align="center" sx={{ fontSize: "10px", fontWeight: 700, textTransform: "uppercase", backgroundColor: "#d5e0f7", color: "#586377", borderRight: "1px solid rgba(195, 198, 214, 0.5)" }}>{role}</TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {matrixData.map((row, idx) => {
                                const isSlowMoving = row.indicator === "Slow Moving";
                                return (
                                    <TableRow key={idx} sx={{ backgroundColor: isSlowMoving ? "rgba(213, 224, 247, 0.5)" : "#ffffff", "&:hover": { backgroundColor: "#f1f4f7" } }}>
                                        <TableCell sx={{ fontSize: "12px", fontWeight: 600, borderRight: "1px solid rgba(195, 198, 214, 0.5)", position: "sticky", left: 0, zIndex: 2, backgroundColor: "inherit" }}>{row.indicator}</TableCell>
                                        {currentRoles.map((_, cellIdx) => (
                                            <TableCell
                                                key={cellIdx}
                                                align="center"
                                                onClick={() => handleCellToggle(idx, cellIdx)}
                                                sx={{ borderRight: "1px solid rgba(195, 198, 214, 0.5)", cursor: "pointer" }}
                                            >
                                                {row.activeCells.includes(cellIdx) ? (
                                                    <Icon name="check_circle" sx={{ color: isSlowMoving && cellIdx === 2 ? "#003d9b" : "#006847", fontSize: 16 }} />
                                                ) : (
                                                    <Typography sx={{ color: "#c3c6d6" }}>â€”</Typography>
                                                )}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>

            {/* Access Assignment Form */}
            <Paper elevation={0} sx={{ borderRadius: "12px", border: "1px solid rgba(195, 198, 214, 0.5)", borderLeft: "4px solid #003d9b", overflow: "hidden", display: "flex", flexDirection: "column", minHeight: 500 }}>
                <Box sx={{ px: 2, py: 1, borderBottom: "1px solid rgba(195, 198, 214, 0.5)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography sx={{ fontSize: "11px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em" }}>Access Assignment</Typography>
                    <IconButton size="small"><Icon name="close" sx={{ fontSize: 18, color: "#434654" }} /></IconButton>
                </Box>
                <Box sx={{ p: 2, flex: 1, overflowY: "auto" }}>
                    <Stack spacing={2}>
                        <Box sx={{ borderBottom: "1px solid rgba(195, 198, 214, 0.5)", pb: 1 }}>
                            <Chip label="Material Owner / Slow Moving" sx={{ fontSize: "11px", fontWeight: 700, backgroundColor: "#dae2ff", color: "#003d9b", borderRadius: "4px" }} />
                        </Box>
                        <Grid container spacing={2}>
                            <Grid item xs={3}>
                                <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#737685", textTransform: "uppercase", mb: 0.5 }}>Role</Typography>
                                <Box sx={{ px: 1.5, py: 0.75, backgroundColor: "#f1f4f7", border: "1px solid #c3c6d6", borderRadius: "4px", fontSize: "13px", fontWeight: 600 }}>Material Owner â€“ Slow Moving</Box>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#737685", textTransform: "uppercase", mb: 0.5 }}>Material Type</Typography>
                                <Select fullWidth size="small" value={selectedMaterialGroup} onChange={(e) => setSelectedMaterialGroup(e.target.value)} sx={{ height: 32, fontSize: "13px", backgroundColor: "#ffffff" }}>
                                    {Object.keys(MATERIAL_DATA).map(group => (
                                        <MenuItem key={group} value={group}>{group}</MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#737685", textTransform: "uppercase", mb: 0.5 }}>Material</Typography>
                                <Select fullWidth size="small" value={selectedMaterialClass} onChange={(e) => setSelectedMaterialClass(e.target.value)} sx={{ height: 32, fontSize: "13px", backgroundColor: "#ffffff" }}>
                                    {MATERIAL_DATA[selectedMaterialGroup]?.map(cls => (
                                        <MenuItem key={cls} value={cls}>{cls}</MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#737685", textTransform: "uppercase", mb: 0.5 }}>W.e.f</Typography>
                                <TextField fullWidth size="small" defaultValue="01-04-2026" inputProps={{ sx: { py: 0.75, fontSize: "13px" } }} />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#737685", textTransform: "uppercase", mb: 0.5 }}>Assigned To</Typography>
                                <Box sx={{ p: 0.5, minHeight: 32, backgroundColor: "#ffffff", border: "1px solid #c3c6d6", borderRadius: "4px", display: "flex", flexWrap: "wrap", gap: 1, alignItems: "center" }}>
                                    {assignedUsers.map(name => (
                                        <Chip
                                            key={name}
                                            label={name}
                                            onDelete={() => handleRemoveUser(name)}
                                            deleteIcon={<Icon name="close" sx={{ fontSize: "14px !important" }} />}
                                            sx={{ height: 24, fontSize: "11px", fontWeight: 700, backgroundColor: "#d5e0f7", color: "#586377" }}
                                        />
                                    ))}
                                    <TextField
                                        variant="standard"
                                        placeholder="Type name and press Enter"
                                        value={newUserName}
                                        onChange={(e) => setNewUserName(e.target.value)}
                                        onKeyDown={handleAddUser}
                                        InputProps={{ disableUnderline: true, sx: { fontSize: "12px", minWidth: "150px", padding: 0 } }}
                                        sx={{ flex: 1, ml: 1 }}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                        <Stack direction="row" spacing={2} justifyContent="flex-end">
                            <Button variant="outlined" sx={{ px: 2, fontSize: "11px", fontWeight: 700, color: "#181c1e", borderColor: "#737685" }}>Cancel</Button>
                            <Button variant="contained" onClick={handleSaveAssignment} sx={{ px: 3, fontSize: "11px", fontWeight: 700, backgroundColor: "#003d9b", "&:hover": { backgroundColor: "#003d9b", opacity: 0.9 } }}>Save Assignment</Button>
                        </Stack>
                    </Stack>
                </Box>
            </Paper>
        </Stack>
    );
}

/* â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
   SIDEBAR
â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */

function Sidebar({ activeView, onSelect }) {
    const state1 = store.getState()
    const userData = state1.login.userData
    const navLinks = [
        { icon: "dashboard", label: "Dashboard", id: "dashboard" },
        { icon: "account_balance", label: "Core finance", id: "core" },
        { icon: "swap_horiz", label: "Transaction Finance", id: "transaction" },
        { icon: "link", label: "Intercompany Finance", id: "intercompany" },
        { icon: "fact_check", label: "General Accounting", id: "ga" },
        { icon: "analytics", label: "Reporting & Compliance", id: "reporting" },
        { icon: "monitoring", label: "Financial Planning", id: "planning" },
        { icon: "shield", label: "Tax & Compliance", id: "tax" },
        { icon: "tune", label: "Planning & Control", id: "control" },
        { icon: "warning", label: "Intelligence & Risk", id: "intelligence" },
        { icon: "verified_user", label: "Roles & Approvals", id: "roles" },
    ];

    const workQueue = [
        { label: "Pending tasks", value: "124", color: "#003d9b" },
        { label: "Overdue", value: "34", color: "#ba1a1a" },
        { label: "Exceptions", value: "12", color: "#ed6c02" },
        { label: "Approvals", value: "8", color: "#181c1e" },
    ];

    const slaTeams = [
        { team: "Ap team", open: 12, breached: 2 },
        { team: "Ar team", open: 8, breached: 4 },
        { team: "Tax team", open: 5, breached: 1 },
    ];

    return (
        <Box
            component="aside"
            sx={{
                display: { xs: "none", lg: "flex" },
                flexDirection: "column",
                position: "fixed",
                top: 64,
                height: "calc(100vh - 64px)",
                zIndex: 40,
                backgroundColor: "#f1f4f7",
                borderRight: "1px solid rgba(195, 198, 214, 0.5)",
                width: 220
            }}
        >
            {/* â”€â”€ Brand â”€â”€ */}
            <Box sx={{ p: 2, display: "flex", alignItems: "center", gap: 1 }}>
                <Box sx={{ width: 32, height: 32, backgroundColor: "#003d9b", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", color: "#ffffff" }}>
                    <Icon name="account_balance" />
                </Box>
                <Box>
                    <Typography sx={{ fontSize: "16px", fontWeight: 700, color: "#181c1e", whiteSpace: "normal" }}>Demo Industrial Works Pvt Ltd</Typography>
                    <Typography sx={{ fontSize: "10px", color: "#737685", letterSpacing: "0.05em" }}>Operational view</Typography>
                </Box>
            </Box>

            {/* â”€â”€ Scrollable nav â”€â”€ */}
            <Box component="nav" sx={{ flex: 1, mt: 2, px: 1, overflowY: "auto", overflowX: "hidden" }} className="custom-scrollbar">
                <Stack spacing={0.5}>
                    {navLinks.map((link) => {
                        const isActive = activeView === link.id;
                        return (
                            <Button
                                key={link.id}
                                fullWidth
                                onClick={() => onSelect(link.id)}
                                startIcon={<Icon name={link.icon} sx={{ fontSize: "20px" }} />}
                                sx={{
                                    justifyContent: "flex-start",
                                    px: 1.5,
                                    py: 1,
                                    borderRadius: "8px",
                                    fontSize: "13px",
                                    fontWeight: isActive ? 700 : 500,
                                    color: isActive ? "#003d9b" : "#434654",
                                    backgroundColor: isActive ? "rgba(0, 61, 155, 0.1)" : "transparent",
                                    textTransform: "none",
                                    "&:hover": { backgroundColor: isActive ? "rgba(0, 61, 155, 0.15)" : "rgba(195, 198, 214, 0.2)" },
                                    "& .MuiButton-startIcon": { mr: 1.5, color: isActive ? "#003d9b" : "#737685" }
                                }}
                            >
                                <Box sx={{ textAlign: "left", lineHeight: 1.2 }}>
                                    {link.label}
                                </Box>
                            </Button>
                        );
                    })}
                </Stack>

                {/* â”€â”€ My Work Queue â”€â”€ */}
                <Box sx={{ mt: 4, px: 1 }}>
                    <Typography sx={{ fontSize: "9px", fontWeight: 700, color: "#737685", textTransform: "uppercase", letterSpacing: "0.05em", mb: 1, px: 0.5 }}>My work queue</Typography>
                    <Stack spacing={0.5}>
                        {workQueue.map((item, idx) => (
                            <Box key={idx} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 1, py: 0.5, borderRadius: "6px", "&:hover": { backgroundColor: "rgba(195, 198, 214, 0.2)" } }}>
                                <Typography sx={{ fontSize: "12px", color: "#434654", fontWeight: 500 }}>{item.label}</Typography>
                                <Typography sx={{ fontSize: "12px", fontWeight: 700, color: item.color }}>{item.value}</Typography>
                            </Box>
                        ))}
                    </Stack>
                </Box>

                {/* â”€â”€ SLA Tracker â”€â”€ */}
                <Box sx={{ mt: 4, mb: 4, px: 1 }}>
                    <Typography sx={{ fontSize: "9px", fontWeight: 700, color: "#737685", textTransform: "uppercase", letterSpacing: "0.05em", mb: 1, px: 0.5 }}>SLA Tracker</Typography>
                    <Stack spacing={1}>
                        {slaTeams.map((team, idx) => (
                            <Box key={idx} sx={{ px: 1, py: 1, borderRadius: "8px", border: "1px solid rgba(195, 198, 214, 0.3)", backgroundColor: "#ffffff" }}>
                                <Typography sx={{ fontSize: "11px", fontWeight: 700, color: "#181c1e", mb: 0.75 }}>{team.team}</Typography>
                                <Stack spacing={0.5}>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        <Typography sx={{ fontSize: "10px", color: "#737685" }}>Open tickets</Typography>
                                        <Typography sx={{ fontSize: "10px", fontWeight: 700 }}>{team.open}</Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        <Typography sx={{ fontSize: "10px", color: "#ba1a1a" }}>Breached</Typography>
                                        <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#ba1a1a" }}>{team.breached}</Typography>
                                    </Box>
                                    <Box sx={{ width: "100%", height: 3, backgroundColor: "#f1f4f7", borderRadius: "2px", mt: 0.5, overflow: "hidden" }}>
                                        <Box sx={{ width: `${(team.breached / team.open) * 100}% `, height: "100%", backgroundColor: "#ba1a1a" }} />
                                    </Box>
                                </Stack>
                            </Box>
                        ))}
                    </Stack>
                </Box>
            </Box>

            {/* â”€â”€ Footer â”€â”€ */}
            <Box sx={{ p: 1.5, borderTop: "1px solid rgba(195, 198, 214, 0.5)", backgroundColor: "#ffffff" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, p: 0.5 }}>
                    <Avatar
                        alt={userData.USR_Name || 'User'}
                        sx={{ bgcolor: userData.USR_Name ? globalhelper.stringToColor(userData.USR_Name) : '#ccc' }}
                    >
                        {userData.USR_Name ? userData.USR_Name.charAt(0).toUpperCase() : 'U'}
                    </Avatar>
                    <Box sx={{ minWidth: 0 }}>
                        <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#181c1e", noWrap: true }}>{userData.USR_Name}</Typography>
                        <Typography sx={{ fontSize: "10px", color: "#737685", noWrap: true }}>Global Controller</Typography>
                    </Box>
                    {/* <IconButton size="small" sx={{ ml: "auto" }}><Icon name="settings" sx={{ fontSize: 16, color: "#737685" }} /></IconButton> */}
                </Box>
            </Box>
        </Box>
    );
}

/* â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
   TOP HEADER
â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */

function TopHeader() {
    return (
        <AppBar position="sticky" elevation={0} sx={{ backgroundColor: "#ffffff", borderBottom: "1px solid rgba(195, 198, 214, 0.5)", zIndex: 1201 }}>
            <Toolbar sx={{ justifyContent: "space-between", minHeight: 64 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
                    <Box sx={{ display: { xs: "none", md: "flex" } }}>
                        <TextField
                            placeholder="Search accounts, entities..."
                            size="small"
                            sx={{
                                width: 320,
                                "& .MuiOutlinedInput-root": {
                                    backgroundColor: "#f1f4f7",
                                    borderRadius: "8px",
                                    "& fieldset": { border: "none" },
                                    "&:hover fieldset": { border: "none" },
                                    "&.Mui-focused fieldset": { border: "none" }
                                },
                                "& .MuiInputBase-input": { fontSize: "14px", py: 1 }
                            }}
                            InputProps={{
                                startAdornment: <Icon name="search" sx={{ fontSize: 20, color: "#737685", mr: 1 }} />
                            }}
                        />
                    </Box>
                </Box>

                <Stack direction="row" spacing={3} alignItems="center">
                    <Stack direction="row" spacing={1.5} alignItems="center" sx={{ borderRight: "1px solid rgba(195, 198, 214, 0.5)", pr: 3 }}>
                        <Box sx={{ textAlign: "right" }}>
                            <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#181c1e", lineHeight: 1.1 }}>Apr 2026</Typography>
                            <Typography sx={{ fontSize: "10px", color: "#737685" }}>Active period</Typography>
                        </Box>
                        <Icon name="calendar_month" sx={{ color: "#737685", fontSize: 20 }} />
                    </Stack>
                    {/* <Stack direction="row" spacing={1}>
                        <IconButton size="small"><Icon name="notifications" sx={{ color: "#737685" }} /></IconButton>
                        <IconButton size="small"><Icon name="settings" sx={{ color: "#737685" }} /></IconButton>
                        <Avatar sx={{ width: 32, height: 32, backgroundColor: "#003d9b", fontSize: "14px" }}>JS</Avatar>
                    </Stack> */}
                </Stack>
            </Toolbar>
        </AppBar>
    );
}

/* â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
   KPI STRIP
â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */

function KpiStrip() {
    const stats = [
        { label: "No issues", value: filesDetails.KPI.filter((item) => item.Colour === "Green").length, color: "#2e7d32" },
        { label: "Moderate issue", value: filesDetails.KPI.filter((item) => item.Colour === "Amber").length, color: "#ed6c02" },
        { label: "Close blocker", value: filesDetails.KPI.filter((item) => item.Colour === "Red").length, color: "#ba1a1a" },
    ];

    const totalValue = filesDetails.KPI.length;

    return (
        <Paper elevation={0} sx={{ p: 2, px: 3, backgroundColor: "#ffffff", borderBottom: "1px solid rgba(195, 198, 214, 0.5)", borderRadius: 0 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 6 }}>
                <Stack direction="row" spacing={5} alignItems="center">
                    {stats.map((s) => (
                        <Box key={s.label} sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#737685", textTransform: "uppercase" }}>{s.label}</Typography>
                            <Typography sx={{ fontSize: "24px", fontWeight: 700, color: s.color, fontFamily: "'IBM Plex Sans', monospace", lineHeight: 1 }}>{s.value}</Typography>
                        </Box>
                    ))}
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", borderLeft: "1px solid rgba(195, 198, 214, 0.5)", pl: 5 }}>
                        <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#737685", textTransform: "uppercase" }}>Total</Typography>
                        <Typography sx={{ fontSize: "24px", fontWeight: 700, color: "#181c1e", fontFamily: "'IBM Plex Sans', monospace", lineHeight: 1 }}>{totalValue}</Typography>
                    </Box>
                </Stack>

                <Box sx={{ flex: 1, maxWidth: 400, ml: "auto" }}>
                    <Box sx={{ width: "100%", height: 8, backgroundColor: "#f1f4f7", borderRadius: "999px", display: "flex", overflow: "hidden" }}>
                        <Box sx={{ width: `${(filesDetails.KPI.filter((item) => item.Colour === "Green").length / totalValue) * 100}% `, backgroundColor: "#2e7d32" }} />
                        <Box sx={{ width: `${(filesDetails.KPI.filter((item) => item.Colour === "Amber").length / totalValue) * 100}% `, backgroundColor: "#ed6c02" }} />
                        <Box sx={{ width: `${(filesDetails.KPI.filter((item) => item.Colour === "Red").length / totalValue) * 100}% `, backgroundColor: "#ba1a1a" }} />
                    </Box>
                </Box>
            </Box>
        </Paper>
    );
}

/* â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
   COCKPIT CARDS  (1 â€“ 9)
â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */

/* Module Row Item */
// function ModuleRow({ icon, label, status, noIssues, moderate, blocker, onDrill }) {
//     const statusColors = {
//         critical: "bg-error/10 text-error",
//         attention: "bg-amber-100 text-amber-700",
//         good: "bg-green-100 text-green-700"
//     };

//     return (
//         <div className="flex items-center justify-between p-2 hover:bg-surface-container-low rounded-lg  transition-all">
//             <div className="flex items-center gap-3">
//                 <div className="w-8 h-8 rounded-lg bg-surface-container-high flex items-center justify-center text-outline -hover:text-primary transition-colors">
//                     <Icon name={icon} className="text-[18px]" />
//                 </div>
//                 <div>
//                     <p className="text-[11px] font-bold text-on-surface leading-tight">{label}</p>
//                     <span className={`text - [8px] font - bold px - 1.5 py - 0.5 rounded uppercase tracking - tighter ${ statusColors[status] || 'bg-surface-container-high' } `}>
//                         {status}
//                     </span>
//                 </div>
//             </div>
//             <div className="flex items-center gap-4">
//                 <div className="flex gap-2 text-[10px] font-data-mono font-bold">
//                     <span className="text-green-600 w-4 text-center">{noIssues}</span>
//                     <span className="text-amber-500 w-4 text-center">{moderate}</span>
//                     <span className="text-red-600 w-4 text-center">{blocker}</span>
//                 </div>
//                 <button
//                     onClick={onDrill}
//                     className="p-1.5 hover:bg-primary/10 rounded-full text-outline hover:text-primary transition-all"
//                 >
//                     <Icon name="arrow_forward" className="text-[18px]" />
//                 </button>
//             </div>
//         </div>
//     );
// }

/* Card 1 â€” Core Finance */
function Card1CoreFinance({ onDrilldown, onStatusClick, isLoadingInventory }) {
    const [isExpanded, setIsExpanded] = useState(false);
    const allRows = [
        {
            icon: "receipt_long", label: "General ledger", mainHeading: "Core Finance", subHeading: "General Ledger", status: "critical", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Core Finance" && kpi["Sub Heading"] === "General Ledger" && kpi.Colour === "Green")?.length,
            moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Core Finance" && kpi["Sub Heading"] === "General Ledger" && kpi.Colour === "Amber")?.length,
            blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Core Finance" && kpi["Sub Heading"] === "General Ledger" && kpi.Colour === "Red")?.length
        },
        {
            icon: "description", label: "Accounts payable", mainHeading: "Core Finance", subHeading: "Accounts Payable", status: "attention", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Core Finance" && kpi["Sub Heading"] === "Accounts Payable" && kpi.Colour === "Green")?.length,
            moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Core Finance" && kpi["Sub Heading"] === "Accounts Payable" && kpi.Colour === "Amber")?.length,
            blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Core Finance" && kpi["Sub Heading"] === "Accounts Payable" && kpi.Colour === "Red")?.length
        },
        {
            icon: "receipt", label: "Accounts receivable", mainHeading: "Core Finance", subHeading: "Accounts Receivable", status: "critical", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Core Finance" && kpi["Sub Heading"] === "Accounts Receivable" && kpi.Colour === "Green")?.length,
            moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Core Finance" && kpi["Sub Heading"] === "Accounts Receivable" && kpi.Colour === "Amber")?.length,
            blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Core Finance" && kpi["Sub Heading"] === "Accounts Receivable" && kpi.Colour === "Red")?.length
        },
        {
            icon: "apartment", label: "Fixed assets", mainHeading: "Core Finance", subHeading: "Fixed Assets", status: "attention", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Core Finance" && kpi["Sub Heading"] === "Fixed Assets" && kpi.Colour === "Green")?.length,
            moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Core Finance" && kpi["Sub Heading"] === "Fixed Assets" && kpi.Colour === "Amber")?.length,
            blocker: 6,
            onBlockerClick: onDrilldown
        },
        {
            icon: "account_balance", label: "Bank & cash", mainHeading: "Core Finance", subHeading: "Bank & Cash", status: "critical", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Core Finance" && kpi["Sub Heading"] === "Bank & Cash" && kpi.Colour === "Green")?.length,
            moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Core Finance" && kpi["Sub Heading"] === "Bank & Cash" && kpi.Colour === "Amber")?.length,
            blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Core Finance" && kpi["Sub Heading"] === "Bank & Cash" && kpi.Colour === "Red")?.length
        }
    ];

    return (
        <Paper elevation={0} sx={{ height: "100%", display: "flex", flexDirection: "column", overflow: "hidden", borderRadius: "12px", border: "1px solid rgba(195, 198, 214, 0.5)", borderTop: "4px solid #003d9b" }}>
            <CardHeader
                title="Core finance"
                icon="account_balance"
                isExpanded={isExpanded}
                onToggle={() => setIsExpanded(!isExpanded)}
            />
            <Box sx={{ flex: 1, overflowY: "auto", pointerEvents: isLoadingInventory ? "none" : "auto", opacity: isLoadingInventory ? 0.5 : 1, transition: "opacity 0.2s" }} className="custom-scrollbar">
                {isExpanded ? (
                    <Stack spacing={1} sx={{ p: 1 }}>
                        {allRows.map((r) => (
                            <ModuleRowInline
                                key={r.label}
                                {...r}
                                onNoIssueClick={onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "No Issue") : undefined}
                                onModerateClick={onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "ModerateIssue") : undefined}
                                onBlockerClick={r.onBlockerClick || (onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "Close Blocker") : undefined)}
                            />
                        ))}
                    </Stack>
                ) : (
                    <CardSummary
                        rows={allRows}
                        onNoIssueClick={onStatusClick ? () => onStatusClick("Core Finance", null, "No Issue") : undefined}
                        onModerateClick={onStatusClick ? () => onStatusClick("Core Finance", null, "ModerateIssue") : undefined}
                        onBlockerClick={onStatusClick ? () => onStatusClick("Core Finance", null, "Close Blocker") : undefined}
                    />
                )}
            </Box>
        </Paper>
    );
}

/* Card 2 â€” Transaction Finance */
function Card2TransactionFinance({ onInventoryDrilldown, onCRMDrilldown, onStatusClick }) {
    const [isExpanded, setIsExpanded] = useState(false);
    const allRows = [
        {
            icon: "warehouse",
            label: "Inventory accounting",
            mainHeading: "Transaction Finance",
            subHeading: "Inventory Accounting",
            status: "critical",
            noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Transaction Finance" && kpi["Sub Heading"] === "Inventory Accounting" && kpi.Colour === "Green")?.length,
            moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Transaction Finance" && kpi["Sub Heading"] === "Inventory Accounting" && kpi.Colour === "Amber")?.length,
            blocker: 6,
            onBlockerClick: onInventoryDrilldown
        }, {
            icon: "manage_accounts",
            label: "CRM Service & Revenue Operations",
            mainHeading: "Transaction Finance",
            subHeading: "CRM Service & Revenue Operations",
            status: "attention",
            noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Transaction Finance" && kpi["Sub Heading"] === "CRM Service & Revenue Operations" && kpi.Colour === "Green")?.length,
            moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Transaction Finance" && kpi["Sub Heading"] === "CRM Service & Revenue Operations" && kpi.Colour === "Amber")?.length,
            blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Transaction Finance" && kpi["Sub Heading"] === "CRM Service & Revenue Operations" && kpi.Colour === "Red")?.length,
            onBlockerClick: onCRMDrilldown
        },
        { icon: "shopping_cart", label: "Procure-to-pay", mainHeading: "Transaction Finance", subHeading: "Procure-to-Pay", status: "critical", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Transaction Finance" && kpi["Sub Heading"] === "Procure-to-Pay" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Transaction Finance" && kpi["Sub Heading"] === "Procure-to-Pay" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Transaction Finance" && kpi["Sub Heading"] === "Procure-to-Pay" && kpi.Colour === "Red")?.length },
        { icon: "sell", label: "Order-to-cash", mainHeading: "Transaction Finance", subHeading: "Order-to-Cash", status: "critical", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Transaction Finance" && kpi["Sub Heading"] === "Order-to-Cash" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Transaction Finance" && kpi["Sub Heading"] === "Order-to-Cash" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Transaction Finance" && kpi["Sub Heading"] === "Order-to-Cash" && kpi.Colour === "Red")?.length },
        {
            icon: "groups",
            label: "Payroll",
            mainHeading: "Transaction Finance",
            subHeading: "Payroll",
            status: "attention",
            noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Transaction Finance" && kpi["Sub Heading"] === "Payroll" && kpi.Colour === "Green")?.length,
            moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Transaction Finance" && kpi["Sub Heading"] === "Payroll" && kpi.Colour === "Amber")?.length,
            blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Transaction Finance" && kpi["Sub Heading"] === "Payroll" && kpi.Colour === "Red")?.length
        }
    ];

    return (
        <Paper elevation={0} sx={{ height: "100%", display: "flex", flexDirection: "column", overflow: "hidden", borderRadius: "12px", border: "1px solid rgba(195, 198, 214, 0.5)", borderTop: "4px solid #ba1a1a" }}>
            <CardHeader
                title="Transaction finance"
                icon="swap_horiz"
                isExpanded={isExpanded}
                onToggle={() => setIsExpanded(!isExpanded)}
                onDownload={() => window.handleDownload("transaction_finance_report.xlsx", allRows)}
            />
            <Box sx={{ flex: 1, overflowY: "auto" }} className="custom-scrollbar">
                {isExpanded ? (
                    <Stack spacing={1} sx={{ p: 1 }}>
                        {allRows.map((r) => (
                            <ModuleRow
                                key={r.label}
                                {...r}
                                onNoIssueClick={onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "No Issue") : undefined}
                                onModerateClick={onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "ModerateIssue") : undefined}
                                onBlockerClick={r.onBlockerClick || (onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "Close Blocker") : undefined)}
                            />
                        ))}
                    </Stack>
                ) : (
                    <CardSummary
                        rows={allRows}
                        onNoIssueClick={onStatusClick ? () => onStatusClick("Transaction Finance", null, "No Issue") : undefined}
                        onModerateClick={onStatusClick ? () => onStatusClick("Transaction Finance", null, "ModerateIssue") : undefined}
                        onBlockerClick={onStatusClick ? () => onStatusClick("Transaction Finance", null, "Close Blocker") : undefined}
                    />
                )}
            </Box>
        </Paper>
    );
}

/* Card 3 â€” Intercompany Finance */
function Card3IntercompanyFinance({ onStatusClick }) {
    const [isExpanded, setIsExpanded] = useState(false);
    const allRows = [
        {
            icon: "moving",
            label: "Advances, receivables & confirmation",
            mainHeading: "Intercompany Finance",
            subHeading: "Advances, Receivables & Confirmation",
            status: "attention",
            noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intercompany Finance" && kpi["Sub Heading"] === "Advances, Receivables & Confirmation" && kpi.Colour === "Green")?.length,
            moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intercompany Finance" && kpi["Sub Heading"] === "Advances, Receivables & Confirmation" && kpi.Colour === "Amber")?.length,
            blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intercompany Finance" && kpi["Sub Heading"] === "Advances, Receivables & Confirmation" && kpi.Colour === "Red")?.length
        },
        {
            icon: "receipt_long",
            label: "AP booking",
            mainHeading: "Intercompany Finance",
            subHeading: "AP Booking",
            status: "critical",
            noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intercompany Finance" && kpi["Sub Heading"] === "AP Booking" && kpi.Colour === "Green")?.length,
            moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intercompany Finance" && kpi["Sub Heading"] === "AP Booking" && kpi.Colour === "Amber")?.length,
            blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intercompany Finance" && kpi["Sub Heading"] === "AP Booking" && kpi.Colour === "Red")?.length
        },
        {
            icon: "request_quote",
            label: "AR billing",
            mainHeading: "Intercompany Finance",
            subHeading: "AR Billing",
            status: "critical",
            noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intercompany Finance" && kpi["Sub Heading"] === "AR Billing" && kpi.Colour === "Green")?.length,
            moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intercompany Finance" && kpi["Sub Heading"] === "AR Billing" && kpi.Colour === "Amber")?.length,
            blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intercompany Finance" && kpi["Sub Heading"] === "AR Billing" && kpi.Colour === "Red")?.length
        },
        {
            icon: "assessment",
            label: "AR confirmation & reporting",
            mainHeading: "Intercompany Finance",
            subHeading: "AR Confirmation & Reporting",
            status: "critical",
            noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intercompany Finance" && kpi["Sub Heading"] === "AR Confirmation & Reporting" && kpi.Colour === "Green")?.length,
            moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intercompany Finance" && kpi["Sub Heading"] === "AR Confirmation & Reporting" && kpi.Colour === "Amber")?.length,
            blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intercompany Finance" && kpi["Sub Heading"] === "AR Confirmation & Reporting" && kpi.Colour === "Red")?.length
        },
        {
            icon: "verified",
            label: "AR Recon, confirm & reporting",
            mainHeading: "Intercompany Finance",
            subHeading: "AR Reconciliation, Confirmation & Reporting",
            status: "critical",
            noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intercompany Finance" && kpi["Sub Heading"] === "AR Reconciliation, Confirmation & Reporting" && kpi.Colour === "Green")?.length,
            moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intercompany Finance" && kpi["Sub Heading"] === "AR Reconciliation, Confirmation & Reporting" && kpi.Colour === "Amber")?.length,
            blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intercompany Finance" && kpi["Sub Heading"] === "AR Reconciliation, Confirmation & Reporting" && kpi.Colour === "Red")?.length
        },
        {
            icon: "payments",
            label: "Cash applications",
            mainHeading: "Intercompany Finance",
            subHeading: "Cash Applications",
            status: "critical",
            noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intercompany Finance" && kpi["Sub Heading"] === "Cash Applications" && kpi.Colour === "Green")?.length,
            moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intercompany Finance" && kpi["Sub Heading"] === "Cash Applications" && kpi.Colour === "Amber")?.length,
            blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intercompany Finance" && kpi["Sub Heading"] === "Cash Applications" && kpi.Colour === "Red")?.length
        },
        { icon: "handshake", label: "Settlement of AP", mainHeading: "Intercompany Finance", subHeading: "Settlement of AP", status: "critical", noIssues: 0, moderate: 1, blocker: 3 },
    ];

    return (
        <Paper elevation={0} sx={{ height: "100%", display: "flex", flexDirection: "column", overflow: "hidden", borderRadius: "12px", border: "1px solid rgba(195, 198, 214, 0.5)", borderTop: "4px solid #3f51b5" }}>
            <CardHeader
                title="Intercompany finance"
                icon="link"
                isExpanded={isExpanded}
                onToggle={() => setIsExpanded(!isExpanded)}
            />
            <Box sx={{ flex: 1, overflowY: "auto" }} className="custom-scrollbar">
                {isExpanded ? (
                    <Stack spacing={1} sx={{ p: 1 }}>
                        {allRows.map((r) => (
                            <ModuleRowInline
                                key={r.label}
                                {...r}
                                onNoIssueClick={onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "No Issue") : undefined}
                                onModerateClick={onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "ModerateIssue") : undefined}
                                onBlockerClick={r.onBlockerClick || (onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "Close Blocker") : undefined)}
                            />
                        ))}
                    </Stack>
                ) : (
                    <CardSummary
                        rows={allRows}
                        onNoIssueClick={onStatusClick ? () => onStatusClick("Intercompany Finance", null, "No Issue") : undefined}
                        onModerateClick={onStatusClick ? () => onStatusClick("Intercompany Finance", null, "ModerateIssue") : undefined}
                        onBlockerClick={onStatusClick ? () => onStatusClick("Intercompany Finance", null, "Close Blocker") : undefined}
                    />
                )}
            </Box>
        </Paper>
    );
}

/* Card 4 â€” General Accounting */
function Card4GAClose({ onStatusClick }) {
    const [isExpanded, setIsExpanded] = useState(false);
    const allRows = [
        { icon: "event_repeat", label: "Accrual journals", mainHeading: "General Accounting", subHeading: "Accrual Journals", status: "critical", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Accrual Journals" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Accrual Journals" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Accrual Journals" && kpi.Colour === "Red")?.length },
        { icon: "account_tree", label: "Allocations", mainHeading: "General Accounting", subHeading: "Allocations", status: "critical", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Allocations" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Allocations" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Allocations" && kpi.Colour === "Red")?.length },
        { icon: "draw", label: "Manual allocations", mainHeading: "General Accounting", subHeading: "Manual Allocations", status: "critical", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Manual Allocations" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Manual Allocations" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Manual Allocations" && kpi.Colour === "Red")?.length },
        { icon: "money", label: "Mtm & ega provisions", mainHeading: "General Accounting", subHeading: "Provision Journals", status: "critical", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Provision Journals" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Provision Journals" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Provision Journals" && kpi.Colour === "Red")?.length },
        { icon: "monitoring", label: "Month end close monitoring", mainHeading: "General Accounting", subHeading: "Month-End Close Monitoring", status: "critical", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Month-End Close Monitoring" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Month-End Close Monitoring" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Month-End Close Monitoring" && kpi.Colour === "Red")?.length },
        { icon: "edit_document", label: "Other manual journals", mainHeading: "General Accounting", subHeading: "Other Manual Journals", status: "critical", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Other Manual Journals" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Other Manual Journals" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Other Manual Journals" && kpi.Colour === "Red")?.length },
        { icon: "list_alt", label: "P&L preparation", mainHeading: "General Accounting", subHeading: "P&L Preparation", status: "attention", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "P&L Preparation" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "P&L Preparation" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "P&L Preparation" && kpi.Colour === "Red")?.length },
        { icon: "fact_check", label: "P&L review", mainHeading: "General Accounting", subHeading: "P&L Review", status: "attention", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "P&L Review" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "P&L Review" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "P&L Review" && kpi.Colour === "Red")?.length },
        { icon: "description", label: "Provision journals", mainHeading: "General Accounting", subHeading: "Provision Journals", status: "critical", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Provision Journals" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Provision Journals" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Provision Journals" && kpi.Colour === "Red")?.length },
        { icon: "published_with_changes", label: "Reclass & recharge journals", mainHeading: "General Accounting", subHeading: "Reclass & Recharge Journals", status: "attention", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Reclass & Recharge Journals" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Reclass & Recharge Journals" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Reclass & Recharge Journals" && kpi.Colour === "Red")?.length },
        { icon: "payments", label: "Revenue review", mainHeading: "General Accounting", subHeading: "Revenue Review", status: "critical", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Revenue Review" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Revenue Review" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Revenue Review" && kpi.Colour === "Red")?.length },
        { icon: "lock_open", label: "Subledger close", mainHeading: "General Accounting", subHeading: "Subledger Close", status: "attention", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Subledger Close" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Subledger Close" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Subledger Close" && kpi.Colour === "Red")?.length },
        { icon: "gavel", label: "Tax provision journals", mainHeading: "General Accounting", subHeading: "Tax Provision Journals", status: "critical", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Tax Provision Journals" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Tax Provision Journals" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "General Accounting" && kpi["Sub Heading"] === "Tax Provision Journals" && kpi.Colour === "Red")?.length },
    ];

    return (
        <Paper elevation={0} sx={{ height: "100%", display: "flex", flexDirection: "column", overflow: "hidden", borderRadius: "12px", border: "1px solid rgba(195, 198, 214, 0.5)", borderTop: "4px solid #ed6c02" }}>
            <CardHeader
                title="General Accounting"
                icon="fact_check"
                isExpanded={isExpanded}
                onToggle={() => setIsExpanded(!isExpanded)}
                onDownload={() => window.handleDownload("IntercompanyFinance_report.xlsx", allRows)}
            />
            <Box sx={{ flex: 1, overflowY: "auto" }} className="custom-scrollbar">
                {isExpanded ? (
                    <Stack spacing={1} sx={{ p: 1 }}>
                        {allRows.map((r) => (
                            <ModuleRow
                                key={r.label}
                                {...r}
                                onNoIssueClick={onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "No Issue") : undefined}
                                onModerateClick={onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "ModerateIssue") : undefined}
                                onBlockerClick={r.onBlockerClick || (onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "Close Blocker") : undefined)}
                            />
                        ))}
                    </Stack>
                ) : (
                    <CardSummary
                        rows={allRows}
                        onNoIssueClick={onStatusClick ? () => onStatusClick("General Accounting", null, "No Issue") : undefined}
                        onModerateClick={onStatusClick ? () => onStatusClick("General Accounting", null, "ModerateIssue") : undefined}
                        onBlockerClick={onStatusClick ? () => onStatusClick("General Accounting", null, "Close Blocker") : undefined}
                    />
                )}
            </Box>
        </Paper>
    );
}

/* Card 5 â€” Reporting & Compliance */
function Card5ReportingCompliance({ onStatusClick }) {
    const [isExpanded, setIsExpanded] = useState(false);
    const allRows = [
        {
            icon: "description",
            label: "Balance sheet notes / schedules",
            mainHeading: "Reporting & Compliance",
            subHeading: "Balance Sheet Notes / Schedules",
            status: "critical",
            noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "Balance Sheet Notes / Schedules" && kpi.Colour === "Green")?.length,
            moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "Balance Sheet Notes / Schedules" && kpi.Colour === "Amber")?.length,
            blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "Balance Sheet Notes / Schedules" && kpi.Colour === "Red")?.length
        },
        {
            icon: "edit_note",
            label: "Consolidation package corrections",
            mainHeading: "Reporting & Compliance",
            subHeading: "Consolidation Package Preparation & Corrections",
            status: "critical",
            noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "Consolidation Package Preparation & Corrections" && kpi.Colour === "Green")?.length,
            moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "Consolidation Package Preparation & Corrections" && kpi.Colour === "Amber")?.length,
            blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "Consolidation Package Preparation & Corrections" && kpi.Colour === "Red")?.length
        },
        {
            icon: "upload_file",
            label: "Consolidation package prep & upload",
            mainHeading: "Reporting & Compliance",
            subHeading: "Consolidation Package Preparation & Corrections",
            status: "attention",
            noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "Consolidation Package Preparation & Corrections" && kpi.Colour === "Green")?.length,
            moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "Consolidation Package Preparation & Corrections" && kpi.Colour === "Amber")?.length,
            blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "Consolidation Package Preparation & Corrections" && kpi.Colour === "Red")?.length
        },
        {
            icon: "tune",
            label: "GAAP adjustments",
            mainHeading: "Reporting & Compliance",
            subHeading: "GAAP Adjustments, Eliminations & Transfers",
            status: "critical",
            noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "GAAP Adjustments, Eliminations & Transfers" && kpi.Colour === "Green")?.length,
            moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "GAAP Adjustments, Eliminations & Transfers" && kpi.Colour === "Amber")?.length,
            blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "GAAP Adjustments, Eliminations & Transfers" && kpi.Colour === "Red")?.length
        },
        {
            icon: "layers_clear",
            label: "Eliminations & top entries",
            mainHeading: "Reporting & Compliance",
            subHeading: "GAAP Adjustments, Eliminations & Transfers",
            status: "critical",
            noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "GAAP Adjustments, Eliminations & Transfers" && kpi.Colour === "Green")?.length,
            moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "GAAP Adjustments, Eliminations & Transfers" && kpi.Colour === "Amber")?.length,
            blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "GAAP Adjustments, Eliminations & Transfers" && kpi.Colour === "Red")?.length
        },
        {
            icon: "fact_check",
            label: "Internal control checklists",
            mainHeading: "Reporting & Compliance",
            subHeading: "Internal Control Checklists",
            status: "critical",
            noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "Internal Control Checklists" && kpi.Colour === "Green")?.length,
            moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "Internal Control Checklists" && kpi.Colour === "Amber")?.length,
            blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "Internal Control Checklists" && kpi.Colour === "Red")?.length
        },
        {
            icon: "verified",
            label: "Management sign-off",
            mainHeading: "Reporting & Compliance",
            subHeading: "Management Sign-off / Certification",
            status: "attention",
            noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "Management Sign-off / Certification" && kpi.Colour === "Green")?.length,
            moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "Management Sign-off / Certification" && kpi.Colour === "Amber")?.length,
            blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "Management Sign-off / Certification" && kpi.Colour === "Red")?.length
        },
        {
            icon: "analytics",
            label: "Post-close financial analysis",
            mainHeading: "Reporting & Compliance",
            subHeading: "Post-Close Financial Analysis",
            status: "critical",
            noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "Post-Close Financial Analysis" && kpi.Colour === "Green")?.length,
            moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "Post-Close Financial Analysis" && kpi.Colour === "Amber")?.length,
            blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "Post-Close Financial Analysis" && kpi.Colour === "Red")?.length
        },
        {
            icon: "assessment",
            label: "Post-close reporting",
            mainHeading: "Reporting & Compliance",
            subHeading: "Post-Close Reporting",
            status: "critical",
            noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "Post-Close Reporting" && kpi.Colour === "Green")?.length,
            moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "Post-Close Reporting" && kpi.Colour === "Amber")?.length,
            blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Reporting & Compliance" && kpi["Sub Heading"] === "Post-Close Reporting" && kpi.Colour === "Red")?.length
        },
    ];

    return (
        <Paper elevation={0} sx={{ height: "100%", display: "flex", flexDirection: "column", overflow: "hidden", borderRadius: "12px", border: "1px solid rgba(195, 198, 214, 0.5)", borderTop: "4px solid #455a64" }}>
            <CardHeader
                title="Reporting & compliance"
                icon="analytics"
                isExpanded={isExpanded}
                onToggle={() => setIsExpanded(!isExpanded)}
                onDownload={() => window.handleDownload("GAClose_report.xlsx", allRows)}
            />
            <Box sx={{ flex: 1, overflowY: "auto" }} className="custom-scrollbar">
                {isExpanded ? (
                    <Stack spacing={1} sx={{ p: 1 }}>
                        {allRows.map((r) => (
                            <ModuleRowInline
                                key={r.label}
                                {...r}
                                onNoIssueClick={onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "No Issue") : undefined}
                                onModerateClick={onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "ModerateIssue") : undefined}
                                onBlockerClick={r.onBlockerClick || (onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "Close Blocker") : undefined)}
                            />
                        ))}
                    </Stack>
                ) : (
                    <CardSummary
                        rows={allRows}
                        onNoIssueClick={onStatusClick ? () => onStatusClick("Reporting & Compliance", null, "No Issue") : undefined}
                        onModerateClick={onStatusClick ? () => onStatusClick("Reporting & Compliance", null, "ModerateIssue") : undefined}
                        onBlockerClick={onStatusClick ? () => onStatusClick("Reporting & Compliance", null, "Close Blocker") : undefined}
                    />
                )}
            </Box>
        </Paper>
    );
}

/* Card 6 â€” Financial Planning */
function Card6FinancialPlanning({ onStatusClick }) {
    const [isExpanded, setIsExpanded] = useState(false);
    const allRows = [
        { icon: "verified", label: "Final budget / forecast sign-off", mainHeading: "Financial Planning", subHeading: "Final Budget / Forecast Sign-off", status: "attention", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Financial Planning" && kpi["Sub Heading"] === "Final Budget / Forecast Sign-off" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Financial Planning" && kpi["Sub Heading"] === "Final Budget / Forecast Sign-off" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Financial Planning" && kpi["Sub Heading"] === "Final Budget / Forecast Sign-off" && kpi.Colour === "Red")?.length },
        { icon: "playlist_add_check", label: "P&l budget preparation", mainHeading: "Financial Planning", subHeading: "P&L Budget Preparation", status: "attention", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Financial Planning" && kpi["Sub Heading"] === "P&L Budget Preparation" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Financial Planning" && kpi["Sub Heading"] === "P&L Budget Preparation" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Financial Planning" && kpi["Sub Heading"] === "P&L Budget Preparation" && kpi.Colour === "Red")?.length },
        { icon: "rate_review", label: "P&L budget review", mainHeading: "Financial Planning", subHeading: "P&L Budget Review", status: "attention", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Financial Planning" && kpi["Sub Heading"] === "P&L Budget Review" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Financial Planning" && kpi["Sub Heading"] === "P&L Budget Review" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Financial Planning" && kpi["Sub Heading"] === "P&L Budget Review" && kpi.Colour === "Red")?.length },
        { icon: "send", label: "P&L budget submission", mainHeading: "Financial Planning", subHeading: "P&L Budget Submission", status: "attention", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Financial Planning" && kpi["Sub Heading"] === "P&L Budget Submission" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Financial Planning" && kpi["Sub Heading"] === "P&L Budget Submission" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Financial Planning" && kpi["Sub Heading"] === "P&L Budget Submission" && kpi.Colour === "Red")?.length },
        { icon: "trending_up", label: "P&L re-forecast", mainHeading: "Financial Planning", subHeading: "P&L Re-forecast", status: "critical", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Financial Planning" && kpi["Sub Heading"] === "P&L Re-forecast" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Financial Planning" && kpi["Sub Heading"] === "P&L Re-forecast" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Financial Planning" && kpi["Sub Heading"] === "P&L Re-forecast" && kpi.Colour === "Red")?.length },
        { icon: "payments", label: "Revenue budget preparation", mainHeading: "Financial Planning", subHeading: "Revenue Budget Preparation", status: "attention", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Financial Planning" && kpi["Sub Heading"] === "Revenue Budget Preparation" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Financial Planning" && kpi["Sub Heading"] === "Revenue Budget Preparation" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Financial Planning" && kpi["Sub Heading"] === "Revenue Budget Preparation" && kpi.Colour === "Red")?.length },
        { icon: "fact_check", label: "Revenue budget review", mainHeading: "Financial Planning", subHeading: "Revenue Budget Review", status: "attention", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Financial Planning" && kpi["Sub Heading"] === "Revenue Budget Review" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Financial Planning" && kpi["Sub Heading"] === "Revenue Budget Review" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Financial Planning" && kpi["Sub Heading"] === "Revenue Budget Review" && kpi.Colour === "Red")?.length },
        { icon: "update", label: "Revenue re-forecast", mainHeading: "Financial Planning", subHeading: "Revenue Re-forecast", status: "critical", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Financial Planning" && kpi["Sub Heading"] === "Revenue Re-forecast" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Financial Planning" && kpi["Sub Heading"] === "Revenue Re-forecast" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Financial Planning" && kpi["Sub Heading"] === "Revenue Re-forecast" && kpi.Colour === "Red")?.length },
    ];

    return (
        <Paper elevation={0} sx={{ height: "100%", display: "flex", flexDirection: "column", overflow: "hidden", borderRadius: "12px", border: "1px solid rgba(195, 198, 214, 0.5)", borderTop: "4px solid #b71c1c" }}>
            <CardHeader
                title="Financial planning"
                icon="monitoring"
                isExpanded={isExpanded}
                onToggle={() => setIsExpanded(!isExpanded)}
            />
            <Box sx={{ flex: 1, overflowY: "auto" }} className="custom-scrollbar">
                {isExpanded ? (
                    <Stack spacing={1} sx={{ p: 1 }}>
                        {allRows.map((r) => (
                            <ModuleRowInline
                                key={r.label}
                                {...r}
                                onNoIssueClick={onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "No Issue") : undefined}
                                onModerateClick={onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "ModerateIssue") : undefined}
                                onBlockerClick={r.onBlockerClick || (onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "Close Blocker") : undefined)}
                            />
                        ))}
                    </Stack>
                ) : (
                    <CardSummary
                        rows={allRows}
                        onNoIssueClick={onStatusClick ? () => onStatusClick("Financial Planning", null, "No Issue") : undefined}
                        onModerateClick={onStatusClick ? () => onStatusClick("Financial Planning", null, "ModerateIssue") : undefined}
                        onBlockerClick={onStatusClick ? () => onStatusClick("Financial Planning", null, "Close Blocker") : undefined}
                    />
                )}
            </Box>
        </Paper>
    );
}

/* Card 7 â€” Tax & Compliance */
function Card7TaxCompliance({ onStatusClick }) {
    const [isExpanded, setIsExpanded] = useState(false);
    const allRows = [
        { icon: "history_edu", label: "GST compliance", mainHeading: "Tax & Compliance", subHeading: "GST Compliance", status: "critical", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Tax & Compliance" && kpi["Sub Heading"] === "GST Compliance" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Tax & Compliance" && kpi["Sub Heading"] === "GST Compliance" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Tax & Compliance" && kpi["Sub Heading"] === "GST Compliance" && kpi.Colour === "Red")?.length },
        { icon: "account_balance_wallet", label: "TDS compliance", mainHeading: "Tax & Compliance", subHeading: "TDS Compliance", status: "critical", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Tax & Compliance" && kpi["Sub Heading"] === "TDS Compliance" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Tax & Compliance" && kpi["Sub Heading"] === "TDS Compliance" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Tax & Compliance" && kpi["Sub Heading"] === "TDS Compliance" && kpi.Colour === "Red")?.length },
        { icon: "folder_open", label: "Statutory returns", mainHeading: "Tax & Compliance", subHeading: "Statutory Returns", status: "attention", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Tax & Compliance" && kpi["Sub Heading"] === "Statutory Returns" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Tax & Compliance" && kpi["Sub Heading"] === "Statutory Returns" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Tax & Compliance" && kpi["Sub Heading"] === "Statutory Returns" && kpi.Colour === "Red")?.length },
        { icon: "search_check", label: "Audit support", mainHeading: "Tax & Compliance", subHeading: "Audit Support", status: "attention", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Tax & Compliance" && kpi["Sub Heading"] === "Audit Support" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Tax & Compliance" && kpi["Sub Heading"] === "Audit Support" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Tax & Compliance" && kpi["Sub Heading"] === "Audit Support" && kpi.Colour === "Red")?.length },
        { icon: "description", label: "Tax provisioning", mainHeading: "Tax & Compliance", subHeading: "Tax Provisioning", status: "attention", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Tax & Compliance" && kpi["Sub Heading"] === "Tax Provisioning" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Tax & Compliance" && kpi["Sub Heading"] === "Tax Provisioning" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Tax & Compliance" && kpi["Sub Heading"] === "Tax Provisioning" && kpi.Colour === "Red")?.length },
        { icon: "import_export", label: "Transfer pricing", mainHeading: "Tax & Compliance", subHeading: "Transfer Pricing", status: "critical", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Tax & Compliance" && kpi["Sub Heading"] === "Transfer Pricing" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Tax & Compliance" && kpi["Sub Heading"] === "Transfer Pricing" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Tax & Compliance" && kpi["Sub Heading"] === "Transfer Pricing" && kpi.Colour === "Red")?.length },
    ];

    return (
        <Paper elevation={0} sx={{ height: "100%", display: "flex", flexDirection: "column", overflow: "hidden", borderRadius: "12px", border: "1px solid rgba(195, 198, 214, 0.5)", borderTop: "4px solid #ed6c02" }}>
            <CardHeader
                title="Tax & compliance"
                icon="shield"
                isExpanded={isExpanded}
                onToggle={() => setIsExpanded(!isExpanded)}
            />
            <Box sx={{ flex: 1, overflowY: "auto" }} className="custom-scrollbar">
                {isExpanded ? (
                    <Stack spacing={1} sx={{ p: 1 }}>
                        {allRows.map((r) => (
                            <ModuleRowInline
                                key={r.label}
                                {...r}
                                onNoIssueClick={onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "No Issue") : undefined}
                                onModerateClick={onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "ModerateIssue") : undefined}
                                onBlockerClick={r.onBlockerClick || (onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "Close Blocker") : undefined)}
                            />
                        ))}
                    </Stack>
                ) : (
                    <CardSummary
                        rows={allRows}
                        onNoIssueClick={onStatusClick ? () => onStatusClick("Tax & Compliance", null, "No Issue") : undefined}
                        onModerateClick={onStatusClick ? () => onStatusClick("Tax & Compliance", null, "ModerateIssue") : undefined}
                        onBlockerClick={onStatusClick ? () => onStatusClick("Tax & Compliance", null, "Close Blocker") : undefined}
                    />
                )}
            </Box>
        </Paper>
    );
}

/* Card 8 â€” Planning & Control */
function Card8PlanningControl({ onStatusClick }) {
    const [isExpanded, setIsExpanded] = useState(false);
    const allRows = [
        { icon: "calculate", label: "Cost accounting", mainHeading: "Planning & Control", subHeading: "Cost Accounting", status: "attention", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Planning & Control" && kpi["Sub Heading"] === "Cost Accounting" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Planning & Control" && kpi["Sub Heading"] === "Cost Accounting" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Planning & Control" && kpi["Sub Heading"] === "Cost Accounting" && kpi.Colour === "Red")?.length },
        { icon: "finance_chip", label: "Profit center analysis", mainHeading: "Planning & Control", subHeading: "Profit Center Analysis", status: "attention", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Planning & Control" && kpi["Sub Heading"] === "Profit Center Analysis" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Planning & Control" && kpi["Sub Heading"] === "Profit Center Analysis" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Planning & Control" && kpi["Sub Heading"] === "Profit Center Analysis" && kpi.Colour === "Red")?.length },
        { icon: "model_training", label: "FP&A benchmarking", mainHeading: "Planning & Control", subHeading: "FP&A Benchmarking", status: "attention", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Planning & Control" && kpi["Sub Heading"] === "FP&A Benchmarking" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Planning & Control" && kpi["Sub Heading"] === "FP&A Benchmarking" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Planning & Control" && kpi["Sub Heading"] === "FP&A Benchmarking" && kpi.Colour === "Red")?.length },
    ];

    return (
        <Paper elevation={0} sx={{ height: "100%", display: "flex", flexDirection: "column", overflow: "hidden", borderRadius: "12px", border: "1px solid rgba(195, 198, 214, 0.5)", borderTop: "4px solid #2e7d32" }}>
            <CardHeader
                title="Planning & control"
                icon="tune"
                isExpanded={isExpanded}
                onToggle={() => setIsExpanded(!isExpanded)}
            />
            <Box sx={{ flex: 1, overflowY: "auto" }} className="custom-scrollbar">
                {isExpanded ? (
                    <Stack spacing={1} sx={{ p: 1 }}>
                        {allRows.map((r) => (
                            <ModuleRow
                                key={r.label}
                                {...r}
                                onNoIssueClick={onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "No Issue") : undefined}
                                onModerateClick={onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "ModerateIssue") : undefined}
                                onBlockerClick={r.onBlockerClick || (onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "Close Blocker") : undefined)}
                            />
                        ))}
                    </Stack>
                ) : (
                    <CardSummary
                        rows={allRows}
                        onNoIssueClick={onStatusClick ? () => onStatusClick("Planning & Control", null, "No Issue") : undefined}
                        onModerateClick={onStatusClick ? () => onStatusClick("Planning & Control", null, "ModerateIssue") : undefined}
                        onBlockerClick={onStatusClick ? () => onStatusClick("Planning & Control", null, "Close Blocker") : undefined}
                    />
                )}
            </Box>
        </Paper>
    );
}

/* Card 9 â€” Intelligence & Risk */
function Card9IntelligenceRisk({ onStatusClick }) {
    const [isExpanded, setIsExpanded] = useState(false);
    const allRows = [
        { icon: "report_problem", label: "Anomaly detection", mainHeading: "Intelligence & Risk", subHeading: "Anomaly Detection", status: "critical", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intelligence & Risk" && kpi["Sub Heading"] === "Anomaly Detection" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intelligence & Risk" && kpi["Sub Heading"] === "Anomaly Detection" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intelligence & Risk" && kpi["Sub Heading"] === "Anomaly Detection" && kpi.Colour === "Red")?.length },
        { icon: "currency_rupee", label: "Finance recovery", mainHeading: "Intelligence & Risk", subHeading: "Finance Recovery", status: "attention", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intelligence & Risk" && kpi["Sub Heading"] === "Finance Recovery" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intelligence & Risk" && kpi["Sub Heading"] === "Finance Recovery" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intelligence & Risk" && kpi["Sub Heading"] === "Finance Recovery" && kpi.Colour === "Red")?.length },
        { icon: "footprint", label: "Audit trail", mainHeading: "Intelligence & Risk", subHeading: "Audit Trail", status: "critical", noIssues: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intelligence & Risk" && kpi["Sub Heading"] === "Audit Trail" && kpi.Colour === "Green")?.length, moderate: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intelligence & Risk" && kpi["Sub Heading"] === "Audit Trail" && kpi.Colour === "Amber")?.length, blocker: filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Intelligence & Risk" && kpi["Sub Heading"] === "Audit Trail" && kpi.Colour === "Red")?.length },
    ];

    return (
        <Paper elevation={0} sx={{ height: "100%", display: "flex", flexDirection: "column", overflow: "hidden", borderRadius: "12px", border: "1px solid rgba(195, 198, 214, 0.5)", borderTop: "4px solid #ba1a1a" }}>
            <CardHeader
                title="Intelligence & risk"
                icon="warning"
                isExpanded={isExpanded}
                onToggle={() => setIsExpanded(!isExpanded)}
            // onDownload={() => onDownload("IntelligenceRisk.xlsx", allRows)}
            />
            <Box sx={{ flex: 1, overflowY: "auto" }} className="custom-scrollbar">
                {isExpanded ? (
                    <Stack spacing={1} sx={{ p: 1 }}>
                        {allRows.map((r) => (
                            <ModuleRow
                                key={r.label}
                                {...r}
                                onNoIssueClick={onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "No Issue") : undefined}
                                onModerateClick={onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "ModerateIssue") : undefined}
                                onBlockerClick={r.onBlockerClick || (onStatusClick ? () => onStatusClick(r.mainHeading, r.subHeading, "Close Blocker") : undefined)}
                            />
                        ))}
                    </Stack>
                ) : (
                    <CardSummary
                        rows={allRows}
                        onNoIssueClick={onStatusClick ? () => onStatusClick("Intelligence & Risk", null, "No Issue") : undefined}
                        onModerateClick={onStatusClick ? () => onStatusClick("Intelligence & Risk", null, "ModerateIssue") : undefined}
                        onBlockerClick={onStatusClick ? () => onStatusClick("Intelligence & Risk", null, "Close Blocker") : undefined}
                    />
                )}
            </Box>
        </Paper>
    );
}

/* â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
   ROOT EXPORT
â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */

export default function Cockpit() {
    useHeadAssets(); // inject Tailwind + fonts into <head> once
    const [drilldown, setDrilldown] = useState(null);
    const [isLoadingInventory, setIsLoadingInventory] = useState(false);
    const [subDrilldown, setSubDrilldown] = useState(null);
    const [isChatOpen, setIsChatOpen] = useState(false);
    const [activeView, setActiveView] = useState("dashboard");
    const [combinedData, setCombinedData] = useState({})
    const [storeManagerApproved, setStoreManagerApproved] = useState(true);
    const [financeManagerApproved, setFinanceManagerApproved] = useState(false);
    const [approvalMessages, setApprovalMessages] = useState([]);
    // Global download handler exposed to components
    const handleDownload = (filename, dataRows) => {
        // Use the 'xlsx' library to create a real Excel file
        const wsData = dataRows && dataRows.length > 0
            ? dataRows.map(row => {
                const mappedRow = {};
                Object.keys(row).forEach(key => {
                    // Clean up key names for Excel (e.g. remove underscores if desired, or keep as is)
                    mappedRow[key] = row[key];
                });
                return mappedRow;
            })
            : [{ Message: "No data available for report" }];

        const ws = XLSX.utils.json_to_sheet(wsData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Report");

        // Write file 
        XLSX.writeFile(wb, filename || "Report.xlsx");
    };
    const getAccInventory = async () => {
        // 1. Promise.all returns an array of results
        const responses = await Promise.all([
            getRequest("api/vr2/getAccInventory?filename=Output_gl_wise_movement_vs_trial_balance_reconciliation_15042026.xlsx"),
            getRequest("api/vr2/getAccInventory?filename=Derived_Output.xlsx"),
            getRequest("api/vr2/getAccInventory?filename=SlowNonMoving.xlsx"),
            getRequest("api/vr2/getAccInventory?filename=fixed_tb_vs_fa_mm_as_on_15_04_2026_OUTPUT.xlsx"),
            getRequest("api/vr2/getAccInventory?filename=Inventory value exception count_15042026.xlsx"),
            getRequest("api/vr2/getAccInventory?filename=Stock VS TB_as_on_15_04_20262.xlsx"),
            getRequest("api/vr2/getAccInventory?filename=grir_ageing_above_threshold_demo_OUTPUT.xlsx"),
            getRequest("api/vr2/getAccInventory?filename=asset_adjustment_entry.xlsx"),
            getRequest("api/vr2/getAccInventory?filename=CRM_FI_Revenue_Mismatch_output.xlsx"),
            getRequest("api/vr2/getAccInventory?filename=Deferred_Revenue_Blockers_output.xlsx"),
            getRequest("api/vr2/getAccInventory?filename=Service_Confirmation_Blockers_output.xlsx"),
            getRequest("api/vr2/getAccInventory?filename=Spare_Consumption_Blockers_output.xlsx"),
            getRequest("api/vr2/getAccInventory?filename=Retrofit_WIP_Blockers_output.xlsx"),
        ]);

        // 2. Combine the 'data' arrays from both responses into one
        const allData = responses
            .filter(r => r?.type === 'success')
            .flatMap(r => r?.res?.data || []);

        // 3. Process the merged data
        const combined = allData.reduce((acc, item) => {
            const key = item?.["Keyword"] || item?.["Final Classification"] || item?.["Final Classification"] || item?.["Material Description"] || item?.["Blocker Type"]
            if (key && key?.trim().toLowerCase() !== 'total') {
                if (!acc[key]) {
                    acc[key] = { title: key, total: 0, rows: [] };
                }
                const parseAmount = (val) => {
                    if (!val) return 0;
                    if (typeof val === 'number') return val;
                    return parseFloat(String(val).replace(/,/g, '')) || 0;
                };

                const value = parseAmount(item?.["Closing Stock Value-In Lakhs"]) || parseAmount(item?.["Financial Impact"]) || parseAmount(item?.["Opening Value Diff"]) || parseAmount(item?.["Closing Value Diff"]) || (parseAmount(item?.["Difference"]) / 100000);
                acc[key].total += value;
                acc[key].rows.push(item);
            }
            return acc;
        }, {});

        setCombinedData(combined); // Updates the cockpit state
        console.log("Final data:", combined);
    }

    useEffect(() => {
        getAccInventory();

        window.handleDownload = handleDownload;
    }, []);

    useEffect(() => {
        getAccInventory();

        window.handleDownload = handleDownload;
    }, []);

    const slowMovingData = {
        title: "Slow moving inventory",
        filename: "SlowNonMoving.xlsx",
        total: "34.74",
        rows: [
            { code: "BO-MOTOR-001", description: "Fan motor", uom: "NOS", value: "4.37" },
            { code: "BO-REMOTE-001", description: "Remote controller", uom: "NOS", value: "3.15" },
            { code: "BO-SENSOR-001", description: "Temperature sensor", uom: "NOS", value: "1.58" },
            { code: "FG-VOL-CR-001", description: "Voltas commercial visi cooler", uom: "NOS", value: "20.58" },
            { code: "FG-VOL-WC-001", description: "Voltas water cooler 120 ltr", uom: "NOS", value: "19.32" },
            { code: "PM-CARTON-001", description: "Printed corrugated box", uom: "NOS", value: "2.34" },
            { code: "PM-LABEL-001", description: "Product barcode label", uom: "NOS", value: "0.33" },
            { code: "PM-THERMO-001", description: "Thermocol eps packing", uom: "NOS", value: "2.40" },
            { code: "RM-COP-001", description: "Copper tube", uom: "MTR", value: "6.00" },
            { code: "RM-STEEL-001", description: "GI steel sheet", uom: "KG", value: "1.07" },
            { code: "RM-WIRE-001", description: "Copper wire", uom: "MTR", value: "2.10" },
            { code: "RM-PAINT-001", description: "Powder coating paint", uom: "KG", value: "1.25" },
            { code: "RM-GAS-001", description: "Refrigerant gas R134a", uom: "KG", value: "4.50" },
        ]
    };

    const nonMovingData = {
        title: "Non-moving / obsolete review",
        filename: "SlowNonMoving.xlsx",
        total: "16.36",
        rows: [
            { code: "RM-ALU-001", description: "Aluminium fin", uom: "KG", value: "2.555" },
            { code: "RM-FOAM-001", description: "Insulation foam", uom: "KG", value: "1.008" },
            { code: "RM-GLASS-001", description: "Toughened glass door", uom: "NOS", value: "3.15" },
            { code: "RM-PLASTIC-001", description: "ABS plastic granules", uom: "KG", value: "0.912" },
            { code: "SF-CAB-001", description: "AC outdoor unit cabinet", uom: "NOS", value: "1.71" },
            { code: "SF-COND-001", description: "Condenser coil assembly", uom: "NOS", value: "3.84" },
            { code: "SF-EVAP-001", description: "Evaporator coil assembly", uom: "NOS", value: "3.19" },
            { code: "OB-OLD-COMP-001", description: "Obsolete compressor model X", uom: "NOS", value: "5.42" },
            { code: "OB-PCB-V1", description: "Legacy control PCB V1.0", uom: "NOS", value: "2.15" },
        ]
    };

    const mmfiDifferenceData = {
        title: "Mm-fi difference value",
        filename: "TBvsMM.xlsx",
        total: 1.99,
        rows: [
            { code: "GL-INV-001", description: "Raw material stock account", uom: "VAL", value: "0.85" },
            { code: "GL-INV-002", description: "Semi-finished goods account", uom: "VAL", value: "0.42" },
            { code: "GL-INV-003", description: "Finished goods account", uom: "VAL", value: "0.72" },
        ]
    };

    const getCombinedItem = (key) => {
        if (!combinedData) return null;
        if (combinedData[key] && combinedData[key].rows && combinedData[key].rows.length > 0) return combinedData[key];
        console.log(combinedData, combinedData[key], key);

        // Case-insensitive lookup
        const lowerKey = key.toLowerCase();
        const foundKey = Object.keys(combinedData).find(k => k.toLowerCase() === lowerKey);
        if (foundKey && combinedData[foundKey] && combinedData[foundKey].rows && combinedData[foundKey].rows.length > 0) {
            console.log(foundKey, combinedData[foundKey]);
            return combinedData[foundKey];
        }

        // Try fallback to mock data if key contains "slow" or "non-moving"
        if (lowerKey.includes("slow")) {
            return {
                title: "Slow moving inventory",
                filename: "SlowNonMoving.xlsx",
                total: 63.228,
                rows: slowMovingData.rows
            };
        }
        if (lowerKey.includes("non") || lowerKey.includes("obsolete")) {
            return {
                title: "Non-moving / obsolete review",
                filename: "SlowNonMoving.xlsx",
                total: 16.36,
                rows: nonMovingData.rows
            };
        }
        return null;
    };

    const slowMovingObj = getCombinedItem('Slow Moving');
    const nonMovingObj = getCombinedItem('Non-Moving / Obsolete Review');

    const inventoryAccountingCombinedData = {
        title: "Full Reports of Inventory Accounting",
        filename: "SlowNonMoving.xlsx",
        total: `â‚¹${(
            (slowMovingObj?.total || 0) +
            (nonMovingObj?.total || 0) +
            1.99 + 28.01 + 22 / 100 // approximation or static sum
        ).toFixed(2)
            } L`,
        rows: [
            ...(slowMovingObj?.rows || []),
            ...(nonMovingObj?.rows || []),
            ...mmfiDifferenceData.rows
        ]
    };

    const fixedAssetCombinedData = {
        title: "Fixed asset accounting",
        filename: "FixedAssetAccounting.xlsx",
        total: `â‚¹ 75.85 L`,
        rows: [
            ...(getCombinedItem('Asset Addition Not Tagged')?.rows || []),
            ...(getCombinedItem('Depreciation Not Ready')?.rows || []),
            ...(getCombinedItem('Pending Capitalization')?.rows || []),
            ...(getCombinedItem('Retirement Pending')?.rows || []),
            ...(getCombinedItem('CWIP Ageing Above Threshold')?.rows || []),
        ]
    };

    const CRMServiceRevenueOperationsCombinedData = {
        title: "CRM Service & Revenue Operations",
        filename: "CRMServiceRevenueOperations.xlsx",
        total: `â‚¹${(2.50 + 1.85 + 0.18 + 0.10 + 0.10).toFixed(2)
            } L`,
        rows: [
            ...(getCombinedItem('CRM Billing vs FI Revenue Mismatch')?.rows || []),
            ...(getCombinedItem('Deferred Revenue Mismatch')?.rows || []),
            ...(getCombinedItem('Service Confirmation Pending')?.rows || []),
            ...(getCombinedItem('Spare Consumption Not Linked ')?.rows || []),
            ...(getCombinedItem('Retrofit WIP Not Settled')?.rows || []),
        ]
    };



    const inventoryDrilldownData = {
        title: "Inventory accounting",
        filename: "InventoryAccounting.xlsx",
        onViewDetailedReport: () => setSubDrilldown(inventoryAccountingCombinedData),
        rows: [
            { metric: "Opening Balance (Stock vs. TB)", value: "â‚¹-0.65 L", isError: false, hasDrill: true, onDrill: () => setSubDrilldown(getCombinedItem("Opening Balance (Stock vs. TB)")) },
            { metric: "Closing Balance (Stock vs. TB)", value: "â‚¹-0.15 L", isError: false, hasDrill: true, onDrill: () => setSubDrilldown(getCombinedItem("Closing Balance (Stock vs. TB)")) },
            { metric: "Non-moving / obsolete review", value: "â‚¹16.36 L", isError: false, hasDrill: true, onDrill: () => setSubDrilldown(nonMovingObj), rows: nonMovingObj?.rows },
            {
                metric: "Slow moving",
                value: "â‚¹34.74 L",
                isError: false,
                hasDrill: true,
                onDrill: () => setSubDrilldown(slowMovingObj),
                rows: slowMovingObj?.rows
            },
            { metric: "Inventory value exception count", value: combinedData?.['Inventory Value Exception Count']?.rows?.length, isError: false, hasDrill: true, onDrill: () => setSubDrilldown(getCombinedItem("Inventory Value Exception Count")), rows: combinedData?.['Inventory Value Exception Count']?.rows },
            { metric: "GR/IR ageing above threshold", value: "8", isError: false, hasDrill: true, onDrill: () => setSubDrilldown(getCombinedItem('GR/IR Ageing Above Threshold')), rows: combinedData?.['GR/IR Ageing Above Threshold']?.rows },
        ],
        footer: {
            label: "Total impact",
            value: `â‚¹${(
                22.15 + 0.65 + 16.36 + 34.74 // approximation or static sum
            ).toFixed(2)
                } L`,
            subText: `${(
                12 // static items
            )
                } items`
        }
    };

    const fixedAssetsDrilldownData = {
        title: "Fixed Assets",
        filename: "Fixed Assets.xlsx",
        onViewDetailedReport: () => setSubDrilldown(fixedAssetCombinedData),
        rows: [
            { metric: "Asset Addition Not Tagged", value: "â‚¹" + (combinedData?.['Asset Addition Not Tagged']?.total || 0).toFixed(2) + " L", isError: false, hasDrill: true, onDrill: () => setSubDrilldown(combinedData?.['Asset Addition Not Tagged']), rows: combinedData?.['Asset Addition Not Tagged']?.rows },
            { metric: "Depreciation Not Ready", value: "â‚¹" + (combinedData?.['Depreciation Not Ready']?.total || 0).toFixed(2) + " L", isError: false, hasDrill: true, onDrill: () => setSubDrilldown(combinedData?.['Depreciation Not Ready']), rows: combinedData?.['Depreciation Not Ready']?.rows },
            { metric: "Pending Capitalization", value: "â‚¹" + (combinedData?.['Pending Capitalization']?.total || 0).toFixed(2) + " L", isError: false, hasDrill: true, onDrill: () => setSubDrilldown(combinedData?.['Pending Capitalization']), rows: combinedData?.['Pending Capitalization']?.rows },
            { metric: "Retirement Pending", value: "â‚¹" + (combinedData?.['Retirement Pending']?.total || 0).toFixed(2) + " L", isError: false, hasDrill: true, onDrill: () => setSubDrilldown(combinedData?.['Retirement Pending']), rows: combinedData?.['Retirement Pending']?.rows },
            { metric: "Capitalisation issue", value: "â‚¹" + (combinedData?.['Capitalisation issue']?.total || 0).toFixed(2) + " L", isError: false, hasDrill: true, onDrill: () => setSubDrilldown(combinedData?.['Capitalisation issue']), rows: combinedData?.['Capitalisation issue']?.rows },
            { metric: "CWIP Ageing Above Threshold", value: "â‚¹" + (combinedData?.['CWIP Ageing Above Threshold']?.total || 0).toFixed(2) + " L", isError: false, hasDrill: true, onDrill: () => setSubDrilldown(combinedData?.['CWIP Ageing Above Threshold']), rows: combinedData?.['CWIP Ageing Above Threshold']?.rows },
        ],
        footer: {
            label: "Total impact",
            value: `â‚¹75.85 L`,
            subText: ``
        }
    };

    const CRMServiceRevenueOperationsDrilldownData = {
        title: "CRM Service & Revenue Operations",
        filename: "CRM Service & Revenue Operations.xlsx",
        onViewDetailedReport: () => setSubDrilldown(CRMServiceRevenueOperationsCombinedData),
        rows: [
            { metric: "CRM Billing vs FI Revenue Mismatch", value: "â‚¹2.50 L", isError: false, hasDrill: true, onDrill: () => { console.log(getCombinedItem('CRM Billing vs FI Revenue Mismatch')); setSubDrilldown(getCombinedItem('CRM Billing vs FI Revenue Mismatch')) }, rows: getCombinedItem('CRM Billing vs FI Revenue Mismatch')?.rows },
            { metric: "Deferred Revenue Mismatch", value: "â‚¹1.85 L", isError: false, hasDrill: true, onDrill: () => setSubDrilldown(getCombinedItem('Deferred Revenue Mismatch')), rows: getCombinedItem('Deferred Revenue Mismatch')?.rows },
            { metric: "Service Confirmation Pending", value: "â‚¹0.18 L", isError: false, hasDrill: true, onDrill: () => setSubDrilldown(getCombinedItem('Service Confirmation Pending')), rows: getCombinedItem('Service Confirmation Pending')?.rows },
            { metric: "Spare Consumption Not Linked ", value: "â‚¹0.10 L", isError: false, hasDrill: true, onDrill: () => setSubDrilldown(getCombinedItem('Spare Consumption Not Linked ')), rows: getCombinedItem('Spare Consumption Not Linked ')?.rows },
            { metric: "Retrofit WIP Not Settled", value: "â‚¹0.10 L", isError: false, hasDrill: true, onDrill: () => setSubDrilldown(getCombinedItem('Retrofit WIP Not Settled')), rows: getCombinedItem('Retrofit WIP Not Settled')?.rows },
        ],
        footer: {
            label: "Total impact",
            value: `â‚¹4.73 L`,
            subText: ``
        }
    };

    // â”€â”€ Generic JSON-driven status drilldown handler â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const handleStatusClick = (mainHeading, subHeading, statusType) => {
        const colourFilter = {
            "No Issue": ["Green"],
            "ModerateIssue": ["Amber", "Yellow", "Orange"],
            "Close Blocker": ["Red"]
        }[statusType] || [];

        const filtered = (filesDetails?.KPI || []).filter(kpi =>
            kpi["Main Heading"] === mainHeading &&
            (!subHeading || kpi["Sub Heading"] === subHeading) &&
            colourFilter.includes(kpi["Colour"])
        );

        console.log("filtered", filesDetails?.KPI?.filter((kpi) => kpi["Main Heading"] === "Core Finance" && kpi["Sub Heading"] === "Fixed Assets" && kpi.Colour === "Red")?.length);


        const displayTitle = subHeading || mainHeading;

        if (filtered.length === 0) {
            store.dispatch(showAlert(`No ${statusType.replace(/([A-Z])/g, " $1").trim()} items found for ${displayTitle}`, "info"));
            return;
        }

        const statusLabel = {
            "No Issue": "No issues",
            "ModerateIssue": "Moderate issue",
            "Close Blocker": "Close blocker"
        }[statusType] || statusType;

        const buildDetailRows = (items) => items.map(kpi => ({
            "Metric": kpi["Metric"] || "â€”",
            "Context ID": kpi["Context ID"] || "â€”",
            "Va Lue": kpi["Va Lue"] != null ? String(kpi["Va Lue"]) : "â€”",
            "Priority": kpi["Priority"] || "â€”",
            "Status Group": kpi["Colour"] || "â€”",
            "Category": kpi["Category"] || kpi["Sub Heading"] || kpi["Module"] || "â€”"
        }));

        const drillRows = filtered.map(kpi => {
            const currentSubHeading = kpi["Sub Heading"] || "";
            const isSpecial = currentSubHeading === "Fixed Assets" || currentSubHeading === "Inventory Accounting";
            return {
                metric: kpi["Metric"] || "â€”",
                value: kpi["Va Lue"] != null ? String(kpi["Va Lue"]) : "â€”",
                isError: kpi["Colour"] === "Red",
                hasDrill: isSpecial,
                onDrill: isSpecial ? () => setSubDrilldown({
                    title: kpi["Metric"] || kpi["Sub Heading"] || mainHeading,
                    total: 0,
                    rows: buildDetailRows([kpi])
                }) : undefined,
                rows: buildDetailRows([kpi])
            };
        });

        const isSpecialReport = subHeading === "Fixed Assets" || subHeading === "Inventory Accounting";

        setDrilldown({
            title: `${displayTitle} `,
            filename: `${displayTitle}_${statusType}.xlsx`,
            onViewDetailedReport: isSpecialReport ? () => setSubDrilldown({
                title: `${displayTitle} â€“ ${statusLabel} `,
                total: 0,
                rows: buildDetailRows(filtered)
            }) : undefined,
            rows: drillRows,
            footer: {
                label: `${statusLabel} total`,
                value: `${drillRows.length} metrics`,
                subText: ""
            }
        });
    };

    return (
        <Box sx={{ display: "flex", height: "100vh", overflow: "hidden", backgroundColor: "#f1f4f7" }}>
            <Sidebar activeView={activeView} onSelect={setActiveView} />
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    height: "100vh",
                    overflow: "hidden",
                    position: "relative",
                    ml: { xs: "72px", lg: "292px" }
                }}
            >
                {activeView === "dashboard" && (
                    <>
                        <TopHeader />
                        <KpiStrip />
                    </>
                )}

                <Box sx={{ flexGrow: 1, overflowY: "auto", px: 2, py: 2 }} className="custom-scrollbar">
                    {activeView === "dashboard" ? (
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6} lg={4}><Card1CoreFinance onDrilldown={() => setDrilldown(fixedAssetsDrilldownData)} onStatusClick={handleStatusClick} isLoadingInventory={isLoadingInventory} /></Grid>
                            <Grid item xs={12} md={6} lg={4}><Card2TransactionFinance onInventoryDrilldown={() => setDrilldown(inventoryDrilldownData)} onCRMDrilldown={() => setDrilldown(CRMServiceRevenueOperationsDrilldownData)} onStatusClick={handleStatusClick} /></Grid>
                            <Grid item xs={12} md={6} lg={4}><Card3IntercompanyFinance onStatusClick={handleStatusClick} /></Grid>
                            <Grid item xs={12} md={6} lg={4}><Card4GAClose onStatusClick={handleStatusClick} /></Grid>
                            <Grid item xs={12} md={6} lg={4}><Card5ReportingCompliance onStatusClick={handleStatusClick} /></Grid>
                            <Grid item xs={12} md={6} lg={4}><Card6FinancialPlanning onStatusClick={handleStatusClick} /></Grid>
                            <Grid item xs={12} md={6} lg={4}><Card7TaxCompliance onStatusClick={handleStatusClick} /></Grid>
                            <Grid item xs={12} md={6} lg={4}><Card8PlanningControl onStatusClick={handleStatusClick} /></Grid>
                            <Grid item xs={12} md={6} lg={4}><Card9IntelligenceRisk onStatusClick={handleStatusClick} /></Grid>
                        </Grid >
                    ) : activeView === "roles" ? (
                        <RolesResponsibilities />
                    ) : activeView === "core" ? (
                        <Box sx={{ height: "100%", width: "100%" }}><Card1CoreFinance onDrilldown={() => setDrilldown(fixedAssetsDrilldownData)} onStatusClick={handleStatusClick} isLoadingInventory={isLoadingInventory} /></Box>
                    ) : activeView === "transaction" ? (
                        <Box sx={{ height: "100%", width: "100%" }}><Card2TransactionFinance onInventoryDrilldown={() => setDrilldown(inventoryDrilldownData)} onCRMDrilldown={() => setDrilldown(CRMServiceRevenueOperationsDrilldownData)} onStatusClick={handleStatusClick} /></Box>
                    ) : activeView === "intercompany" ? (
                        <Box sx={{ height: "100%", width: "100%" }}><Card3IntercompanyFinance onStatusClick={handleStatusClick} /></Box>
                    ) : activeView === "ga" ? (
                        <Box sx={{ height: "100%", width: "100%" }}><Card4GAClose onStatusClick={handleStatusClick} /></Box>
                    ) : activeView === "reporting" ? (
                        <Box sx={{ height: "100%", width: "100%" }}><Card5ReportingCompliance onStatusClick={handleStatusClick} /></Box>
                    ) : activeView === "planning" ? (
                        <Box sx={{ height: "100%", width: "100%" }}><Card6FinancialPlanning onStatusClick={handleStatusClick} /></Box>
                    ) : activeView === "tax" ? (
                        <Box sx={{ height: "100%", width: "100%" }}><Card7TaxCompliance onStatusClick={handleStatusClick} /></Box>
                    ) : activeView === "control" ? (
                        <Box sx={{ height: "100%", width: "100%" }}><Card8PlanningControl onStatusClick={handleStatusClick} /></Box>
                    ) : activeView === "intelligence" ? (
                        <Box sx={{ height: "100%", width: "100%" }}><Card9IntelligenceRisk onStatusClick={handleStatusClick} /></Box>
                    ) : (
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", color: "#737685", fontStyle: "italic" }}>
                            <Typography>Content for {activeView} is coming soon...</Typography>
                        </Box>
                    )
                    }
                </Box >

                <DrilldownModal
                    isOpen={!!drilldown}
                    onClose={() => { setDrilldown(null); setSubDrilldown(null); }}
                    title={drilldown?.title}
                    data={drilldown}
                    onDownload={() => handleDownload(`${drilldown?.title} -FullReport.xlsx`, drilldown?.rows?.reduce((acc, item) => { if (item?.rows) return [...acc, ...item?.rows]; else return [...acc]; }, []))}
                />

                <DetailDrilldownModal
                    parentTitle={drilldown?.title}
                    isOpen={!!subDrilldown}
                    onClose={() => setSubDrilldown(null)}
                    title={subDrilldown?.title}
                    total={typeof subDrilldown?.total === "string" ? subDrilldown?.total : subDrilldown?.total?.toFixed(2)}
                    data={subDrilldown}
                    isChatOpen={isChatOpen}
                    onChatToggle={() => setIsChatOpen(!isChatOpen)}
                    onDownload={() => handleDownload(`${subDrilldown?.title} -FullReport.xlsx`, subDrilldown?.rows)}
                    storeManagerApproved={storeManagerApproved}
                    setStoreManagerApproved={setStoreManagerApproved}
                    financeManagerApproved={financeManagerApproved}
                    setFinanceManagerApproved={setFinanceManagerApproved}
                    approvalMessages={approvalMessages}
                    setApprovalMessages={setApprovalMessages}
                />
            </Box >
        </Box >
    );
}
